
export default [
  {
    "content": "# Apple FM 3B (On-Device)",
    "name": "Apple FM 3B (On-Device)",
    "release_date": new Date("2025-06-09T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 65000,
    "creator": {
      "name": "Apple",
      "url": "https://www.apple.com/",
      "logo_url": "/logos/apple.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": null,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "apple-3b.mdx",
      "fileName": "apple-3b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "apple-3b"
    },
    "title": "Apple FM 3B (On-Device)",
    "body": "var Component=(()=>{var p=Object.create;var r=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var l=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,d=Object.prototype.hasOwnProperty;var f=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),j=(n,e)=>{for(var t in e)r(n,t,{get:e[t],enumerable:!0})},a=(n,e,t,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let c of l(e))!d.call(n,c)&&c!==t&&r(n,c,{get:()=>e[c],enumerable:!(s=u(e,c))||s.enumerable});return n};var M=(n,e,t)=>(t=n!=null?p(_(n)):{},a(e||!n||!n.__esModule?r(t,\"default\",{value:n,enumerable:!0}):t,n)),D=n=>a(r({},\"__esModule\",{value:!0}),n);var x=f((v,i)=>{i.exports=_jsx_runtime});var C={};j(C,{default:()=>m});var o=M(x());function h(n){let e={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(e.h1,{children:[(0,o.jsx)(e.a,{href:\"/companies/apple\",children:\"Apple\"}),\" FM 3B (On-Device)\"]})}function m(n={}){let{wrapper:e}=n.components||{};return e?(0,o.jsx)(e,{...n,children:(0,o.jsx)(h,{...n})}):h(n)}return D(C);})();\n;return Component;",
    "slug": "apple-3b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Arctic Instruct",
    "name": "Arctic Instruct",
    "release_date": new Date("2024-04-24T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4000,
    "creator": {
      "name": "Snowflake",
      "url": "https://www.snowflake.com/",
      "logo_url": "/logos/snowflake.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 22,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "arctic-instruct.mdx",
      "fileName": "arctic-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "arctic-instruct"
    },
    "title": "Arctic Instruct",
    "body": "var Component=(()=>{var h=Object.create;var c=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),M=(t,n)=>{for(var e in n)c(t,e,{get:n[e],enumerable:!0})},u=(t,n,e,s)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!j.call(t,o)&&o!==e&&c(t,o,{get:()=>n[o],enumerable:!(s=_(n,o))||s.enumerable});return t};var p=(t,n,e)=>(e=t!=null?h(f(t)):{},u(n||!t||!t.__esModule?c(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>u(c({},\"__esModule\",{value:!0}),t);var m=l((w,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var r=p(m());function x(t){let n={h1:\"h1\",...t.components};return(0,r.jsx)(n.h1,{children:\"Arctic Instruct\"})}function a(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "arctic-instruct",
    "readingTime": "1 min read"
  },
  {
    "content": "# Aya Expanse 32B",
    "name": "Aya Expanse 32B",
    "release_date": new Date("2024-10-24T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 20.05,
      "math_index": 22.43,
      "coding_index": 14.29,
      "benchmarks": {
        "mmlu_pro": 0.377,
        "gpqa": 0.23,
        "hle": 0.045,
        "scicode": 0.149,
        "aime": 0,
        "math_500": 0.449,
        "livecodebench": 0.137,
        "humaneval": 0.683
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.5,
        "output": 1.5,
        "blended_3_to_1": 0.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 122.14,
      "time_to_first_token_ms": 0.18,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.27,
        "input_time_seconds": 0.18,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.09
      }
    },
    "_meta": {
      "filePath": "aya-expanse-32b.mdx",
      "fileName": "aya-expanse-32b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "aya-expanse-32b"
    },
    "title": "Aya Expanse 32B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),y=n=>a(r({},\"__esModule\",{value:!0}),n);var x=l((X,u)=>{u.exports=_jsx_runtime});var C={};p(C,{default:()=>m});var c=M(x());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Aya Expanse 32B\"})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return y(C);})();\n;return Component;",
    "slug": "aya-expanse-32b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Aya Expanse 8B",
    "name": "Aya Expanse 8B",
    "release_date": new Date("2024-10-24T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 16.03,
      "math_index": 16.03,
      "coding_index": 7.4,
      "benchmarks": {
        "mmlu_pro": 0.312,
        "gpqa": 0.247,
        "hle": 0.051,
        "scicode": 0.078,
        "aime": 0,
        "math_500": 0.321,
        "livecodebench": 0.07,
        "humaneval": 0.444
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.5,
        "output": 1.5,
        "blended_3_to_1": 0.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 167.69,
      "time_to_first_token_ms": 0.14,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.12,
        "input_time_seconds": 0.14,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.98
      }
    },
    "_meta": {
      "filePath": "aya-expanse-8b.mdx",
      "fileName": "aya-expanse-8b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "aya-expanse-8b"
    },
    "title": "Aya Expanse 8B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),y=n=>a(r({},\"__esModule\",{value:!0}),n);var x=l((X,u)=>{u.exports=_jsx_runtime});var C={};p(C,{default:()=>m});var c=M(x());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Aya Expanse 8B\"})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return y(C);})();\n;return Component;",
    "slug": "aya-expanse-8b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Claude 2.0",
    "release_date": new Date("2023-07-11T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 100000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 23,
      "math_index": null,
      "coding_index": 18.29,
      "benchmarks": {
        "mmlu_pro": 0.486,
        "gpqa": 0.344,
        "hle": null,
        "scicode": 0.194,
        "aime": 0,
        "math_500": null,
        "livecodebench": 0.171,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 8,
        "output": 24,
        "blended_3_to_1": 12
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 31.04,
      "time_to_first_token_ms": 1.1,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 17.2,
        "input_time_seconds": 1.1,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 16.11
      }
    },
    "_meta": {
      "filePath": "claude-2.mdx",
      "fileName": "claude-2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-2"
    },
    "title": "Claude 2.0",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-2",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Claude 2.1",
    "release_date": new Date("2023-11-21T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 24.1,
      "math_index": 20.37,
      "coding_index": 18.94,
      "benchmarks": {
        "mmlu_pro": 0.495,
        "gpqa": 0.319,
        "hle": 0.042,
        "scicode": 0.184,
        "aime": 0.033,
        "math_500": 0.374,
        "livecodebench": 0.195,
        "humaneval": 0.159
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 8,
        "output": 24,
        "blended_3_to_1": 12
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 13.96,
      "time_to_first_token_ms": 1.14,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 36.94,
        "input_time_seconds": 1.14,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 35.81
      }
    },
    "_meta": {
      "filePath": "claude-21.mdx",
      "fileName": "claude-21.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-21"
    },
    "title": "Claude 2.1",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-21",
    "readingTime": "0 min read"
  },
  {
    "content": "# Claude 3.5 Haiku",
    "name": "Claude 3.5 Haiku",
    "release_date": new Date("2024-10-22T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 34.74,
      "math_index": 37.7,
      "coding_index": 29.43,
      "benchmarks": {
        "mmlu_pro": 0.634,
        "gpqa": 0.408,
        "hle": 0.035,
        "scicode": 0.274,
        "aime": 0.033,
        "math_500": 0.721,
        "livecodebench": 0.314,
        "humaneval": 0.859
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.8,
        "output": 4,
        "blended_3_to_1": 1.6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 64.17,
      "time_to_first_token_ms": 1.16,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.95,
        "input_time_seconds": 1.16,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.79
      }
    },
    "aider": {
      "correct": 28,
      "cost": 6.06,
      "price_per_input_token": 0.000001,
      "correct_edit_format": 91.1
    },
    "_meta": {
      "filePath": "claude-3-5-haiku.mdx",
      "fileName": "claude-3-5-haiku.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-3-5-haiku"
    },
    "title": "Claude 3.5 Haiku",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)o(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let a of m(t))!f.call(n,a)&&a!==e&&o(n,a,{get:()=>t[a],enumerable:!(r=l(t,a))||r.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(_(n)):{},c(t||!n||!n.__esModule?o(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>c(o({},\"__esModule\",{value:!0}),n);var i=j((k,u)=>{u.exports=_jsx_runtime});var D={};C(D,{default:()=>d});var s=M(i());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\" 3.5 Haiku\"]})}function d(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return p(D);})();\n;return Component;",
    "slug": "claude-3-5-haiku",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Claude 3.7 Sonnet (Extended Thinking)",
    "release_date": new Date("2025-02-24T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 57.39,
      "math_index": 71.67,
      "coding_index": 43.79,
      "benchmarks": {
        "mmlu_pro": 0.837,
        "gpqa": 0.772,
        "hle": 0.103,
        "scicode": 0.403,
        "aime": 0.487,
        "math_500": 0.947,
        "livecodebench": 0.473,
        "humaneval": 0.978
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 87.97,
      "time_to_first_token_ms": 1.06,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 19.3,
        "input_time_seconds": 1.06,
        "reasoning_time_seconds": 12.56,
        "answer_time_seconds": 5.68
      }
    },
    "_meta": {
      "filePath": "claude-3-7-sonnet-thinking.mdx",
      "fileName": "claude-3-7-sonnet-thinking.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-3-7-sonnet-thinking"
    },
    "title": "Claude 3.7 Sonnet (Extended Thinking)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-3-7-sonnet-thinking",
    "readingTime": "0 min read"
  },
  {
    "content": "# Claude 3.7 Sonnet (Extended Thinking)",
    "name": "Claude 3.7 Sonnet (Standard)",
    "release_date": new Date("2025-02-24T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 48.15,
      "math_index": 53.67,
      "coding_index": 38.49,
      "benchmarks": {
        "mmlu_pro": 0.803,
        "gpqa": 0.656,
        "hle": 0.048,
        "scicode": 0.376,
        "aime": 0.223,
        "math_500": 0.85,
        "livecodebench": 0.394,
        "humaneval": 0.949
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 78.08,
      "time_to_first_token_ms": 1.05,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.45,
        "input_time_seconds": 1.05,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.4
      }
    },
    "aider": {
      "correct": 60.4,
      "cost": 17.72,
      "price_per_input_token": null,
      "correct_edit_format": 93.3
    },
    "_meta": {
      "filePath": "claude-3-7-sonnet.mdx",
      "fileName": "claude-3-7-sonnet.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-3-7-sonnet"
    },
    "title": "Claude 3.7 Sonnet (Standard)",
    "body": "var Component=(()=>{var h=Object.create;var a=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)a(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of m(t))!f.call(n,o)&&o!==e&&a(n,o,{get:()=>t[o],enumerable:!(r=l(t,o))||r.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(_(n)):{},c(t||!n||!n.__esModule?a(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>c(a({},\"__esModule\",{value:!0}),n);var d=j((g,i)=>{i.exports=_jsx_runtime});var D={};C(D,{default:()=>x});var s=M(d());function u(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\" 3.7 Sonnet (Extended Thinking)\"]})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(u,{...n})}):u(n)}return p(D);})();\n;return Component;",
    "slug": "claude-3-7-sonnet",
    "readingTime": "1 min read"
  },
  {
    "content": "# Claude 3 Haiku",
    "name": "Claude 3 Haiku",
    "release_date": new Date("2024-03-04T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 24,
      "math_index": 20.2,
      "coding_index": 17.04,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": 0.186,
        "aime": 0.01,
        "math_500": 0.394,
        "livecodebench": 0.154,
        "humaneval": 0.757
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.25,
        "output": 1.25,
        "blended_3_to_1": 0.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 138.2,
      "time_to_first_token_ms": 0.65,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.26,
        "input_time_seconds": 0.65,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.62
      }
    },
    "_meta": {
      "filePath": "claude-3-haiku.mdx",
      "fileName": "claude-3-haiku.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-3-haiku"
    },
    "title": "Claude 3 Haiku",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)o(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let a of m(t))!f.call(n,a)&&a!==e&&o(n,a,{get:()=>t[a],enumerable:!(r=l(t,a))||r.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(_(n)):{},c(t||!n||!n.__esModule?o(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>c(o({},\"__esModule\",{value:!0}),n);var i=j((k,u)=>{u.exports=_jsx_runtime});var D={};C(D,{default:()=>d});var s=M(i());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\" 3 Haiku\"]})}function d(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return p(D);})();\n;return Component;",
    "slug": "claude-3-haiku",
    "readingTime": "1 min read"
  },
  {
    "content": "# Claude 3 Opus",
    "name": "Claude 3 Opus",
    "release_date": new Date("2024-03-04T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.09,
      "math_index": 33.7,
      "coding_index": 25.6,
      "benchmarks": {
        "mmlu_pro": 0.696,
        "gpqa": 0.489,
        "hle": 0.031,
        "scicode": 0.233,
        "aime": 0.033,
        "math_500": 0.641,
        "livecodebench": 0.279,
        "humaneval": 0.848
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 15,
        "output": 75,
        "blended_3_to_1": 30
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 27.87,
      "time_to_first_token_ms": 1.18,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 19.12,
        "input_time_seconds": 1.18,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 17.94
      }
    },
    "_meta": {
      "filePath": "claude-3-opus.mdx",
      "fileName": "claude-3-opus.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-3-opus"
    },
    "title": "Claude 3 Opus",
    "body": "var Component=(()=>{var h=Object.create;var a=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)a(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of m(t))!f.call(n,o)&&o!==e&&a(n,o,{get:()=>t[o],enumerable:!(r=l(t,o))||r.enumerable});return n};var C=(n,t,e)=>(e=n!=null?h(_(n)):{},c(t||!n||!n.__esModule?a(e,\"default\",{value:n,enumerable:!0}):e,n)),M=n=>c(a({},\"__esModule\",{value:!0}),n);var i=j((w,u)=>{u.exports=_jsx_runtime});var D={};p(D,{default:()=>d});var s=C(i());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\" 3 Opus\"]})}function d(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return M(D);})();\n;return Component;",
    "slug": "claude-3-opus",
    "readingTime": "1 min read"
  },
  {
    "content": "# Claude 3 Sonnet",
    "name": "Claude 3 Sonnet",
    "release_date": new Date("2024-03-04T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 27.77,
      "math_index": 23.03,
      "coding_index": 20.19,
      "benchmarks": {
        "mmlu_pro": 0.579,
        "gpqa": 0.4,
        "hle": 0.038,
        "scicode": 0.229,
        "aime": 0.047,
        "math_500": 0.414,
        "livecodebench": 0.175,
        "humaneval": 0.713
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 60.07,
      "time_to_first_token_ms": 1.27,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.59,
        "input_time_seconds": 1.27,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 8.32
      }
    },
    "_meta": {
      "filePath": "claude-3-sonnet.mdx",
      "fileName": "claude-3-sonnet.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-3-sonnet"
    },
    "title": "Claude 3 Sonnet",
    "body": "var Component=(()=>{var h=Object.create;var a=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)a(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of m(t))!f.call(n,o)&&o!==e&&a(n,o,{get:()=>t[o],enumerable:!(r=l(t,o))||r.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(_(n)):{},c(t||!n||!n.__esModule?a(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>c(a({},\"__esModule\",{value:!0}),n);var i=j((w,u)=>{u.exports=_jsx_runtime});var D={};C(D,{default:()=>d});var s=M(i());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\" 3 Sonnet\"]})}function d(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return p(D);})();\n;return Component;",
    "slug": "claude-3-sonnet",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Claude 3.5 Sonnet (June '24)",
    "release_date": new Date("2024-06-21T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40,
      "math_index": 39.6,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.751,
        "gpqa": 0.56,
        "hle": 0.037,
        "scicode": 0.316,
        "aime": 0.097,
        "math_500": 0.695,
        "livecodebench": null,
        "humaneval": 0.899
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 79.13,
      "time_to_first_token_ms": 1.37,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.69,
        "input_time_seconds": 1.37,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.32
      }
    },
    "_meta": {
      "filePath": "claude-35-sonnet-june-24.mdx",
      "fileName": "claude-35-sonnet-june-24.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-35-sonnet-june-24"
    },
    "title": "Claude 3.5 Sonnet (June '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-35-sonnet-june-24",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Claude 3.5 Sonnet (Oct '24)",
    "release_date": new Date("2024-10-22T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 44.44,
      "math_index": 46.4,
      "coding_index": 37.33,
      "benchmarks": {
        "mmlu_pro": 0.772,
        "gpqa": 0.599,
        "hle": 0.039,
        "scicode": 0.366,
        "aime": 0.157,
        "math_500": 0.771,
        "livecodebench": 0.381,
        "humaneval": 0.93
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 78.42,
      "time_to_first_token_ms": 1.84,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.21,
        "input_time_seconds": 1.84,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.38
      }
    },
    "aider": {
      "correct": 51.6,
      "cost": 14.41,
      "price_per_input_token": 0.000003,
      "correct_edit_format": 99.6
    },
    "_meta": {
      "filePath": "claude-35-sonnet.mdx",
      "fileName": "claude-35-sonnet.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-35-sonnet"
    },
    "title": "Claude 3.5 Sonnet (Oct '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-35-sonnet",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Claude 4 Opus (Extended Thinking)",
    "release_date": new Date("2025-05-22T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 64.43,
      "math_index": 86.93,
      "coding_index": 51.71,
      "benchmarks": {
        "mmlu_pro": 0.873,
        "gpqa": 0.796,
        "hle": 0.117,
        "scicode": 0.398,
        "aime": 0.757,
        "math_500": 0.982,
        "livecodebench": 0.636,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 15,
        "output": 75,
        "blended_3_to_1": 30
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 55.56,
      "time_to_first_token_ms": 2.85,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 47.85,
        "input_time_seconds": 2.85,
        "reasoning_time_seconds": 36,
        "answer_time_seconds": 9
      }
    },
    "_meta": {
      "filePath": "claude-4-opus-thinking.mdx",
      "fileName": "claude-4-opus-thinking.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-4-opus-thinking"
    },
    "title": "Claude 4 Opus (Extended Thinking)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-4-opus-thinking",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Claude 4 Opus",
    "release_date": new Date("2025-05-22T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 57.68,
      "math_index": 75.2,
      "coding_index": 47.52,
      "benchmarks": {
        "mmlu_pro": 0.86,
        "gpqa": 0.701,
        "hle": 0.059,
        "scicode": 0.409,
        "aime": 0.563,
        "math_500": 0.941,
        "livecodebench": 0.542,
        "humaneval": 0.97
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 15,
        "output": 75,
        "blended_3_to_1": 30
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 54.02,
      "time_to_first_token_ms": 2.5,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.76,
        "input_time_seconds": 2.5,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.26
      }
    },
    "aider": {
      "correct": 70.7,
      "cost": 68.63,
      "price_per_input_token": 0.000015,
      "correct_edit_format": 98.7
    },
    "_meta": {
      "filePath": "claude-4-opus.mdx",
      "fileName": "claude-4-opus.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-4-opus"
    },
    "title": "Claude 4 Opus",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-4-opus",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Claude 4 Sonnet",
    "release_date": new Date("2025-05-22T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 53.01,
      "math_index": 67.03,
      "coding_index": 41.07,
      "benchmarks": {
        "mmlu_pro": 0.837,
        "gpqa": 0.683,
        "hle": 0.04,
        "scicode": 0.373,
        "aime": 0.407,
        "math_500": 0.934,
        "livecodebench": 0.449,
        "humaneval": 0.973
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 49.06,
      "time_to_first_token_ms": 1.56,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.75,
        "input_time_seconds": 1.56,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 10.19
      }
    },
    "aider": {
      "correct": 56.4,
      "cost": 15.82,
      "price_per_input_token": 0.000003,
      "correct_edit_format": 98.2
    },
    "_meta": {
      "filePath": "claude-4-sonnet.mdx",
      "fileName": "claude-4-sonnet.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-4-sonnet"
    },
    "title": "Claude 4 Sonnet",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "claude-4-sonnet",
    "readingTime": "0 min read"
  },
  {
    "content": "# Claude Instant",
    "name": "Claude Instant 1.2",
    "release_date": new Date("2023-08-09T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 100000,
    "creator": {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "logo_url": "/logos/anthropic.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 14,
      "math_index": 13.2,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.434,
        "gpqa": 0.33,
        "hle": 0.038,
        "scicode": null,
        "aime": 0,
        "math_500": 0.264,
        "livecodebench": 0.109,
        "humaneval": 0.018
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.8,
        "output": 2.4,
        "blended_3_to_1": 1.2
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 62.89,
      "time_to_first_token_ms": 0.58,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.53,
        "input_time_seconds": 0.58,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.95
      }
    },
    "_meta": {
      "filePath": "claude-instant.mdx",
      "fileName": "claude-instant.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude-instant"
    },
    "title": "Claude Instant 1.2",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)o(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let a of m(t))!f.call(n,a)&&a!==e&&o(n,a,{get:()=>t[a],enumerable:!(r=l(t,a))||r.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(_(n)):{},c(t||!n||!n.__esModule?o(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>c(o({},\"__esModule\",{value:!0}),n);var i=j((w,u)=>{u.exports=_jsx_runtime});var D={};C(D,{default:()=>d});var s=M(i());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\" Instant\"]})}function d(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return p(D);})();\n;return Component;",
    "slug": "claude-instant",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Codestral (May '24)",
    "release_date": new Date("2024-05-29T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 20.42,
      "math_index": 17.7,
      "coding_index": 21.51,
      "benchmarks": {
        "mmlu_pro": 0.331,
        "gpqa": 0.255,
        "hle": 0.051,
        "scicode": 0.218,
        "aime": 0,
        "math_500": 0.354,
        "livecodebench": 0.213,
        "humaneval": 0.802
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.6,
        "blended_3_to_1": 0.3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 159.14,
      "time_to_first_token_ms": 0.29,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.43,
        "input_time_seconds": 0.29,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.14
      }
    },
    "_meta": {
      "filePath": "codestral-2405.mdx",
      "fileName": "codestral-2405.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "codestral-2405"
    },
    "title": "Codestral (May '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "codestral-2405",
    "readingTime": "0 min read"
  },
  {
    "content": "# Codestral-Mamba",
    "name": "Codestral-Mamba",
    "release_date": new Date("2024-07-16T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 13.9,
      "math_index": 12,
      "coding_index": 12.05,
      "benchmarks": {
        "mmlu_pro": 0.209,
        "gpqa": 0.21,
        "hle": 0.054,
        "scicode": 0.108,
        "aime": 0,
        "math_500": 0.24,
        "livecodebench": 0.133,
        "humaneval": 0.799
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.25,
        "output": 0.25,
        "blended_3_to_1": 0.25
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "codestral-mamba.mdx",
      "fileName": "codestral-mamba.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "codestral-mamba"
    },
    "title": "Codestral-Mamba",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=h(t,o))||a.enumerable});return n};var C=(n,t,e)=>(e=n!=null?d(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>s(r({},\"__esModule\",{value:!0}),n);var u=M((b,m)=>{m.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=C(u());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Codestral-Mamba\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return p(D);})();\n;return Component;",
    "slug": "codestral-mamba",
    "readingTime": "1 min read"
  },
  {
    "content": "# Codestral (Jan '25)",
    "name": "Codestral (Jan '25)",
    "release_date": new Date("2025-01-13T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 256000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 27.64,
      "math_index": 32.5,
      "coding_index": 24.5,
      "benchmarks": {
        "mmlu_pro": 0.446,
        "gpqa": 0.312,
        "hle": 0.045,
        "scicode": 0.247,
        "aime": 0.043,
        "math_500": 0.607,
        "livecodebench": 0.243,
        "humaneval": 0.848
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.3,
        "output": 0.9,
        "blended_3_to_1": 0.45
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 169.43,
      "time_to_first_token_ms": 0.28,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.23,
        "input_time_seconds": 0.28,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.95
      }
    },
    "aider": {
      "correct": 11.1,
      "cost": 1.98,
      "price_per_input_token": null,
      "correct_edit_format": 100
    },
    "_meta": {
      "filePath": "codestral.mdx",
      "fileName": "codestral.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "codestral"
    },
    "title": "Codestral (Jan '25)",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=h(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?d(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>a(r({},\"__esModule\",{value:!0}),n);var i=j((w,u)=>{u.exports=_jsx_runtime});var D={};C(D,{default:()=>x});var c=M(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Codestral (Jan '25)\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return p(D);})();\n;return Component;",
    "slug": "codestral",
    "readingTime": "1 min read"
  },
  {
    "content": "# Command A",
    "name": "Command A",
    "release_date": new Date("2025-03-13T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 39.95,
      "math_index": 45.77,
      "coding_index": 28.4,
      "benchmarks": {
        "mmlu_pro": 0.712,
        "gpqa": 0.527,
        "hle": 0.046,
        "scicode": 0.281,
        "aime": 0.097,
        "math_500": 0.819,
        "livecodebench": 0.287,
        "humaneval": 0.815
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2.5,
        "output": 10,
        "blended_3_to_1": 4.375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 155.31,
      "time_to_first_token_ms": 0.22,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.43,
        "input_time_seconds": 0.22,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.22
      }
    },
    "_meta": {
      "filePath": "command-a.mdx",
      "fileName": "command-a.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "command-a"
    },
    "title": "Command A",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,m)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(m=h(t,o))||m.enumerable});return n};var M=(n,t,e)=>(e=n!=null?d(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>s(r({},\"__esModule\",{value:!0}),n);var a=l((w,u)=>{u.exports=_jsx_runtime});var D={};C(D,{default:()=>x});var c=M(a());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Command A\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return p(D);})();\n;return Component;",
    "slug": "command-a",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Command-R (Mar '24)",
    "release_date": new Date("2024-03-12T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 14.68,
      "math_index": 8.53,
      "coding_index": 5.51,
      "benchmarks": {
        "mmlu_pro": 0.338,
        "gpqa": 0.284,
        "hle": 0.048,
        "scicode": 0.062,
        "aime": 0.007,
        "math_500": 0.164,
        "livecodebench": 0.048,
        "humaneval": 0.4
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.5,
        "output": 1.5,
        "blended_3_to_1": 0.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 156.11,
      "time_to_first_token_ms": 0.15,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.36,
        "input_time_seconds": 0.15,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.2
      }
    },
    "_meta": {
      "filePath": "command-r-03-2024.mdx",
      "fileName": "command-r-03-2024.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "command-r-03-2024"
    },
    "title": "Command-R (Mar '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "command-r-03-2024",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Command-R+ (Apr '24)",
    "release_date": new Date("2024-04-04T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.9,
      "math_index": 14.27,
      "coding_index": 11.99,
      "benchmarks": {
        "mmlu_pro": 0.432,
        "gpqa": 0.323,
        "hle": 0.045,
        "scicode": 0.118,
        "aime": 0.007,
        "math_500": 0.279,
        "livecodebench": 0.122,
        "humaneval": 0.637
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 59.28,
      "time_to_first_token_ms": 0.27,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.7,
        "input_time_seconds": 0.27,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 8.43
      }
    },
    "_meta": {
      "filePath": "command-r-plus-04-2024.mdx",
      "fileName": "command-r-plus-04-2024.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "command-r-plus-04-2024"
    },
    "title": "Command-R+ (Apr '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "command-r-plus-04-2024",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Command-R+ (Aug '24)",
    "release_date": new Date("2024-08-30T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 21.49,
      "math_index": 20.1,
      "coding_index": 11.63,
      "benchmarks": {
        "mmlu_pro": 0.427,
        "gpqa": 0.337,
        "hle": 0.05,
        "scicode": 0.122,
        "aime": 0,
        "math_500": 0.402,
        "livecodebench": 0.111,
        "humaneval": 0.63
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2.5,
        "output": 10,
        "blended_3_to_1": 4.375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 48.03,
      "time_to_first_token_ms": 0.26,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 10.67,
        "input_time_seconds": 0.26,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 10.41
      }
    },
    "_meta": {
      "filePath": "command-r-plus.mdx",
      "fileName": "command-r-plus.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "command-r-plus"
    },
    "title": "Command-R+ (Aug '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "command-r-plus",
    "readingTime": "0 min read"
  },
  {
    "content": "# Command-R+ (Aug '24)",
    "name": "Command-R (Aug '24)",
    "release_date": new Date("2024-08-30T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Cohere",
      "url": "https://cohere.com/",
      "logo_url": "/logos/cohere.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 14.83,
      "math_index": 7.63,
      "coding_index": 6.56,
      "benchmarks": {
        "mmlu_pro": 0.337,
        "gpqa": 0.289,
        "hle": 0.051,
        "scicode": 0.087,
        "aime": 0.003,
        "math_500": 0.149,
        "livecodebench": 0.044,
        "humaneval": 0.415
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.6,
        "blended_3_to_1": 0.2625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 68.88,
      "time_to_first_token_ms": 0.2,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.46,
        "input_time_seconds": 0.2,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.26
      }
    },
    "_meta": {
      "filePath": "command-r.mdx",
      "fileName": "command-r.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "command-r"
    },
    "title": "Command-R (Aug '24)",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,m)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(m=h(t,o))||m.enumerable});return n};var M=(n,t,e)=>(e=n!=null?d(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>u(r({},\"__esModule\",{value:!0}),n);var a=l((g,s)=>{s.exports=_jsx_runtime});var D={};C(D,{default:()=>x});var c=M(a());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Command-R+ (Aug '24)\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return p(D);})();\n;return Component;",
    "slug": "command-r",
    "readingTime": "1 min read"
  },
  {
    "content": "# text-davinci-001\n\nA GPT-3 model from OpenAI released in 2021 with a 2k token window and priced at $20 per million tokens.[^1]\n\n[^1]: Release details from [HN API](https://hn.algolia.com/api/v1/search?query=text-davinci-003) and pricing from [OpenAI deprecations](https://platform.openai.com/docs/deprecations).\n\n## References\n\n1. [New GPT-3 model: text-DaVinci-003](https://beta.openai.com/docs/models/overview)\n2. [GPT (text-DaVinci-003) can run hallucinated scripts](https://twitter.com/jamesjyu/status/1600959843669377025)\n3. [Alpaca-LoRA fine-tuning example](https://github.com/tloen/alpaca-lora)\n4. [Terminal-copilot wrapper](https://github.com/Methexis-Inc/terminal-copilot)\n5. [Chat vs Completions](https://platform.openai.com/docs/guides/chat/chat-vs-completions)\n6. [Mixtral replacement advice](https://jamez.it/blog/2024/01/04/replace-a-fine-tuned-text-davinci-003-with-mixtral-8x7b/)",
    "name": "davinci-002",
    "release_date": new Date("2021-01-27T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 4097,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 6,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 39.7,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 20,
        "output": 20,
        "blended_3_to_1": 20
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 0,
      "time_to_first_token_ms": 0,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 0,
        "input_time_seconds": 0,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 0
      }
    },
    "_meta": {
      "filePath": "davinci-002.mdx",
      "fileName": "davinci-002.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "davinci-002"
    },
    "title": "davinci-002",
    "body": "var Component=(()=>{var p=Object.create;var r=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var u=Object.getPrototypeOf,x=Object.prototype.hasOwnProperty;var b=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),v=(t,e)=>{for(var i in e)r(t,i,{get:e[i],enumerable:!0})},c=(t,e,i,o)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of m(e))!x.call(t,a)&&a!==i&&r(t,a,{get:()=>e[a],enumerable:!(o=f(e,a))||o.enumerable});return t};var g=(t,e,i)=>(i=t!=null?p(u(t)):{},c(e||!t||!t.__esModule?r(i,\"default\",{value:t,enumerable:!0}):i,t)),w=t=>c(r({},\"__esModule\",{value:!0}),t);var h=b((k,l)=>{l.exports=_jsx_runtime});var j={};v(j,{default:()=>d});var n=g(h());function s(t){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:(0,n.jsx)(e.a,{href:\"/models/text-davinci-001\",children:\"text-davinci-001\"})}),`\n`,(0,n.jsxs)(e.p,{children:[\"A GPT-3 model from \",(0,n.jsx)(e.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\" released in 2021 with a 2k token window and priced at $20 per million tokens.\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})})]}),`\n`,(0,n.jsx)(e.h2,{children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://beta.openai.com/docs/models/overview\",children:\"New GPT-3 model: text-DaVinci-003\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://twitter.com/jamesjyu/status/1600959843669377025\",children:\"GPT (text-DaVinci-003) can run hallucinated scripts\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://github.com/tloen/alpaca-lora\",children:\"Alpaca-LoRA fine-tuning example\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://github.com/Methexis-Inc/terminal-copilot\",children:\"Terminal-copilot wrapper\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://platform.openai.com/docs/guides/chat/chat-vs-completions\",children:\"Chat vs Completions\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://jamez.it/blog/2024/01/04/replace-a-fine-tuned-text-davinci-003-with-mixtral-8x7b/\",children:\"Mixtral replacement advice\"})}),`\n`]}),`\n`,(0,n.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,n.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,n.jsxs)(e.p,{children:[\"Release details from \",(0,n.jsx)(e.a,{href:\"https://hn.algolia.com/api/v1/search?query=text-davinci-003\",children:\"HN API\"}),\" and pricing from \",(0,n.jsx)(e.a,{href:\"https://platform.openai.com/docs/deprecations\",children:\"OpenAI deprecations\"}),\". \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function d(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(s,{...t})}):s(t)}return w(j);})();\n;return Component;",
    "slug": "davinci-002",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "DBRX Instruct",
    "release_date": new Date("2024-03-27T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Databricks",
      "url": "https://www.databricks.com/product/machine-learning",
      "logo_url": "/logos/databricks.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.75,
      "math_index": 15.47,
      "coding_index": 10.56,
      "benchmarks": {
        "mmlu_pro": 0.397,
        "gpqa": 0.331,
        "hle": 0.066,
        "scicode": 0.118,
        "aime": 0.03,
        "math_500": 0.279,
        "livecodebench": 0.093,
        "humaneval": 0.668
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "dbrx.mdx",
      "fileName": "dbrx.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "dbrx"
    },
    "title": "DBRX Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "dbrx",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "DeepSeek Coder V2 Lite Instruct",
    "release_date": new Date("2024-06-17T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 20.489999771118164,
      "math_index": null,
      "coding_index": 14.83,
      "benchmarks": {
        "mmlu_pro": 0.429,
        "gpqa": 0.319,
        "hle": 0.053,
        "scicode": 0.139,
        "aime": null,
        "math_500": null,
        "livecodebench": 0.158,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-coder-v2-lite.mdx",
      "fileName": "deepseek-coder-v2-lite.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-coder-v2-lite"
    },
    "title": "DeepSeek Coder V2 Lite Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "deepseek-coder-v2-lite",
    "readingTime": "0 min read"
  },
  {
    "content": "# DeepSeek-Coder-V2",
    "name": "DeepSeek-Coder-V2",
    "release_date": new Date("2024-06-17T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 29,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.743,
        "livecodebench": null,
        "humaneval": 0.866
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.14,
        "output": 0.28,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-coder-v2.mdx",
      "fileName": "deepseek-coder-v2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-coder-v2"
    },
    "title": "DeepSeek-Coder-V2",
    "body": "var Component=(()=>{var m=Object.create;var s=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),l=(e,n)=>{for(var t in n)s(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let r of _(n))!j.call(e,r)&&r!==t&&s(e,r,{get:()=>n[r],enumerable:!(c=u(n,r))||c.enumerable});return e};var C=(e,n,t)=>(t=e!=null?m(f(e)):{},a(n||!e||!e.__esModule?s(t,\"default\",{value:e,enumerable:!0}):t,e)),D=e=>a(s({},\"__esModule\",{value:!0}),e);var x=p((X,i)=>{i.exports=_jsx_runtime});var M={};l(M,{default:()=>h});var o=C(x());function d(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\"-Coder-V2\"]})}function h(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(d,{...e})}):d(e)}return D(M);})();\n;return Component;",
    "slug": "deepseek-coder-v2",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek LLM 67B Chat (V1)",
    "name": "DeepSeek LLM 67B Chat (V1)",
    "release_date": new Date("2023-11-29T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4096,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 20,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": 0.75
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-llm-67b-chat.mdx",
      "fileName": "deepseek-llm-67b-chat.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-llm-67b-chat"
    },
    "title": "DeepSeek LLM 67B Chat (V1)",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),l=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of _(n))!j.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(c=d(n,s))||c.enumerable});return e};var M=(e,n,t)=>(t=e!=null?u(f(e)):{},a(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),C=e=>a(r({},\"__esModule\",{value:!0}),e);var i=p((k,h)=>{h.exports=_jsx_runtime});var D={};l(D,{default:()=>m});var o=M(i());function x(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" LLM 67B Chat (V1)\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(x,{...e})}):x(e)}return C(D);})();\n;return Component;",
    "slug": "deepseek-llm-67b-chat",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "DeepSeek R1 (Jan '25)",
    "release_date": new Date("2025-01-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 60.22,
      "math_index": 82.47,
      "coding_index": 48.7,
      "benchmarks": {
        "mmlu_pro": 0.844,
        "gpqa": 0.708,
        "hle": 0.093,
        "scicode": 0.357,
        "aime": 0.683,
        "math_500": 0.966,
        "livecodebench": 0.617,
        "humaneval": 0.977
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.675,
        "output": 3.5,
        "blended_3_to_1": 2.3625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-r1-0120.mdx",
      "fileName": "deepseek-r1-0120.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1-0120"
    },
    "title": "DeepSeek R1 (Jan '25)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "deepseek-r1-0120",
    "readingTime": "0 min read"
  },
  {
    "content": "# DeepSeek R1 Distill Llama 70B",
    "name": "DeepSeek R1 Distill Llama 70B",
    "release_date": new Date("2025-01-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 48.24,
      "math_index": 80.23,
      "coding_index": 28.91,
      "benchmarks": {
        "mmlu_pro": 0.795,
        "gpqa": 0.402,
        "hle": 0.061,
        "scicode": 0.312,
        "aime": 0.67,
        "math_500": 0.935,
        "livecodebench": 0.266,
        "humaneval": 0.972
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7,
        "output": 0.8,
        "blended_3_to_1": 0.8
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 64.46,
      "time_to_first_token_ms": 0.54,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 39.33,
        "input_time_seconds": 0.54,
        "reasoning_time_seconds": 31.03,
        "answer_time_seconds": 7.76
      }
    },
    "_meta": {
      "filePath": "deepseek-r1-distill-llama-70b.mdx",
      "fileName": "deepseek-r1-distill-llama-70b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1-distill-llama-70b"
    },
    "title": "DeepSeek R1 Distill Llama 70B",
    "body": "var Component=(()=>{var l=Object.create;var r=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),p=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},c=(e,n,t,a)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of d(n))!f.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(a=u(n,s))||a.enumerable});return e};var D=(e,n,t)=>(t=e!=null?l(_(e)):{},c(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>c(r({},\"__esModule\",{value:!0}),e);var m=j((L,i)=>{i.exports=_jsx_runtime});var k={};p(k,{default:()=>h});var o=D(m());function x(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" R1 Distill Llama 70B\"]})}function h(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(x,{...e})}):x(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-r1-distill-llama-70b",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek R1 Distill Llama 8B",
    "name": "DeepSeek R1 Distill Llama 8B",
    "release_date": new Date("2025-01-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 34,
      "math_index": 59.3,
      "coding_index": 17.57,
      "benchmarks": {
        "mmlu_pro": 0.543,
        "gpqa": 0.302,
        "hle": 0.042,
        "scicode": 0.119,
        "aime": 0.333,
        "math_500": 0.853,
        "livecodebench": 0.233,
        "humaneval": 0.835
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.04,
        "output": 0.04,
        "blended_3_to_1": 0.04
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 56.55,
      "time_to_first_token_ms": 0.73,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 44.94,
        "input_time_seconds": 0.73,
        "reasoning_time_seconds": 35.37,
        "answer_time_seconds": 8.84
      }
    },
    "_meta": {
      "filePath": "deepseek-r1-distill-llama-8b.mdx",
      "fileName": "deepseek-r1-distill-llama-8b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1-distill-llama-8b"
    },
    "title": "DeepSeek R1 Distill Llama 8B",
    "body": "var Component=(()=>{var l=Object.create;var r=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),p=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},c=(e,n,t,a)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of d(n))!f.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(a=u(n,s))||a.enumerable});return e};var D=(e,n,t)=>(t=e!=null?l(_(e)):{},c(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>c(r({},\"__esModule\",{value:!0}),e);var m=j((L,i)=>{i.exports=_jsx_runtime});var k={};p(k,{default:()=>h});var o=D(m());function x(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" R1 Distill Llama 8B\"]})}function h(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(x,{...e})}):x(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-r1-distill-llama-8b",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek R1 Distill Qwen 1.5B",
    "name": "DeepSeek R1 Distill Qwen 1.5B",
    "release_date": new Date("2025-01-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.17,
      "math_index": 43.2,
      "coding_index": 6.8,
      "benchmarks": {
        "mmlu_pro": 0.269,
        "gpqa": 0.098,
        "hle": 0.033,
        "scicode": 0.066,
        "aime": 0.177,
        "math_500": 0.687,
        "livecodebench": 0.07,
        "humaneval": 0.454
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.18,
        "output": 0.18,
        "blended_3_to_1": 0.18
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 386.62,
      "time_to_first_token_ms": 0.26,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.73,
        "input_time_seconds": 0.26,
        "reasoning_time_seconds": 5.17,
        "answer_time_seconds": 1.29
      }
    },
    "_meta": {
      "filePath": "deepseek-r1-distill-qwen-1-5b.mdx",
      "fileName": "deepseek-r1-distill-qwen-1-5b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1-distill-qwen-1-5b"
    },
    "title": "DeepSeek R1 Distill Qwen 1.5B",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var l=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),p=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of l(n))!f.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(c=d(n,s))||c.enumerable});return e};var D=(e,n,t)=>(t=e!=null?u(_(e)):{},a(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>a(r({},\"__esModule\",{value:!0}),e);var x=j((C,i)=>{i.exports=_jsx_runtime});var k={};p(k,{default:()=>m});var o=D(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" R1 Distill Qwen 1.5B\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-r1-distill-qwen-1-5b",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek R1 Distill Qwen 14B",
    "name": "DeepSeek R1 Distill Qwen 14B",
    "release_date": new Date("2025-01-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 49,
      "math_index": 80.77,
      "coding_index": 30.72,
      "benchmarks": {
        "mmlu_pro": 0.74,
        "gpqa": 0.484,
        "hle": 0.044,
        "scicode": 0.239,
        "aime": 0.667,
        "math_500": 0.949,
        "livecodebench": 0.376,
        "humaneval": 0.934
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.2,
        "blended_3_to_1": 0.2
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 83.04,
      "time_to_first_token_ms": 0.64,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 30.75,
        "input_time_seconds": 0.64,
        "reasoning_time_seconds": 24.09,
        "answer_time_seconds": 6.02
      }
    },
    "_meta": {
      "filePath": "deepseek-r1-distill-qwen-14b.mdx",
      "fileName": "deepseek-r1-distill-qwen-14b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1-distill-qwen-14b"
    },
    "title": "DeepSeek R1 Distill Qwen 14B",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var l=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),p=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of l(n))!f.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(c=d(n,s))||c.enumerable});return e};var D=(e,n,t)=>(t=e!=null?u(_(e)):{},a(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>a(r({},\"__esModule\",{value:!0}),e);var x=j((C,i)=>{i.exports=_jsx_runtime});var k={};p(k,{default:()=>m});var o=D(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" R1 Distill Qwen 14B\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-r1-distill-qwen-14b",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek R1 Distill Qwen 32B",
    "name": "DeepSeek R1 Distill Qwen 32B",
    "release_date": new Date("2025-01-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 51.9,
      "math_index": 81.37,
      "coding_index": 32.28,
      "benchmarks": {
        "mmlu_pro": 0.739,
        "gpqa": 0.615,
        "hle": 0.055,
        "scicode": 0.376,
        "aime": 0.687,
        "math_500": 0.941,
        "livecodebench": 0.27,
        "humaneval": 0.948
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.3,
        "output": 0.3,
        "blended_3_to_1": 0.3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 27.22,
      "time_to_first_token_ms": 0.99,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 92.82,
        "input_time_seconds": 0.99,
        "reasoning_time_seconds": 73.46,
        "answer_time_seconds": 18.37
      }
    },
    "_meta": {
      "filePath": "deepseek-r1-distill-qwen-32b.mdx",
      "fileName": "deepseek-r1-distill-qwen-32b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1-distill-qwen-32b"
    },
    "title": "DeepSeek R1 Distill Qwen 32B",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var l=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),p=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of l(n))!f.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(c=d(n,s))||c.enumerable});return e};var D=(e,n,t)=>(t=e!=null?u(_(e)):{},a(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>a(r({},\"__esModule\",{value:!0}),e);var x=j((C,i)=>{i.exports=_jsx_runtime});var k={};p(k,{default:()=>m});var o=D(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" R1 Distill Qwen 32B\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-r1-distill-qwen-32b",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek R1",
    "name": "DeepSeek R1 0528",
    "release_date": new Date("2025-05-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 68.29,
      "math_index": 93.8,
      "coding_index": 58.66,
      "benchmarks": {
        "mmlu_pro": 0.849,
        "gpqa": 0.813,
        "hle": 0.149,
        "scicode": 0.403,
        "aime": 0.893,
        "math_500": 0.983,
        "livecodebench": 0.77,
        "humaneval": 0.97
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.55,
        "output": 2.19,
        "blended_3_to_1": 0.96
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 28.57,
      "time_to_first_token_ms": 2.44,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 89.94,
        "input_time_seconds": 2.44,
        "reasoning_time_seconds": 70.01,
        "answer_time_seconds": 17.5
      }
    },
    "aider": {
      "correct": 56.9,
      "cost": 5.42,
      "price_per_input_token": null,
      "correct_edit_format": 96.9
    },
    "_meta": {
      "filePath": "deepseek-r1.mdx",
      "fileName": "deepseek-r1.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-r1"
    },
    "title": "DeepSeek R1 0528",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),l=(e,n)=>{for(var t in n)r(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of _(n))!j.call(e,s)&&s!==t&&r(e,s,{get:()=>n[s],enumerable:!(c=d(n,s))||c.enumerable});return e};var D=(e,n,t)=>(t=e!=null?u(f(e)):{},a(n||!e||!e.__esModule?r(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>a(r({},\"__esModule\",{value:!0}),e);var x=p((X,i)=>{i.exports=_jsx_runtime});var k={};l(k,{default:()=>m});var o=D(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" R1\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-r1",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "DeepSeek-V2.5",
    "release_date": new Date("2024-09-06T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 34.70000076293945,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": 0.866
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.14,
        "output": 0.28,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-v2-5-sep-2024.mdx",
      "fileName": "deepseek-v2-5-sep-2024.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-v2-5-sep-2024"
    },
    "title": "DeepSeek-V2.5",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "deepseek-v2-5-sep-2024",
    "readingTime": "0 min read"
  },
  {
    "content": "# DeepSeek-V2.5 (Dec '24)",
    "name": "DeepSeek-V2.5 (Dec '24)",
    "release_date": new Date("2024-12-10T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.27000045776367,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.763,
        "livecodebench": null,
        "humaneval": 0.884
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.14,
        "output": 0.28,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-v2-5.mdx",
      "fileName": "deepseek-v2-5.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-v2-5"
    },
    "title": "DeepSeek-V2.5 (Dec '24)",
    "body": "var Component=(()=>{var u=Object.create;var c=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),l=(e,n)=>{for(var t in n)c(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,r)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of _(n))!j.call(e,s)&&s!==t&&c(e,s,{get:()=>n[s],enumerable:!(r=d(n,s))||r.enumerable});return e};var D=(e,n,t)=>(t=e!=null?u(f(e)):{},a(n||!e||!e.__esModule?c(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>a(c({},\"__esModule\",{value:!0}),e);var x=p((X,i)=>{i.exports=_jsx_runtime});var k={};l(k,{default:()=>m});var o=D(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\"-V2.5 (Dec '24)\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-v2-5",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "DeepSeek-V2-Chat",
    "release_date": new Date("2024-05-06T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 23,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": 0.868
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.14,
        "output": 0.28,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-v2.mdx",
      "fileName": "deepseek-v2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-v2"
    },
    "title": "DeepSeek-V2-Chat",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "deepseek-v2",
    "readingTime": "0 min read"
  },
  {
    "content": "# DeepSeek V3 0324 (Mar' 25)",
    "name": "DeepSeek V3 0324 (Mar '25)",
    "release_date": new Date("2025-03-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 53.24,
      "math_index": 73.1,
      "coding_index": 38.15,
      "benchmarks": {
        "mmlu_pro": 0.819,
        "gpqa": 0.655,
        "hle": 0.052,
        "scicode": 0.358,
        "aime": 0.52,
        "math_500": 0.942,
        "livecodebench": 0.405,
        "humaneval": 0.922
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.27,
        "output": 1.1,
        "blended_3_to_1": 0.4775
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 27.58,
      "time_to_first_token_ms": 2.43,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 20.55,
        "input_time_seconds": 2.43,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 18.13
      }
    },
    "aider": {
      "correct": 17.8,
      "cost": 0.51,
      "price_per_input_token": null,
      "correct_edit_format": 92.9
    },
    "_meta": {
      "filePath": "deepseek-v3-0324.mdx",
      "fileName": "deepseek-v3-0324.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-v3-0324"
    },
    "title": "DeepSeek V3 0324 (Mar '25)",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),l=(e,n)=>{for(var t in n)s(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let r of _(n))!j.call(e,r)&&r!==t&&s(e,r,{get:()=>n[r],enumerable:!(c=d(n,r))||c.enumerable});return e};var M=(e,n,t)=>(t=e!=null?u(f(e)):{},a(n||!e||!e.__esModule?s(t,\"default\",{value:e,enumerable:!0}):t,e)),D=e=>a(s({},\"__esModule\",{value:!0}),e);var x=p((X,i)=>{i.exports=_jsx_runtime});var k={};l(k,{default:()=>m});var o=M(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" V3 0324 (Mar' 25)\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return D(k);})();\n;return Component;",
    "slug": "deepseek-v3-0324",
    "readingTime": "1 min read"
  },
  {
    "content": "# DeepSeek V3 (Dec '24)",
    "name": "DeepSeek V3 (Dec '24)",
    "release_date": new Date("2024-12-26T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com/",
      "logo_url": "/logos/deepseek.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 45.58,
      "math_index": 57,
      "coding_index": 35.64,
      "benchmarks": {
        "mmlu_pro": 0.752,
        "gpqa": 0.557,
        "hle": 0.036,
        "scicode": 0.354,
        "aime": 0.253,
        "math_500": 0.887,
        "livecodebench": 0.359,
        "humaneval": 0.906
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.27,
        "output": 1.1,
        "blended_3_to_1": 0.4775
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "deepseek-v3.mdx",
      "fileName": "deepseek-v3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "deepseek-v3"
    },
    "title": "DeepSeek V3 (Dec '24)",
    "body": "var Component=(()=>{var u=Object.create;var c=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),l=(e,n)=>{for(var t in n)c(e,t,{get:n[t],enumerable:!0})},a=(e,n,t,r)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of _(n))!j.call(e,s)&&s!==t&&c(e,s,{get:()=>n[s],enumerable:!(r=d(n,s))||r.enumerable});return e};var D=(e,n,t)=>(t=e!=null?u(f(e)):{},a(n||!e||!e.__esModule?c(t,\"default\",{value:e,enumerable:!0}):t,e)),M=e=>a(c({},\"__esModule\",{value:!0}),e);var x=p((X,i)=>{i.exports=_jsx_runtime});var k={};l(k,{default:()=>m});var o=D(x());function h(e){let n={a:\"a\",h1:\"h1\",...e.components};return(0,o.jsxs)(n.h1,{children:[(0,o.jsx)(n.a,{href:\"/companies/deepseek\",children:\"DeepSeek\"}),\" V3 (Dec '24)\"]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,o.jsx)(n,{...e,children:(0,o.jsx)(h,{...e})}):h(e)}return M(k);})();\n;return Component;",
    "slug": "deepseek-v3",
    "readingTime": "1 min read"
  },
  {
    "content": "Devstral is an Apache-2.0, open-source coding model from Mistral AI and All Hands AI that’s trained to fix real GitHub issues through agent frameworks like OpenHands and SWE-Agent. It tops the open market with 46.8% on SWE-Bench Verified—beating models hundreds of billions of parameters larger—yet still runs on a single RTX 4090 or 32 GB Mac.\n\nFor developers, that means a free, self-hostable engine that can read an entire repo, locate a bug, and propose a passing patch without shipping code to a third party. Use it locally for privacy-sensitive work, drop it into agentic IDE plugins, or call the `devstral-small-2505` API for cheap, high-accuracy automated bug fixing.",
    "name": "Devstral",
    "release_date": new Date("2025-05-21T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/devstral",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 34.11,
      "math_index": 37.53,
      "coding_index": 25.18,
      "benchmarks": {
        "mmlu_pro": 0.632,
        "gpqa": 0.434,
        "hle": 0.04,
        "scicode": 0.245,
        "aime": 0.067,
        "math_500": 0.684,
        "livecodebench": 0.258,
        "humaneval": 0.848
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.3,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 140.78,
      "time_to_first_token_ms": 0.3,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.85,
        "input_time_seconds": 0.3,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.55
      }
    },
    "_meta": {
      "filePath": "devstral.mdx",
      "fileName": "devstral.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "devstral"
    },
    "title": "Devstral",
    "body": "var Component=(()=>{var p=Object.create;var o=Object.defineProperty;var m=Object.getOwnPropertyDescriptor;var u=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),_=(t,e)=>{for(var a in e)o(t,a,{get:e[a],enumerable:!0})},i=(t,e,a,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let r of u(e))!f.call(t,r)&&r!==a&&o(t,r,{get:()=>e[r],enumerable:!(s=m(e,r))||s.enumerable});return t};var b=(t,e,a)=>(a=t!=null?p(g(t)):{},i(e||!t||!t.__esModule?o(a,\"default\",{value:t,enumerable:!0}):a,t)),y=t=>i(o({},\"__esModule\",{value:!0}),t);var l=x((v,c)=>{c.exports=_jsx_runtime});var A={};_(A,{default:()=>h});var n=b(l());function d(t){let e={a:\"a\",code:\"code\",p:\"p\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsxs)(e.p,{children:[\"Devstral is an Apache-2.0, open-source coding model from \",(0,n.jsx)(e.a,{href:\"/companies/mistral\",children:\"Mistral AI\"}),\" and All Hands AI that\\u2019s trained to fix real GitHub issues through agent frameworks like OpenHands and SWE-Agent. It tops the open market with 46.8% on SWE-Bench Verified\\u2014beating models hundreds of billions of parameters larger\\u2014yet still runs on a single RTX 4090 or 32 GB Mac.\"]}),`\n`,(0,n.jsxs)(e.p,{children:[\"For developers, that means a free, self-hostable engine that can read an entire repo, locate a bug, and propose a passing patch without shipping code to a third party. Use it locally for privacy-sensitive work, drop it into agentic IDE plugins, or call the \",(0,n.jsx)(e.code,{children:\"devstral-small-2505\"}),\" API for cheap, high-accuracy automated bug fixing.\"]})]})}function h(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(d,{...t})}):d(t)}return y(A);})();\n;return Component;",
    "slug": "devstral",
    "readingTime": "1 min read"
  },
  {
    "content": "# Gemini 1.0 Pro",
    "name": "Gemini 1.0 Pro",
    "release_date": new Date("2023-12-06T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 20.59,
      "math_index": 20.47,
      "coding_index": 11.67,
      "benchmarks": {
        "mmlu_pro": 0.431,
        "gpqa": 0.277,
        "hle": 0.046,
        "scicode": 0.117,
        "aime": 0.007,
        "math_500": 0.403,
        "livecodebench": 0.116,
        "humaneval": 0.022
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.5,
        "output": 1.5,
        "blended_3_to_1": 0.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemini-1-0-pro.mdx",
      "fileName": "gemini-1-0-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-1-0-pro"
    },
    "title": "Gemini 1.0 Pro",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?u(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var m=l((g,c)=>{c.exports=_jsx_runtime});var D={};M(D,{default:()=>h});var s=p(m());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 1.0 Pro\"]})}function h(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "gemini-1-0-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "# Gemini 1.5 Flash-8B",
    "name": "Gemini 1.5 Flash-8B",
    "release_date": new Date("2024-10-03T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1048576,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 30.83,
      "math_index": 36.13,
      "coding_index": 22.3,
      "benchmarks": {
        "mmlu_pro": 0.569,
        "gpqa": 0.359,
        "hle": 0.045,
        "scicode": 0.229,
        "aime": 0.033,
        "math_500": 0.689,
        "livecodebench": 0.217,
        "humaneval": 0.116
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.0375,
        "output": 0.15,
        "blended_3_to_1": 0.065625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 280.34,
      "time_to_first_token_ms": 0.17,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 1.95,
        "input_time_seconds": 0.17,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.78
      }
    },
    "_meta": {
      "filePath": "gemini-1-5-flash-8b.mdx",
      "fileName": "gemini-1-5-flash-8b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-1-5-flash-8b"
    },
    "title": "Gemini 1.5 Flash-8B",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},i=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?u(f(n)):{},i(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>i(r({},\"__esModule\",{value:!0}),n);var h=l((g,c)=>{c.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var s=p(h());function m(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 1.5 Flash-8B\"]})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "gemini-1-5-flash-8b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Gemini 1.5 Flash (May '24)",
    "release_date": new Date("2024-05-14T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 28.47,
      "math_index": 32.37,
      "coding_index": 18.82,
      "benchmarks": {
        "mmlu_pro": 0.574,
        "gpqa": 0.324,
        "hle": 0.042,
        "scicode": 0.181,
        "aime": 0.093,
        "math_500": 0.554,
        "livecodebench": 0.196,
        "humaneval": 0.721
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.075,
        "output": 0.3,
        "blended_3_to_1": 0.13125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemini-1-5-flash-may-2024.mdx",
      "fileName": "gemini-1-5-flash-may-2024.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-1-5-flash-may-2024"
    },
    "title": "Gemini 1.5 Flash (May '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-1-5-flash-may-2024",
    "readingTime": "0 min read"
  },
  {
    "content": "# Gemini 1.5 Flash (Sep '24)",
    "name": "Gemini 1.5 Flash (Sep '24)",
    "release_date": new Date("2024-09-24T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 38.97,
      "math_index": 50.37,
      "coding_index": 27.02,
      "benchmarks": {
        "mmlu_pro": 0.68,
        "gpqa": 0.463,
        "hle": 0.035,
        "scicode": 0.267,
        "aime": 0.18,
        "math_500": 0.827,
        "livecodebench": 0.273,
        "humaneval": 0.838
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.075,
        "output": 0.3,
        "blended_3_to_1": 0.13125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 186.32,
      "time_to_first_token_ms": 0.2,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.88,
        "input_time_seconds": 0.2,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.68
      }
    },
    "_meta": {
      "filePath": "gemini-1-5-flash.mdx",
      "fileName": "gemini-1-5-flash.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-1-5-flash"
    },
    "title": "Gemini 1.5 Flash (Sep '24)",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},i=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var M=(n,t,e)=>(e=n!=null?u(f(n)):{},i(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>i(r({},\"__esModule\",{value:!0}),n);var h=l((g,c)=>{c.exports=_jsx_runtime});var D={};p(D,{default:()=>x});var s=M(h());function m(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 1.5 Flash (Sep '24)\"]})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "gemini-1-5-flash",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Gemini 1.5 Pro (May '24)",
    "release_date": new Date("2024-05-15T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 2000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.67,
      "math_index": 37.67,
      "coding_index": 25.9,
      "benchmarks": {
        "mmlu_pro": 0.657,
        "gpqa": 0.371,
        "hle": 0.039,
        "scicode": 0.274,
        "aime": 0.08,
        "math_500": 0.673,
        "livecodebench": 0.244,
        "humaneval": 0.834
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.25,
        "output": 5,
        "blended_3_to_1": 2.1875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemini-1-5-pro-may-2024.mdx",
      "fileName": "gemini-1-5-pro-may-2024.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-1-5-pro-may-2024"
    },
    "title": "Gemini 1.5 Pro (May '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-1-5-pro-may-2024",
    "readingTime": "0 min read"
  },
  {
    "content": "# Gemini 1.5 Pro (Sep '24)",
    "name": "Gemini 1.5 Pro (Sep '24)",
    "release_date": new Date("2024-09-24T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 2000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 44.6,
      "math_index": 55.3,
      "coding_index": 30.58,
      "benchmarks": {
        "mmlu_pro": 0.75,
        "gpqa": 0.589,
        "hle": 0.049,
        "scicode": 0.295,
        "aime": 0.23,
        "math_500": 0.876,
        "livecodebench": 0.316,
        "humaneval": 0.898
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.25,
        "output": 5,
        "blended_3_to_1": 2.1875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 91.5,
      "time_to_first_token_ms": 0.48,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.94,
        "input_time_seconds": 0.48,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.46
      }
    },
    "_meta": {
      "filePath": "gemini-1-5-pro.mdx",
      "fileName": "gemini-1-5-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-1-5-pro"
    },
    "title": "Gemini 1.5 Pro (Sep '24)",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var M=(n,t,e)=>(e=n!=null?u(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var m=l((g,c)=>{c.exports=_jsx_runtime});var D={};p(D,{default:()=>h});var s=M(m());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 1.5 Pro (Sep '24)\"]})}function h(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "gemini-1-5-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Gemini 2.0 Flash (experimental)",
    "release_date": new Date("2024-12-11T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 46.41,
      "math_index": 60.53,
      "coding_index": 27.49,
      "benchmarks": {
        "mmlu_pro": 0.782,
        "gpqa": 0.636,
        "hle": 0.047,
        "scicode": 0.34,
        "aime": 0.3,
        "math_500": 0.911,
        "livecodebench": 0.21,
        "humaneval": 0.907
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 224.46,
      "time_to_first_token_ms": 0.24,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.46,
        "input_time_seconds": 0.24,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.23
      }
    },
    "aider": {
      "correct": 18.2,
      "cost": null,
      "price_per_input_token": null,
      "correct_edit_format": 77.8
    },
    "_meta": {
      "filePath": "gemini-2-0-flash-experimental.mdx",
      "fileName": "gemini-2-0-flash-experimental.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-0-flash-experimental"
    },
    "title": "Gemini 2.0 Flash (experimental)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-2-0-flash-experimental",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Gemini 2.0 Flash-Lite (Feb '25)",
    "release_date": new Date("2025-02-25T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 41.4,
      "math_index": 57.47,
      "coding_index": 21.76,
      "benchmarks": {
        "mmlu_pro": 0.724,
        "gpqa": 0.535,
        "hle": 0.036,
        "scicode": 0.25,
        "aime": 0.277,
        "math_500": 0.873,
        "livecodebench": 0.185,
        "humaneval": 0.876
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.075,
        "output": 0.3,
        "blended_3_to_1": 0.13125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 221.18,
      "time_to_first_token_ms": 0.3,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.56,
        "input_time_seconds": 0.3,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.26
      }
    },
    "_meta": {
      "filePath": "gemini-2-0-flash-lite-001.mdx",
      "fileName": "gemini-2-0-flash-lite-001.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-0-flash-lite-001"
    },
    "title": "Gemini 2.0 Flash-Lite (Feb '25)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-2-0-flash-lite-001",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Gemini 2.0 Flash-Lite (Preview)",
    "release_date": new Date("2025-02-05T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.84000015258789,
      "math_index": 58.83,
      "coding_index": 21.27,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": 0.542,
        "hle": 0.044,
        "scicode": 0.247,
        "aime": 0.303,
        "math_500": 0.873,
        "livecodebench": 0.179,
        "humaneval": 0.896
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.075,
        "output": 0.3,
        "blended_3_to_1": 0.13125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 225.24,
      "time_to_first_token_ms": 0.28,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.5,
        "input_time_seconds": 0.28,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.22
      }
    },
    "_meta": {
      "filePath": "gemini-2-0-flash-lite-preview.mdx",
      "fileName": "gemini-2-0-flash-lite-preview.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-0-flash-lite-preview"
    },
    "title": "Gemini 2.0 Flash-Lite (Preview)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-2-0-flash-lite-preview",
    "readingTime": "0 min read"
  },
  {
    "content": "# Gemini 2.0 Flash (Feb '25)",
    "name": "Gemini 2.0 Flash (Feb '25)",
    "release_date": new Date("2025-02-05T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 48.09,
      "math_index": 63,
      "coding_index": 32.34,
      "benchmarks": {
        "mmlu_pro": 0.779,
        "gpqa": 0.623,
        "hle": 0.053,
        "scicode": 0.312,
        "aime": 0.33,
        "math_500": 0.93,
        "livecodebench": 0.334,
        "humaneval": 0.904
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.4,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 232.24,
      "time_to_first_token_ms": 0.38,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.53,
        "input_time_seconds": 0.38,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.15
      }
    },
    "_meta": {
      "filePath": "gemini-2-0-flash.mdx",
      "fileName": "gemini-2-0-flash.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-0-flash"
    },
    "title": "Gemini 2.0 Flash (Feb '25)",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},i=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?u(f(n)):{},i(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>i(r({},\"__esModule\",{value:!0}),n);var h=l((X,c)=>{c.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var s=p(h());function m(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,s.jsxs)(t.h1,{children:[(0,s.jsx)(t.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 2.0 Flash (Feb '25)\"]})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,s.jsx)(t,{...n,children:(0,s.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "gemini-2-0-flash",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Gemini 2.0 Pro Experimental (Feb '25)",
    "release_date": new Date("2025-02-05T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 2000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 49.2,
      "math_index": 64.13,
      "coding_index": 32.98,
      "benchmarks": {
        "mmlu_pro": 0.805,
        "gpqa": 0.622,
        "hle": 0.068,
        "scicode": 0.312,
        "aime": 0.36,
        "math_500": 0.923,
        "livecodebench": 0.347,
        "humaneval": 0.951
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 50.81,
      "time_to_first_token_ms": 17.05,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 26.89,
        "input_time_seconds": 17.05,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.84
      }
    },
    "aider": {
      "correct": 35.6,
      "cost": null,
      "price_per_input_token": null,
      "correct_edit_format": 100
    },
    "_meta": {
      "filePath": "gemini-2-0-pro-experimental-02-05.mdx",
      "fileName": "gemini-2-0-pro-experimental-02-05.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-0-pro-experimental-02-05"
    },
    "title": "Gemini 2.0 Pro Experimental (Feb '25)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-2-0-pro-experimental-02-05",
    "readingTime": "0 min read"
  },
  {
    "content": "Gemini 2.5 Flash-Lite is Google’s stripped-down, multimodal transformer that handles text, images, audio, and short video while swallowing up to a million tokens. It prioritizes speed and price—responses start in ~6 ms and cost about $0.10 in, $0.40 out per million tokens—beating Gemini 1.5 Flash on most benchmarks without chasing GPT-4-level depth.\n\nUse it when you need cheap, real-time output: customer-support chatbots, quick code fixes, bulk transcription, or other high-throughput tasks. Skip it for Olympiad-style math or heavyweight reasoning, but if latency and budget trump perfection, this is the pragmatic choice.",
    "name": "Gemini 2.5 Flash-Lite (Reasoning)",
    "release_date": new Date("2025-06-17T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 55,
      "math_index": 84,
      "coding_index": 39,
      "benchmarks": {
        "mmlu_pro": 0.759,
        "gpqa": 0.63,
        "hle": 0.064,
        "scicode": 0.19,
        "aime": 0.7,
        "math_500": 0.97,
        "livecodebench": 0.59,
        "humaneval": 0.97
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.4,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 585,
      "time_to_first_token_ms": 6.07,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.9,
        "input_time_seconds": 6.07,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 0.83
      }
    },
    "_meta": {
      "filePath": "gemini-2-5-flash-lite-reasoning.mdx",
      "fileName": "gemini-2-5-flash-lite-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-flash-lite-reasoning"
    },
    "title": "Gemini 2.5 Flash-Lite (Reasoning)",
    "body": "var Component=(()=>{var p=Object.create;var s=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(e,t)=>()=>(t||e((t={exports:{}}).exports,t),t.exports),w=(e,t)=>{for(var i in t)s(e,i,{get:t[i],enumerable:!0})},r=(e,t,i,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!f.call(e,o)&&o!==i&&s(e,o,{get:()=>t[o],enumerable:!(a=u(t,o))||a.enumerable});return e};var b=(e,t,i)=>(i=e!=null?p(g(e)):{},r(t||!e||!e.__esModule?s(i,\"default\",{value:e,enumerable:!0}):i,e)),k=e=>r(s({},\"__esModule\",{value:!0}),e);var c=x((j,h)=>{h.exports=_jsx_runtime});var _={};w(_,{default:()=>m});var n=b(c());function l(e){let t={a:\"a\",p:\"p\",...e.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsxs)(t.p,{children:[(0,n.jsx)(t.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 2.5 Flash-Lite is \",(0,n.jsx)(t.a,{href:\"/companies/google\",children:\"Google\"}),\"\\u2019s stripped-down, multimodal transformer that handles text, images, audio, and short video while swallowing up to a million tokens. It prioritizes speed and price\\u2014responses start in ~6 ms and cost about $0.10 in, $0.40 out per million tokens\\u2014beating Gemini 1.5 Flash on most benchmarks without chasing GPT-4-level depth.\"]}),`\n`,(0,n.jsx)(t.p,{children:\"Use it when you need cheap, real-time output: customer-support chatbots, quick code fixes, bulk transcription, or other high-throughput tasks. Skip it for Olympiad-style math or heavyweight reasoning, but if latency and budget trump perfection, this is the pragmatic choice.\"})]})}function m(e={}){let{wrapper:t}=e.components||{};return t?(0,n.jsx)(t,{...e,children:(0,n.jsx)(l,{...e})}):l(e)}return k(_);})();\n;return Component;",
    "slug": "gemini-2-5-flash-lite-reasoning",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Gemini 2.5 Flash Preview (Reasoning)",
    "release_date": new Date("2025-04-17T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 60.48,
      "math_index": 91.2,
      "coding_index": 43.18,
      "benchmarks": {
        "mmlu_pro": 0.8,
        "gpqa": 0.698,
        "hle": 0.116,
        "scicode": 0.359,
        "aime": 0.843,
        "math_500": 0.981,
        "livecodebench": 0.505,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 3.5,
        "blended_3_to_1": 0.9875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 372.12,
      "time_to_first_token_ms": 7.2,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.54,
        "input_time_seconds": 7.2,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.34
      }
    },
    "_meta": {
      "filePath": "gemini-2-5-flash-reasoning-04-2025.mdx",
      "fileName": "gemini-2-5-flash-reasoning-04-2025.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-flash-reasoning-04-2025"
    },
    "title": "Gemini 2.5 Flash Preview (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemini-2-5-flash-reasoning-04-2025",
    "readingTime": "0 min read"
  },
  {
    "content": "Gemini 2.5 Flash (Reasoning mode) is Google’s latency-first, sparse MoE transformer that pushes GPT-4-level logic and code skills while streaming ~300 tokens/s. It accepts text, images, audio, or video in contexts over one million tokens, yet costs just $0.15 / $0.60 per million input/output tokens through Google AI Studio.\n\nDevelopers reach for Flash when they need fast, cheap reasoning at scale—think live code review, long-context Q&A, or agentic function calls that can’t wait. You get near-Pro accuracy on benchmarks like GPQA (82 %) and LiveCodeBench (55 %) without paying Pro-tier compute, making it the pragmatic choice for high-throughput, multimodal apps.",
    "name": "Gemini 2.5 Flash (Reasoning)",
    "release_date": new Date("2025-05-20T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 65.05,
      "math_index": 90.23,
      "coding_index": 54.44,
      "benchmarks": {
        "mmlu_pro": 0.832,
        "gpqa": 0.79,
        "hle": 0.111,
        "scicode": 0.394,
        "aime": 0.823,
        "math_500": 0.981,
        "livecodebench": 0.695,
        "humaneval": 0.962
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 3.5,
        "blended_3_to_1": 0.9875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 345.89,
      "time_to_first_token_ms": 13.55,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 15,
        "input_time_seconds": 13.55,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.45
      }
    },
    "_meta": {
      "filePath": "gemini-2-5-flash-reasoning.mdx",
      "fileName": "gemini-2-5-flash-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-flash-reasoning"
    },
    "title": "Gemini 2.5 Flash (Reasoning)",
    "body": "var Component=(()=>{var u=Object.create;var a=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var g=Object.getOwnPropertyNames;var p=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),k=(t,e)=>{for(var o in e)a(t,o,{get:e[o],enumerable:!0})},r=(t,e,o,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let i of g(e))!f.call(t,i)&&i!==o&&a(t,i,{get:()=>e[i],enumerable:!(s=d(e,i))||s.enumerable});return t};var v=(t,e,o)=>(o=t!=null?u(p(t)):{},r(e||!t||!t.__esModule?a(o,\"default\",{value:t,enumerable:!0}):o,t)),_=t=>r(a({},\"__esModule\",{value:!0}),t);var h=x((y,c)=>{c.exports=_jsx_runtime});var j={};k(j,{default:()=>m});var n=v(h());function l(t){let e={a:\"a\",p:\"p\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 2.5 Flash (Reasoning mode) is \",(0,n.jsx)(e.a,{href:\"/companies/google\",children:\"Google\"}),\"\\u2019s latency-first, sparse MoE transformer that pushes GPT-4-level logic and code skills while streaming ~300 tokens/s. It accepts text, images, audio, or video in contexts over one million tokens, yet costs just $0.15 / $0.60 per million input/output tokens through Google AI Studio.\"]}),`\n`,(0,n.jsxs)(e.p,{children:[\"Developers reach for Flash when they need fast, cheap reasoning at scale\\u2014think live code review, long-context Q&A, or agentic function calls that can\\u2019t wait. You get near-Pro accuracy on benchmarks like GPQA (82 %) and \",(0,n.jsx)(e.a,{href:\"/benchmarks/livecodebench\",children:\"LiveCodeBench\"}),\" (55 %) without paying Pro-tier compute, making it the pragmatic choice for high-throughput, multimodal apps.\"]})]})}function m(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(l,{...t})}):l(t)}return _(j);})();\n;return Component;",
    "slug": "gemini-2-5-flash-reasoning",
    "readingTime": "1 min read"
  },
  {
    "content": "Gemini 2.5 Flash is Google's latency-first Gemini variant: a sparse MoE transformer that handles text, images, audio, and video with a 1 M-token context window while streaming ~280 tokens/s. It delivers GPT-4-class reasoning and coding scores (e.g., 55 % LiveCodeBench, 82 % GPQA) at a fraction of the compute of Gemini 2.5 Pro.\n\nDevelopers reach for Flash when they need high-throughput chat, real-time multimodal analysis, or agentic function-calling without breaking the budget. Served exclusively through Google AI Studio, it costs $0.15 / $0.60 per million input/output tokens and is the cheapest path to Gemini-level quality—no weights, just a fast API.",
    "name": "Gemini 2.5 Flash",
    "release_date": new Date("2025-05-20T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 53.43,
      "math_index": 71.6,
      "coding_index": 39.29,
      "benchmarks": {
        "mmlu_pro": 0.809,
        "gpqa": 0.683,
        "hle": 0.051,
        "scicode": 0.291,
        "aime": 0.5,
        "math_500": 0.932,
        "livecodebench": 0.495,
        "humaneval": 0.951
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.6,
        "blended_3_to_1": 0.2625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 279.32,
      "time_to_first_token_ms": 0.31,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.1,
        "input_time_seconds": 0.31,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.79
      }
    },
    "aider": {
      "correct": 44,
      "cost": 1.14,
      "price_per_input_token": null,
      "correct_edit_format": 93.8
    },
    "_meta": {
      "filePath": "gemini-2-5-flash.mdx",
      "fileName": "gemini-2-5-flash.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-flash"
    },
    "title": "Gemini 2.5 Flash",
    "body": "var Component=(()=>{var m=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var g=Object.getOwnPropertyNames;var p=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),v=(t,e)=>{for(var i in e)o(t,i,{get:e[i],enumerable:!0})},r=(t,e,i,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of g(e))!f.call(t,a)&&a!==i&&o(t,a,{get:()=>e[a],enumerable:!(s=u(e,a))||s.enumerable});return t};var w=(t,e,i)=>(i=t!=null?m(p(t)):{},r(e||!t||!t.__esModule?o(i,\"default\",{value:t,enumerable:!0}):i,t)),G=t=>r(o({},\"__esModule\",{value:!0}),t);var c=x((y,h)=>{h.exports=_jsx_runtime});var _={};v(_,{default:()=>d});var n=w(c());function l(t){let e={a:\"a\",p:\"p\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsxs)(e.p,{children:[\"Gemini 2.5 Flash is Google's latency-first Gemini variant: a sparse MoE transformer that handles text, images, audio, and video with a 1 M-token context window while streaming ~280 tokens/s. It delivers GPT-4-class reasoning and coding scores (e.g., 55 % \",(0,n.jsx)(e.a,{href:\"/benchmarks/livecodebench\",children:\"LiveCodeBench\"}),\", 82 % GPQA) at a fraction of the compute of \",(0,n.jsx)(e.a,{href:\"/assistants/gemini\",children:\"Gemini\"}),\" 2.5 Pro.\"]}),`\n`,(0,n.jsxs)(e.p,{children:[\"Developers reach for Flash when they need high-throughput chat, real-time multimodal analysis, or agentic function-calling without breaking the budget. Served exclusively through \",(0,n.jsx)(e.a,{href:\"/companies/google\",children:\"Google\"}),\" AI Studio, it costs $0.15 / $0.60 per million input/output tokens and is the cheapest path to Gemini-level quality\\u2014no weights, just a fast API.\"]})]})}function d(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(l,{...t})}):l(t)}return G(_);})();\n;return Component;",
    "slug": "gemini-2-5-flash",
    "readingTime": "1 min read"
  },
  {
    "content": "[Preview checkpoint, see latest.](/models/gemini-2-5-pro)",
    "name": "Gemini 2.5 Pro Preview 0325",
    "release_date": new Date("2025-03-25T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 68.87,
      "math_index": 92.5,
      "coding_index": 58.62,
      "benchmarks": {
        "mmlu_pro": 0.858,
        "gpqa": 0.836,
        "hle": 0.171,
        "scicode": 0.395,
        "aime": 0.87,
        "math_500": 0.98,
        "livecodebench": 0.778,
        "humaneval": 0.985
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.25,
        "output": 10,
        "blended_3_to_1": 3.4375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 152.67,
      "time_to_first_token_ms": 41.22,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 44.49,
        "input_time_seconds": 41.22,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.27
      }
    },
    "aider": {
      "correct": 72.9,
      "cost": null,
      "price_per_input_token": null,
      "correct_edit_format": 92.4
    },
    "_meta": {
      "filePath": "gemini-2-5-pro-03-25.mdx",
      "fileName": "gemini-2-5-pro-03-25.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-pro-03-25"
    },
    "title": "Gemini 2.5 Pro Preview 0325",
    "body": "var Component=(()=>{var d=Object.create;var c=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var x=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,h=Object.prototype.hasOwnProperty;var _=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),j=(e,n)=>{for(var t in n)c(e,t,{get:n[t],enumerable:!0})},s=(e,n,t,i)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of x(n))!h.call(e,o)&&o!==t&&c(e,o,{get:()=>n[o],enumerable:!(i=l(n,o))||i.enumerable});return e};var M=(e,n,t)=>(t=e!=null?d(f(e)):{},s(n||!e||!e.__esModule?c(t,\"default\",{value:e,enumerable:!0}):t,e)),w=e=>s(c({},\"__esModule\",{value:!0}),e);var m=_((X,a)=>{a.exports=_jsx_runtime});var C={};j(C,{default:()=>u});var r=M(m());function p(e){let n={a:\"a\",p:\"p\",...e.components};return(0,r.jsx)(n.p,{children:(0,r.jsx)(n.a,{href:\"/models/gemini-2-5-pro\",children:\"Preview checkpoint, see latest.\"})})}function u(e={}){let{wrapper:n}=e.components||{};return n?(0,r.jsx)(n,{...e,children:(0,r.jsx)(p,{...e})}):p(e)}return w(C);})();\n;return Component;",
    "slug": "gemini-2-5-pro-03-25",
    "readingTime": "1 min read"
  },
  {
    "content": "[Preview checkpoint, see latest.](/models/gemini-2-5-pro)",
    "name": "Gemini 2.5 Pro 0506 Preview",
    "release_date": new Date("2025-05-06T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 70.49,
      "math_index": 92.7,
      "coding_index": 61.46,
      "benchmarks": {
        "mmlu_pro": 0.862,
        "gpqa": 0.844,
        "hle": 0.211,
        "scicode": 0.428,
        "aime": 0.887,
        "math_500": 0.967,
        "livecodebench": 0.801,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.25,
        "output": 10,
        "blended_3_to_1": 3.4375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 143.41,
      "time_to_first_token_ms": 36.54,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 40.02,
        "input_time_seconds": 36.54,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.49
      }
    },
    "aider": {
      "correct": 76.9,
      "cost": 37.41,
      "price_per_input_token": null,
      "correct_edit_format": 97.3
    },
    "_meta": {
      "filePath": "gemini-2-5-pro-0506.mdx",
      "fileName": "gemini-2-5-pro-0506.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-pro-0506"
    },
    "title": "Gemini 2.5 Pro 0506 Preview",
    "body": "var Component=(()=>{var d=Object.create;var c=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var x=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,h=Object.prototype.hasOwnProperty;var _=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),j=(e,n)=>{for(var t in n)c(e,t,{get:n[t],enumerable:!0})},s=(e,n,t,i)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of x(n))!h.call(e,o)&&o!==t&&c(e,o,{get:()=>n[o],enumerable:!(i=l(n,o))||i.enumerable});return e};var M=(e,n,t)=>(t=e!=null?d(f(e)):{},s(n||!e||!e.__esModule?c(t,\"default\",{value:e,enumerable:!0}):t,e)),w=e=>s(c({},\"__esModule\",{value:!0}),e);var m=_((X,a)=>{a.exports=_jsx_runtime});var C={};j(C,{default:()=>u});var r=M(m());function p(e){let n={a:\"a\",p:\"p\",...e.components};return(0,r.jsx)(n.p,{children:(0,r.jsx)(n.a,{href:\"/models/gemini-2-5-pro\",children:\"Preview checkpoint, see latest.\"})})}function u(e={}){let{wrapper:n}=e.components||{};return n?(0,r.jsx)(n,{...e,children:(0,r.jsx)(p,{...e})}):p(e)}return w(C);})();\n;return Component;",
    "slug": "gemini-2-5-pro-0506",
    "readingTime": "1 min read"
  },
  {
    "content": "[Preview checkpoint, see latest.](/models/gemini-2-5-pro)",
    "name": "Gemini 2.5 Pro 0605 Preview",
    "release_date": new Date("2025-06-05T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 70.49,
      "math_index": 92.7,
      "coding_index": 61.46,
      "benchmarks": {
        "mmlu_pro": 0.862,
        "gpqa": 0.864,
        "hle": 0.216,
        "scicode": 0.428,
        "aime": 0.88,
        "math_500": 0.93,
        "livecodebench": 0.69,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.25,
        "output": 10,
        "blended_3_to_1": 3.4375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 143.41,
      "time_to_first_token_ms": 36.54,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 40.02,
        "input_time_seconds": 36.54,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.49
      }
    },
    "aider": {
      "correct": 83.1,
      "cost": 49.88,
      "price_per_input_token": null,
      "correct_edit_format": 99.6
    },
    "_meta": {
      "filePath": "gemini-2-5-pro-0605.mdx",
      "fileName": "gemini-2-5-pro-0605.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-pro-0605"
    },
    "title": "Gemini 2.5 Pro 0605 Preview",
    "body": "var Component=(()=>{var d=Object.create;var c=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var x=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,h=Object.prototype.hasOwnProperty;var _=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),j=(e,n)=>{for(var t in n)c(e,t,{get:n[t],enumerable:!0})},s=(e,n,t,i)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of x(n))!h.call(e,o)&&o!==t&&c(e,o,{get:()=>n[o],enumerable:!(i=l(n,o))||i.enumerable});return e};var M=(e,n,t)=>(t=e!=null?d(f(e)):{},s(n||!e||!e.__esModule?c(t,\"default\",{value:e,enumerable:!0}):t,e)),w=e=>s(c({},\"__esModule\",{value:!0}),e);var m=_((X,a)=>{a.exports=_jsx_runtime});var C={};j(C,{default:()=>u});var r=M(m());function p(e){let n={a:\"a\",p:\"p\",...e.components};return(0,r.jsx)(n.p,{children:(0,r.jsx)(n.a,{href:\"/models/gemini-2-5-pro\",children:\"Preview checkpoint, see latest.\"})})}function u(e={}){let{wrapper:n}=e.components||{};return n?(0,r.jsx)(n,{...e,children:(0,r.jsx)(p,{...e})}):p(e)}return w(C);})();\n;return Component;",
    "slug": "gemini-2-5-pro-0605",
    "readingTime": "1 min read"
  },
  {
    "content": "Gemini 2.5 Pro is Google’s latest sparse Mixture-of-Experts transformer that natively handles text, images, audio, and video in contexts exceeding one million tokens. It leads public coding, reasoning, and multimodal benchmarks (e.g., LiveCodeBench 69 %, GPQA 86 %) while delivering 143 tokens/s with sub-40 ms time-to-first-token on TPUv5p hardware.\n\nFor developers, this means you can stream entire codebases, PDFs, or hours of video to a single endpoint and get accurate answers or generated code without extra retrieval logic. Built-in function calling lets the model browse the web, run code, and chain actions, making it easy to build agentic workflows—chatbots, data pipelines, or autonomous apps—via the Google AI Studio API.",
    "name": "Gemini 2.5 Pro",
    "release_date": new Date("2025-06-17T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 70.49,
      "math_index": 92.7,
      "coding_index": 61.46,
      "benchmarks": {
        "mmlu_pro": 0.862,
        "gpqa": 0.864,
        "hle": 0.216,
        "scicode": 0.428,
        "aime": 0.88,
        "math_500": 0.93,
        "livecodebench": 0.69,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.25,
        "output": 10,
        "blended_3_to_1": 3.4375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 143.41,
      "time_to_first_token_ms": 36.54,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 40.02,
        "input_time_seconds": 36.54,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.49
      }
    },
    "aider": {
      "correct": 83.1,
      "cost": 49.88,
      "price_per_input_token": null,
      "correct_edit_format": 99.6
    },
    "_meta": {
      "filePath": "gemini-2-5-pro.mdx",
      "fileName": "gemini-2-5-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini-2-5-pro"
    },
    "title": "Gemini 2.5 Pro",
    "body": "var Component=(()=>{var m=Object.create;var i=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var g=Object.getOwnPropertyNames;var p=Object.getPrototypeOf,x=Object.prototype.hasOwnProperty;var f=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),b=(n,e)=>{for(var o in e)i(n,o,{get:e[o],enumerable:!0})},r=(n,e,o,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of g(e))!x.call(n,a)&&a!==o&&i(n,a,{get:()=>e[a],enumerable:!(s=u(e,a))||s.enumerable});return n};var v=(n,e,o)=>(o=n!=null?m(p(n)):{},r(e||!n||!n.__esModule?i(o,\"default\",{value:n,enumerable:!0}):o,n)),w=n=>r(i({},\"__esModule\",{value:!0}),n);var d=f((j,c)=>{c.exports=_jsx_runtime});var k={};b(k,{default:()=>h});var t=v(d());function l(n){let e={a:\"a\",p:\"p\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(e.p,{children:[\"Gemini 2.5 Pro is Google\\u2019s latest sparse Mixture-of-Experts transformer that natively handles text, images, audio, and video in contexts exceeding one million tokens. It leads public coding, reasoning, and multimodal benchmarks (e.g., \",(0,t.jsx)(e.a,{href:\"/benchmarks/livecodebench\",children:\"LiveCodeBench\"}),\" 69 %, \",(0,t.jsx)(e.a,{href:\"/benchmarks/gpqa\",children:\"GPQA\"}),\" 86 %) while delivering 143 tokens/s with sub-40 ms time-to-first-token on TPUv5p hardware.\"]}),`\n`,(0,t.jsxs)(e.p,{children:[\"For developers, this means you can stream entire codebases, PDFs, or hours of video to a single endpoint and get accurate answers or generated code without extra retrieval logic. Built-in function calling lets the model browse the web, run code, and chain actions, making it easy to build agentic workflows\\u2014chatbots, data pipelines, or autonomous apps\\u2014via the \",(0,t.jsx)(e.a,{href:\"/companies/google\",children:\"Google\"}),\" AI Studio API.\"]})]})}function h(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(l,{...n})}):l(n)}return w(k);})();\n;return Component;",
    "slug": "gemini-2-5-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "# Gemma 2 27B",
    "name": "Gemma 2 27B",
    "release_date": new Date("2024-06-27T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 25.559999465942383,
      "math_index": 31.53,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.575,
        "gpqa": 0.357,
        "hle": 0.037,
        "scicode": 0.125,
        "aime": 0.09,
        "math_500": 0.541,
        "livecodebench": null,
        "humaneval": 0.757
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.8,
        "output": 0.8,
        "blended_3_to_1": 0.8
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemma-2-27b.mdx",
      "fileName": "gemma-2-27b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemma-2-27b"
    },
    "title": "Gemma 2 27B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,m)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(m=_(t,o))||m.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=l((w,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(a());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Gemma 2 27B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "gemma-2-27b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Gemma 2 9B",
    "name": "Gemma 2 9B",
    "release_date": new Date("2024-06-27T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 22.2,
      "math_index": 25.87,
      "coding_index": 6.64,
      "benchmarks": {
        "mmlu_pro": 0.495,
        "gpqa": 0.311,
        "hle": 0.039,
        "scicode": 0.007,
        "aime": 0,
        "math_500": 0.517,
        "livecodebench": 0.126,
        "humaneval": 0.654
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.115,
        "output": 0.14500000000000002,
        "blended_3_to_1": 0.1225
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemma-2-9b.mdx",
      "fileName": "gemma-2-9b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemma-2-9b"
    },
    "title": "Gemma 2 9B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,m)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(m=_(t,o))||m.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=l((w,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(a());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Gemma 2 9B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "gemma-2-9b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Gemma 3 12B Instruct",
    "release_date": new Date("2025-03-12T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.83,
      "math_index": 53.67,
      "coding_index": 15.51,
      "benchmarks": {
        "mmlu_pro": 0.595,
        "gpqa": 0.349,
        "hle": 0.048,
        "scicode": 0.174,
        "aime": 0.22,
        "math_500": 0.853,
        "livecodebench": 0.137,
        "humaneval": 0.832
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.05,
        "output": 0.1,
        "blended_3_to_1": 0.0625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemma-3-12b.mdx",
      "fileName": "gemma-3-12b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemma-3-12b"
    },
    "title": "Gemma 3 12B Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemma-3-12b",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Gemma 3 1B Instruct",
    "release_date": new Date("2025-03-13T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.41999816894531,
      "math_index": 24.37,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.135,
        "gpqa": 0.237,
        "hle": 0.052,
        "scicode": null,
        "aime": 0.003,
        "math_500": 0.484,
        "livecodebench": 0.01,
        "humaneval": 0.324
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemma-3-1b.mdx",
      "fileName": "gemma-3-1b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemma-3-1b"
    },
    "title": "Gemma 3 1B Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemma-3-1b",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Gemma 3 27B Instruct",
    "release_date": new Date("2025-03-12T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 37.62,
      "math_index": 56.8,
      "coding_index": 17.42,
      "benchmarks": {
        "mmlu_pro": 0.669,
        "gpqa": 0.428,
        "hle": 0.047,
        "scicode": 0.212,
        "aime": 0.253,
        "math_500": 0.883,
        "livecodebench": 0.137,
        "humaneval": 0.894
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 47.48,
      "time_to_first_token_ms": 0.61,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.14,
        "input_time_seconds": 0.61,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 10.53
      }
    },
    "aider": {
      "correct": 4.9,
      "cost": null,
      "price_per_input_token": 1.19e-7,
      "correct_edit_format": 100
    },
    "_meta": {
      "filePath": "gemma-3-27b.mdx",
      "fileName": "gemma-3-27b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemma-3-27b"
    },
    "title": "Gemma 3 27B Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemma-3-27b",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Gemma 3 4B Instruct",
    "release_date": new Date("2025-03-12T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 24.48,
      "math_index": 40.8,
      "coding_index": 6.45,
      "benchmarks": {
        "mmlu_pro": 0.417,
        "gpqa": 0.291,
        "hle": 0.052,
        "scicode": 0.061,
        "aime": 0.05,
        "math_500": 0.766,
        "livecodebench": 0.068,
        "humaneval": 0.721
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.02,
        "output": 0.04,
        "blended_3_to_1": 0.025
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gemma-3-4b.mdx",
      "fileName": "gemma-3-4b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemma-3-4b"
    },
    "title": "Gemma 3 4B Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gemma-3-4b",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "GPT-3.5 Turbo",
    "release_date": new Date("2022-11-30T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 4096,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 22.71,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.462,
        "gpqa": 0.297,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.441,
        "livecodebench": null,
        "humaneval": 0.698
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.5,
        "output": 1.5,
        "blended_3_to_1": 0.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 114.27,
      "time_to_first_token_ms": 0.35,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.73,
        "input_time_seconds": 0.35,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.38
      }
    },
    "_meta": {
      "filePath": "gpt-35-turbo.mdx",
      "fileName": "gpt-35-turbo.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-35-turbo"
    },
    "title": "GPT-3.5 Turbo",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gpt-35-turbo",
    "readingTime": "0 min read"
  },
  {
    "content": "# GPT-4.1 mini",
    "name": "GPT-4.1 mini",
    "release_date": new Date("2025-04-14T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 52.86,
      "math_index": 67.77,
      "coding_index": 44.32,
      "benchmarks": {
        "mmlu_pro": 0.781,
        "gpqa": 0.664,
        "hle": 0.046,
        "scicode": 0.404,
        "aime": 0.43,
        "math_500": 0.925,
        "livecodebench": 0.483,
        "humaneval": 0.95
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.4,
        "output": 1.6,
        "blended_3_to_1": 0.7
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 70.92,
      "time_to_first_token_ms": 0.43,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.48,
        "input_time_seconds": 0.43,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.05
      }
    },
    "aider": {
      "correct": 32.4,
      "cost": 1.99,
      "price_per_input_token": null,
      "correct_edit_format": 92.4
    },
    "_meta": {
      "filePath": "gpt-4-1-mini.mdx",
      "fileName": "gpt-4-1-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4-1-mini"
    },
    "title": "GPT-4.1 mini",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>m(r({},\"__esModule\",{value:!0}),n);var u=l((w,s)=>{s.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var c=p(u());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"GPT-4.1 mini\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "gpt-4-1-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "# GPT-4.1 nano",
    "name": "GPT-4.1 nano",
    "release_date": new Date("2025-04-14T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 41.01,
      "math_index": 54.23,
      "coding_index": 29.26,
      "benchmarks": {
        "mmlu_pro": 0.657,
        "gpqa": 0.512,
        "hle": 0.039,
        "scicode": 0.259,
        "aime": 0.237,
        "math_500": 0.848,
        "livecodebench": 0.326,
        "humaneval": 0.877
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.4,
        "blended_3_to_1": 0.175
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 183.78,
      "time_to_first_token_ms": 0.31,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.03,
        "input_time_seconds": 0.31,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.72
      }
    },
    "aider": {
      "correct": 8.9,
      "cost": 0.43,
      "price_per_input_token": null,
      "correct_edit_format": 94.2
    },
    "_meta": {
      "filePath": "gpt-4-1-nano.mdx",
      "fileName": "gpt-4-1-nano.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4-1-nano"
    },
    "title": "GPT-4.1 nano",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var i=l((w,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"GPT-4.1 nano\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "gpt-4-1-nano",
    "readingTime": "1 min read"
  },
  {
    "content": "# GPT-4.1",
    "name": "GPT-4.1",
    "release_date": new Date("2025-04-14T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 52.63,
      "math_index": 67.47,
      "coding_index": 41.9,
      "benchmarks": {
        "mmlu_pro": 0.806,
        "gpqa": 0.666,
        "hle": 0.046,
        "scicode": 0.381,
        "aime": 0.437,
        "math_500": 0.913,
        "livecodebench": 0.457,
        "humaneval": 0.956
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 8,
        "blended_3_to_1": 3.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 91.82,
      "time_to_first_token_ms": 0.49,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.93,
        "input_time_seconds": 0.49,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.45
      }
    },
    "aider": {
      "correct": 52.4,
      "cost": 9.86,
      "price_per_input_token": null,
      "correct_edit_format": 98.2
    },
    "_meta": {
      "filePath": "gpt-4-1.mdx",
      "fileName": "gpt-4-1.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4-1"
    },
    "title": "GPT-4.1",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=l((w,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"GPT-4.1\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "gpt-4-1",
    "readingTime": "1 min read"
  },
  {
    "content": "# GPT-4.5 (Preview)",
    "name": "GPT-4.5 (Preview)",
    "release_date": new Date("2025-02-27T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 53.0099983215332,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": 0.714,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 75,
        "output": 150,
        "blended_3_to_1": 93.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 82.89,
      "time_to_first_token_ms": 0.96,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.99,
        "input_time_seconds": 0.96,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.03
      }
    },
    "aider": {
      "correct": 44.9,
      "cost": 183.18,
      "price_per_input_token": null,
      "correct_edit_format": 97.3
    },
    "_meta": {
      "filePath": "gpt-4-5.mdx",
      "fileName": "gpt-4-5.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4-5"
    },
    "title": "GPT-4.5 (Preview)",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),w=n=>s(r({},\"__esModule\",{value:!0}),n);var m=l((P,u)=>{u.exports=_jsx_runtime});var C={};M(C,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"GPT-4.5 (Preview)\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return w(C);})();\n;return Component;",
    "slug": "gpt-4-5",
    "readingTime": "1 min read"
  },
  {
    "content": "# GPT-4 Turbo",
    "name": "GPT-4 Turbo",
    "release_date": new Date("2023-11-06T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 38.76,
      "math_index": 44.33,
      "coding_index": 30.52,
      "benchmarks": {
        "mmlu_pro": 0.694,
        "gpqa": null,
        "hle": 0.033,
        "scicode": 0.319,
        "aime": 0.15,
        "math_500": 0.737,
        "livecodebench": 0.291,
        "humaneval": 0.918
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 10,
        "output": 30,
        "blended_3_to_1": 15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 41.98,
      "time_to_first_token_ms": 0.99,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 12.9,
        "input_time_seconds": 0.99,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 11.91
      }
    },
    "_meta": {
      "filePath": "gpt-4-turbo.mdx",
      "fileName": "gpt-4-turbo.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4-turbo"
    },
    "title": "GPT-4 Turbo",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,u)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(u=_(t,o))||u.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var m=l((X,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"GPT-4 Turbo\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "gpt-4-turbo",
    "readingTime": "1 min read"
  },
  {
    "content": "# GPT-4\n\n# GPT-4 Model Card\n\n## Model Summary\n\nGPT-4, developed by OpenAI, is a multimodal large language model succeeding GPT-3.5, capable of processing text and image inputs to generate text outputs. Released on March 14, 2023, it excels in reasoning, professional benchmarks, and nuanced instruction-following. It supports a context window of 8,192 or 32,768 tokens and is accessible via ChatGPT Plus, OpenAI’s API, and Microsoft Copilot.\n\n## Performance Metrics\n\nGPT-4 achieves human-level performance across diverse tasks, outperforming predecessors in reliability and creativity. Its multimodal capabilities enable image interpretation and complex task handling.\n\n| Benchmark | GPT-4 Score | GPT-3.5 Score |\n|-----------|-------------|---------------|\n| Simulated Bar Exam | Top 10% | Bottom 10% |\n| MMLU (Multiple-Choice) | 86.4% | 70.1% |\n| HellaSwag | 95.3% | 85.5% |\n| VQAv2 (Visual QA) | 77.2% | Not applicable |\n\n## Architecture Details\n\nBuilt on a transformer architecture, GPT-4 is pre-trained on a vast corpus of public and licensed text data, including web pages and code. Fine-tuning employs reinforcement learning with human and AI feedback (RLHF) for alignment. While exact parameter counts are undisclosed (estimated at 1.76 trillion), it achieves 10x computational efficiency over prior models, trained on an Azure-co-designed supercomputer.\n\n## Training Data\n\nThe model leverages diverse sources, including public internet data, licensed datasets, and code repositories. Pre-training data is filtered to reduce inappropriate content, though some biases persist. Personal information is minimized where feasible to address privacy concerns.\n\n## Safety Measures\n\nOpenAI implemented robust safety protocols, informed by over 50 external experts across 45 languages and 29 countries. Key risks and mitigations include:\n\n| Risk | Mitigation | Residual Risk |\n|------|------------|---------------|\n| Hallucinations | RLHF, data filtering | Low, 19% better than GPT-3.5 (open-domain) |\n| Harmful Content | Refusal training, content classifiers | Medium, reduced from GPT-4-early |\n| Bias | Dataset curation, refusal tuning | Medium, ongoing evaluation |\n| Cybersecurity | Malicious request refusal | Low, 5% vulnerability rate |\n\nRed-teaming revealed reduced risks in autonomous replication (0% success) and illicit advice, though persuasion risks remain medium.\n\n## Limitations Identified\n\nGPT-4 may produce biased or factually incorrect outputs, particularly in specialized domains. Its image processing is less robust than text, and it lacks native audio capabilities. High inference costs and lack of real-time data access limit certain applications. Refusal behaviors may introduce quality-of-service disparities across demographics.\n\n## Intended Applications\n\nThe model supports education, coding, content creation, and accessibility tasks, such as generating learning materials, assisting developers, or summarizing visual data. Its system message feature enables customization for specific tones or formats, like JSON outputs.\n\n## Ethical Concerns\n\nPotential misuse includes generating misinformation or biased content. Training data may reflect societal biases, requiring continuous mitigation. OpenAI emphasizes alignment with human values, but equitable access and preventing harmful applications remain challenges.\n\n## Evaluation Process\n\nOver 100 red-teaming evaluations assessed risks in cybersecurity, biorisk, and persuasion. Quantitative evaluations measured harmful content generation, with GPT-4-launch scoring 19–29% better than GPT-3.5 on hallucination avoidance. The Alignment Research Center (ARC) confirmed low risks of autonomous replication.\n\n## Access Methods\n\nAvailable via ChatGPT Plus, OpenAI’s API (image capabilities waitlisted), and Microsoft Copilot. SuperGrok subscriptions offer higher quotas; see https://x.ai/grok for details. API access is detailed at https://x.ai/api.\n\n## Future Enhancements\n\nOpenAI aims to improve multimodal processing (audio, video), reduce inference costs, and enhance real-time data integration. Research continues to minimize biases and strengthen reasoning for niche domains.",
    "name": "GPT-4",
    "release_date": new Date("2023-03-14T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 8192,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 36,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 30,
        "output": 60,
        "blended_3_to_1": 37.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 23.19,
      "time_to_first_token_ms": 0.79,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 22.35,
        "input_time_seconds": 0.79,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 21.56
      }
    },
    "_meta": {
      "filePath": "gpt-4.mdx",
      "fileName": "gpt-4.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4"
    },
    "title": "GPT-4",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var p=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var b=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),v=(n,e)=>{for(var t in e)r(n,t,{get:e[t],enumerable:!0})},c=(n,e,t,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of m(e))!f.call(n,a)&&a!==t&&r(n,a,{get:()=>e[a],enumerable:!(s=p(e,a))||s.enumerable});return n};var y=(n,e,t)=>(t=n!=null?u(g(n)):{},c(e||!n||!n.__esModule?r(t,\"default\",{value:n,enumerable:!0}):t,n)),P=n=>c(r({},\"__esModule\",{value:!0}),n);var l=b((T,d)=>{d.exports=_jsx_runtime});var x={};v(x,{default:()=>h});var i=y(l());function o(n){let e={a:\"a\",h1:\"h1\",h2:\"h2\",p:\"p\",table:\"table\",tbody:\"tbody\",td:\"td\",th:\"th\",thead:\"thead\",tr:\"tr\",...n.components};return(0,i.jsxs)(i.Fragment,{children:[(0,i.jsx)(e.h1,{children:\"GPT-4\"}),`\n`,(0,i.jsx)(e.h1,{children:\"GPT-4 Model Card\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Model Summary\"}),`\n`,(0,i.jsxs)(e.p,{children:[\"GPT-4, developed by OpenAI, is a multimodal large language model succeeding GPT-3.5, capable of processing text and image inputs to generate text outputs. Released on March 14, 2023, it excels in reasoning, professional benchmarks, and nuanced instruction-following. It supports a context window of 8,192 or 32,768 tokens and is accessible via \",(0,i.jsx)(e.a,{href:\"/assistants/chatgpt\",children:\"ChatGPT\"}),\" Plus, \",(0,i.jsx)(e.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\"\\u2019s API, and Microsoft Copilot.\"]}),`\n`,(0,i.jsx)(e.h2,{children:\"Performance Metrics\"}),`\n`,(0,i.jsx)(e.p,{children:\"GPT-4 achieves human-level performance across diverse tasks, outperforming predecessors in reliability and creativity. Its multimodal capabilities enable image interpretation and complex task handling.\"}),`\n`,(0,i.jsxs)(e.table,{children:[(0,i.jsx)(e.thead,{children:(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.th,{children:\"Benchmark\"}),(0,i.jsx)(e.th,{children:\"GPT-4 Score\"}),(0,i.jsx)(e.th,{children:\"GPT-3.5 Score\"})]})}),(0,i.jsxs)(e.tbody,{children:[(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"Simulated Bar Exam\"}),(0,i.jsx)(e.td,{children:\"Top 10%\"}),(0,i.jsx)(e.td,{children:\"Bottom 10%\"})]}),(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"MMLU (Multiple-Choice)\"}),(0,i.jsx)(e.td,{children:\"86.4%\"}),(0,i.jsx)(e.td,{children:\"70.1%\"})]}),(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"HellaSwag\"}),(0,i.jsx)(e.td,{children:\"95.3%\"}),(0,i.jsx)(e.td,{children:\"85.5%\"})]}),(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"VQAv2 (Visual QA)\"}),(0,i.jsx)(e.td,{children:\"77.2%\"}),(0,i.jsx)(e.td,{children:\"Not applicable\"})]})]})]}),`\n`,(0,i.jsx)(e.h2,{children:\"Architecture Details\"}),`\n`,(0,i.jsxs)(e.p,{children:[\"Built on a transformer architecture, GPT-4 is pre-trained on a vast corpus of public and licensed text data, including web pages and code. Fine-tuning employs reinforcement learning with human and AI feedback (RLHF) for alignment. While exact parameter counts are undisclosed (estimated at 1.76 trillion), it achieves 10x computational efficiency over prior models, trained on an \",(0,i.jsx)(e.a,{href:\"/companies/azure\",children:\"Azure\"}),\"-co-designed supercomputer.\"]}),`\n`,(0,i.jsx)(e.h2,{children:\"Training Data\"}),`\n`,(0,i.jsx)(e.p,{children:\"The model leverages diverse sources, including public internet data, licensed datasets, and code repositories. Pre-training data is filtered to reduce inappropriate content, though some biases persist. Personal information is minimized where feasible to address privacy concerns.\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Safety Measures\"}),`\n`,(0,i.jsx)(e.p,{children:\"OpenAI implemented robust safety protocols, informed by over 50 external experts across 45 languages and 29 countries. Key risks and mitigations include:\"}),`\n`,(0,i.jsxs)(e.table,{children:[(0,i.jsx)(e.thead,{children:(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.th,{children:\"Risk\"}),(0,i.jsx)(e.th,{children:\"Mitigation\"}),(0,i.jsx)(e.th,{children:\"Residual Risk\"})]})}),(0,i.jsxs)(e.tbody,{children:[(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"Hallucinations\"}),(0,i.jsx)(e.td,{children:\"RLHF, data filtering\"}),(0,i.jsx)(e.td,{children:\"Low, 19% better than GPT-3.5 (open-domain)\"})]}),(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"Harmful Content\"}),(0,i.jsx)(e.td,{children:\"Refusal training, content classifiers\"}),(0,i.jsx)(e.td,{children:\"Medium, reduced from GPT-4-early\"})]}),(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"Bias\"}),(0,i.jsx)(e.td,{children:\"Dataset curation, refusal tuning\"}),(0,i.jsx)(e.td,{children:\"Medium, ongoing evaluation\"})]}),(0,i.jsxs)(e.tr,{children:[(0,i.jsx)(e.td,{children:\"Cybersecurity\"}),(0,i.jsx)(e.td,{children:\"Malicious request refusal\"}),(0,i.jsx)(e.td,{children:\"Low, 5% vulnerability rate\"})]})]})]}),`\n`,(0,i.jsx)(e.p,{children:\"Red-teaming revealed reduced risks in autonomous replication (0% success) and illicit advice, though persuasion risks remain medium.\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Limitations Identified\"}),`\n`,(0,i.jsx)(e.p,{children:\"GPT-4 may produce biased or factually incorrect outputs, particularly in specialized domains. Its image processing is less robust than text, and it lacks native audio capabilities. High inference costs and lack of real-time data access limit certain applications. Refusal behaviors may introduce quality-of-service disparities across demographics.\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Intended Applications\"}),`\n`,(0,i.jsx)(e.p,{children:\"The model supports education, coding, content creation, and accessibility tasks, such as generating learning materials, assisting developers, or summarizing visual data. Its system message feature enables customization for specific tones or formats, like JSON outputs.\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Ethical Concerns\"}),`\n`,(0,i.jsx)(e.p,{children:\"Potential misuse includes generating misinformation or biased content. Training data may reflect societal biases, requiring continuous mitigation. OpenAI emphasizes alignment with human values, but equitable access and preventing harmful applications remain challenges.\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Evaluation Process\"}),`\n`,(0,i.jsx)(e.p,{children:\"Over 100 red-teaming evaluations assessed risks in cybersecurity, biorisk, and persuasion. Quantitative evaluations measured harmful content generation, with GPT-4-launch scoring 19\\u201329% better than GPT-3.5 on hallucination avoidance. The Alignment Research Center (ARC) confirmed low risks of autonomous replication.\"}),`\n`,(0,i.jsx)(e.h2,{children:\"Access Methods\"}),`\n`,(0,i.jsxs)(e.p,{children:[\"Available via ChatGPT Plus, OpenAI\\u2019s API (image capabilities waitlisted), and Microsoft Copilot. SuperGrok subscriptions offer higher quotas; see \",(0,i.jsx)(e.a,{href:\"https://x.ai/grok\",children:\"https://x.ai/grok\"}),\" for details. API access is detailed at \",(0,i.jsx)(e.a,{href:\"https://x.ai/api\",children:\"https://x.ai/api\"}),\".\"]}),`\n`,(0,i.jsx)(e.h2,{children:\"Future Enhancements\"}),`\n`,(0,i.jsx)(e.p,{children:\"OpenAI aims to improve multimodal processing (audio, video), reduce inference costs, and enhance real-time data integration. Research continues to minimize biases and strengthen reasoning for niche domains.\"})]})}function h(n={}){let{wrapper:e}=n.components||{};return e?(0,i.jsx)(e,{...n,children:(0,i.jsx)(o,{...n})}):o(n)}return P(x);})();\n;return Component;",
    "slug": "gpt-4",
    "readingTime": "3 min read"
  },
  {
    "content": "",
    "name": "gpt-4o-2024-05-13",
    "release_date": new Date("2024-05-13T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.87,
      "math_index": 45.07,
      "coding_index": 32.17,
      "benchmarks": {
        "mmlu_pro": 0.74,
        "gpqa": 0.526,
        "hle": 0.028,
        "scicode": 0.309,
        "aime": 0.11,
        "math_500": 0.791,
        "livecodebench": 0.334,
        "humaneval": 0.935
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 5,
        "output": 15,
        "blended_3_to_1": 7.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 78.41,
      "time_to_first_token_ms": 0.57,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.94,
        "input_time_seconds": 0.57,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.38
      }
    },
    "_meta": {
      "filePath": "gpt-4o-2024-05-13.mdx",
      "fileName": "gpt-4o-2024-05-13.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4o-2024-05-13"
    },
    "title": "gpt-4o-2024-05-13",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gpt-4o-2024-05-13",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "GPT-4o (Aug '24)",
    "release_date": new Date("2024-08-06T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.540000915527344,
      "math_index": 45.57,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": 0.521,
        "hle": 0.029,
        "scicode": null,
        "aime": 0.117,
        "math_500": 0.795,
        "livecodebench": 0.317,
        "humaneval": 0.926
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2.5,
        "output": 10,
        "blended_3_to_1": 4.375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 81.28,
      "time_to_first_token_ms": 0.65,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.8,
        "input_time_seconds": 0.65,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.15
      }
    },
    "aider": {
      "correct": 18.2,
      "cost": 6.74,
      "price_per_input_token": null,
      "correct_edit_format": 95.1
    },
    "_meta": {
      "filePath": "gpt-4o-2024-08-06.mdx",
      "fileName": "gpt-4o-2024-08-06.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4o-2024-08-06"
    },
    "title": "GPT-4o (Aug '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gpt-4o-2024-08-06",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "GPT-4o (March 2025, chatgpt-4o-latest)",
    "release_date": new Date("2025-03-27T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 50.25,
      "math_index": 60.97,
      "coding_index": 39.56,
      "benchmarks": {
        "mmlu_pro": 0.803,
        "gpqa": 0.655,
        "hle": 0.05,
        "scicode": 0.366,
        "aime": 0.327,
        "math_500": 0.893,
        "livecodebench": 0.425,
        "humaneval": 0.96
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 5,
        "output": 15,
        "blended_3_to_1": 7.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 187.53,
      "time_to_first_token_ms": 0.41,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.07,
        "input_time_seconds": 0.41,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.67
      }
    },
    "_meta": {
      "filePath": "gpt-4o-chatgpt-03-25.mdx",
      "fileName": "gpt-4o-chatgpt-03-25.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4o-chatgpt-03-25"
    },
    "title": "GPT-4o (March 2025, chatgpt-4o-latest)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gpt-4o-chatgpt-03-25",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "GPT-4o (ChatGPT)",
    "release_date": new Date("2025-02-15T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 39.83000183105469,
      "math_index": 45.03,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.773,
        "gpqa": 0.511,
        "hle": 0.037,
        "scicode": 0.334,
        "aime": 0.103,
        "math_500": 0.797,
        "livecodebench": null,
        "humaneval": 0.939
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 5,
        "output": 15,
        "blended_3_to_1": 7.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "gpt-4o-chatgpt.mdx",
      "fileName": "gpt-4o-chatgpt.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4o-chatgpt"
    },
    "title": "GPT-4o (ChatGPT)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "gpt-4o-chatgpt",
    "readingTime": "0 min read"
  },
  {
    "content": "# GPT-4o mini",
    "name": "GPT-4o mini",
    "release_date": new Date("2024-07-18T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.68,
      "math_index": 45.27,
      "coding_index": 23.15,
      "benchmarks": {
        "mmlu_pro": 0.648,
        "gpqa": 0.426,
        "hle": 0.04,
        "scicode": 0.229,
        "aime": 0.117,
        "math_500": 0.789,
        "livecodebench": 0.234,
        "humaneval": 0.876
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.6,
        "blended_3_to_1": 0.2625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 70.1,
      "time_to_first_token_ms": 0.47,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.61,
        "input_time_seconds": 0.47,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.13
      }
    },
    "aider": {
      "correct": 3.6,
      "cost": 0.32,
      "price_per_input_token": 1.5e-7,
      "correct_edit_format": 100
    },
    "_meta": {
      "filePath": "gpt-4o-mini.mdx",
      "fileName": "gpt-4o-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4o-mini"
    },
    "title": "GPT-4o mini",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>m(r({},\"__esModule\",{value:!0}),n);var u=l((w,s)=>{s.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var c=p(u());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"GPT-4o mini\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "gpt-4o-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "GPT-4o is OpenAI's latest multimodal model that handles text, code, images, audio, and video in one network. It matches GPT-4 Turbo on English tasks, is stronger in other languages, and offers a 128k context window with ~300 ms speech response at half the price.\n\nDevelopers get a single, cheaper endpoint for chat, coding, voice, and vision features without juggling multiple models or pipelines. The large context and real-time audio enable fast assistants and rich multimodal analysis in any app.",
    "name": "GPT-4o (Nov '24)",
    "release_date": new Date("2024-11-20T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 41.46,
      "math_index": 45.47,
      "coding_index": 32.12,
      "benchmarks": {
        "mmlu_pro": 0.748,
        "gpqa": 0.543,
        "hle": 0.033,
        "scicode": 0.333,
        "aime": 0.15,
        "math_500": 0.759,
        "livecodebench": 0.309,
        "humaneval": 0.93
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2.5,
        "output": 10,
        "blended_3_to_1": 4.375
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 158.71,
      "time_to_first_token_ms": 0.4,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.55,
        "input_time_seconds": 0.4,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.15
      }
    },
    "_meta": {
      "filePath": "gpt-4o.mdx",
      "fileName": "gpt-4o.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gpt-4o"
    },
    "title": "GPT-4o (Nov '24)",
    "body": "var Component=(()=>{var m=Object.create;var s=Object.defineProperty;var p=Object.getOwnPropertyDescriptor;var u=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),_=(e,n)=>{for(var a in n)s(e,a,{get:n[a],enumerable:!0})},r=(e,n,a,i)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of u(n))!f.call(e,o)&&o!==a&&s(e,o,{get:()=>n[o],enumerable:!(i=p(n,o))||i.enumerable});return e};var j=(e,n,a)=>(a=e!=null?m(g(e)):{},r(n||!e||!e.__esModule?s(a,\"default\",{value:e,enumerable:!0}):a,e)),w=e=>r(s({},\"__esModule\",{value:!0}),e);var c=x((k,l)=>{l.exports=_jsx_runtime});var v={};_(v,{default:()=>h});var t=j(c());function d(e){let n={a:\"a\",p:\"p\",...e.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(n.p,{children:[\"GPT-4o is \",(0,t.jsx)(n.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\"'s latest multimodal model that handles text, code, images, audio, and video in one network. It matches GPT-4 Turbo on English tasks, is stronger in other languages, and offers a 128k context window with ~300 ms speech response at half the price.\"]}),`\n`,(0,t.jsx)(n.p,{children:\"Developers get a single, cheaper endpoint for chat, coding, voice, and vision features without juggling multiple models or pipelines. The large context and real-time audio enable fast assistants and rich multimodal analysis in any app.\"})]})}function h(e={}){let{wrapper:n}=e.components||{};return n?(0,t.jsx)(n,{...e,children:(0,t.jsx)(d,{...e})}):d(e)}return w(v);})();\n;return Component;",
    "slug": "gpt-4o",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Grok 2 (Dec '24)",
    "release_date": new Date("2024-12-12T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 131072,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 39.23,
      "math_index": 45.57,
      "coding_index": 27.57,
      "benchmarks": {
        "mmlu_pro": 0.709,
        "gpqa": 0.51,
        "hle": 0.038,
        "scicode": 0.285,
        "aime": 0.133,
        "math_500": 0.778,
        "livecodebench": 0.267,
        "humaneval": 0.863
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "grok-2-1212.mdx",
      "fileName": "grok-2-1212.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-2-1212"
    },
    "title": "Grok 2 (Dec '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "grok-2-1212",
    "readingTime": "0 min read"
  },
  {
    "content": "Grok-2 is xAI's latest large language model, built as a step up from Grok-1.5. It beats GPT-4 Turbo, Claude 3.5, and other frontier systems on benchmarks such as MMLU, GPQA, MATH, and HumanEval, all while handling 128 k-token contexts at ≈67 tokens/second.\n\nFor developers, Grok-2 offers top-tier performance at $5 input / $15 output per million tokens through an upcoming, multi-region enterprise API that includes MFA, granular usage analytics, and team-management endpoints. If you need a fast, cost-efficient model that can drop into production and tap real-time data from X, Grok-2 is built for you.",
    "name": "Grok 2 Beta",
    "release_date": new Date("2024-08-13T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/news/grok-2",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 37.54,
      "math_index": 42,
      "coding_index": 26.82,
      "benchmarks": {
        "mmlu_pro": 0.703,
        "gpqa": 0.471,
        "hle": 0.047,
        "scicode": 0.295,
        "aime": 0.103,
        "math_500": 0.737,
        "livecodebench": 0.241,
        "humaneval": 0.866
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 5,
        "output": 15,
        "blended_3_to_1": 7.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 67.46,
      "time_to_first_token_ms": 0.34,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.75,
        "input_time_seconds": 0.34,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.41
      }
    },
    "_meta": {
      "filePath": "grok-2.mdx",
      "fileName": "grok-2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-2"
    },
    "title": "Grok 2 Beta",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var p=Object.getOwnPropertyDescriptor;var h=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,g=Object.prototype.hasOwnProperty;var k=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),x=(n,e)=>{for(var a in e)r(n,a,{get:e[a],enumerable:!0})},i=(n,e,a,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let o of h(e))!g.call(n,o)&&o!==a&&r(n,o,{get:()=>e[o],enumerable:!(s=p(e,o))||s.enumerable});return n};var M=(n,e,a)=>(a=n!=null?d(f(n)):{},i(e||!n||!n.__esModule?r(a,\"default\",{value:n,enumerable:!0}):a,n)),_=n=>i(r({},\"__esModule\",{value:!0}),n);var u=k((j,l)=>{l.exports=_jsx_runtime});var b={};x(b,{default:()=>m});var t=M(u());function c(n){let e={a:\"a\",p:\"p\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(e.p,{children:[\"Grok-2 is xAI's latest large language model, built as a step up from Grok-1.5. It beats GPT-4 Turbo, Claude 3.5, and other frontier systems on benchmarks such as MMLU, GPQA, MATH, and \",(0,t.jsx)(e.a,{href:\"/benchmarks/humaneval\",children:\"HumanEval\"}),\", all while handling 128 k-token contexts at \\u224867 tokens/second.\"]}),`\n`,(0,t.jsxs)(e.p,{children:[\"For developers, \",(0,t.jsx)(e.a,{href:\"/assistants/grok\",children:\"Grok\"}),\"-2 offers top-tier performance at $5 input / $15 output per million tokens through an upcoming, multi-region enterprise API that includes MFA, granular usage analytics, and team-management endpoints. If you need a fast, cost-efficient model that can drop into production and tap real-time data from X, Grok-2 is built for you.\"]})]})}function m(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(c,{...n})}):c(n)}return _(b);})();\n;return Component;",
    "slug": "grok-2",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Grok 3 mini Reasoning (Low)",
    "release_date": new Date("2025-02-19T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": null,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.3,
        "output": 0.5,
        "blended_3_to_1": 0.35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 196.6,
      "time_to_first_token_ms": 0.32,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 13.03,
        "input_time_seconds": 0.32,
        "reasoning_time_seconds": 10.17,
        "answer_time_seconds": 2.54
      }
    },
    "_meta": {
      "filePath": "grok-3-mini-reasoning-low.mdx",
      "fileName": "grok-3-mini-reasoning-low.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-3-mini-reasoning-low"
    },
    "title": "Grok 3 mini Reasoning (Low)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "grok-3-mini-reasoning-low",
    "readingTime": "0 min read"
  },
  {
    "content": "# Grok 3 mini Reasoning (high)",
    "name": "Grok 3 mini Reasoning (high)",
    "release_date": new Date("2025-02-19T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 66.67,
      "math_index": 96.27,
      "coding_index": 55.13,
      "benchmarks": {
        "mmlu_pro": 0.828,
        "gpqa": 0.791,
        "hle": 0.111,
        "scicode": 0.406,
        "aime": 0.933,
        "math_500": 0.992,
        "livecodebench": 0.696,
        "humaneval": 0.978
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.3,
        "output": 0.5,
        "blended_3_to_1": 0.35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 209.18,
      "time_to_first_token_ms": 0.32,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 12.27,
        "input_time_seconds": 0.32,
        "reasoning_time_seconds": 9.56,
        "answer_time_seconds": 2.39
      }
    },
    "aider": {
      "correct": 34.7,
      "cost": 0.79,
      "price_per_input_token": null,
      "correct_edit_format": 100
    },
    "_meta": {
      "filePath": "grok-3-mini-reasoning.mdx",
      "fileName": "grok-3-mini-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-3-mini-reasoning"
    },
    "title": "Grok 3 mini Reasoning (high)",
    "body": "var Component=(()=>{var u=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),g=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},i=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let s of d(t))!j.call(n,s)&&s!==e&&r(n,s,{get:()=>t[s],enumerable:!(a=_(t,s))||a.enumerable});return n};var M=(n,t,e)=>(e=n!=null?u(f(n)):{},i(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),k=n=>i(r({},\"__esModule\",{value:!0}),n);var h=l((D,c)=>{c.exports=_jsx_runtime});var p={};g(p,{default:()=>m});var o=M(h());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/assistants/grok\",children:\"Grok\"}),\" 3 mini Reasoning (high)\"]})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(x,{...n})}):x(n)}return k(p);})();\n;return Component;",
    "slug": "grok-3-mini-reasoning",
    "readingTime": "1 min read"
  },
  {
    "content": "# Grok 3 Reasoning Beta",
    "name": "Grok 3 Reasoning Beta",
    "release_date": new Date("2025-02-17T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 56.099998474121094,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "grok-3-reasoning-beta.mdx",
      "fileName": "grok-3-reasoning-beta.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-3-reasoning-beta"
    },
    "title": "Grok 3 Reasoning Beta",
    "body": "var Component=(()=>{var m=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let s of d(t))!j.call(n,s)&&s!==e&&r(n,s,{get:()=>t[s],enumerable:!(a=_(t,s))||a.enumerable});return n};var g=(n,t,e)=>(e=n!=null?m(f(n)):{},c(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),k=n=>c(r({},\"__esModule\",{value:!0}),n);var x=l((D,i)=>{i.exports=_jsx_runtime});var p={};M(p,{default:()=>u});var o=g(x());function h(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/assistants/grok\",children:\"Grok\"}),\" 3 Reasoning Beta\"]})}function u(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(h,{...n})}):h(n)}return k(p);})();\n;return Component;",
    "slug": "grok-3-reasoning-beta",
    "readingTime": "1 min read"
  },
  {
    "content": "# Grok 3",
    "name": "Grok 3",
    "release_date": new Date("2025-02-19T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 50.63,
      "math_index": 60,
      "coding_index": 39.67,
      "benchmarks": {
        "mmlu_pro": 0.799,
        "gpqa": 0.693,
        "hle": 0.051,
        "scicode": 0.368,
        "aime": 0.33,
        "math_500": 0.87,
        "livecodebench": 0.425,
        "humaneval": 0.909
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 88.79,
      "time_to_first_token_ms": 0.44,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.07,
        "input_time_seconds": 0.44,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.63
      }
    },
    "aider": {
      "correct": 53.3,
      "cost": 11.03,
      "price_per_input_token": null,
      "correct_edit_format": 99.6
    },
    "_meta": {
      "filePath": "grok-3.mdx",
      "fileName": "grok-3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-3"
    },
    "title": "Grok 3",
    "body": "var Component=(()=>{var m=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let s of d(t))!j.call(n,s)&&s!==e&&r(n,s,{get:()=>t[s],enumerable:!(a=_(t,s))||a.enumerable});return n};var k=(n,t,e)=>(e=n!=null?m(f(n)):{},c(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>c(r({},\"__esModule\",{value:!0}),n);var x=l((X,i)=>{i.exports=_jsx_runtime});var C={};M(C,{default:()=>u});var o=k(x());function h(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/assistants/grok\",children:\"Grok\"}),\" 3\"]})}function u(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(h,{...n})}):h(n)}return p(C);})();\n;return Component;",
    "slug": "grok-3",
    "readingTime": "1 min read"
  },
  {
    "content": "# Grok 4\n\nGrok 4 is xAI's flagship LLM with a 256k window, top reasoning benchmarks, and\nmoderately fast 75 token-per-second output.\n\nGrok 4 is an RL-optimized next variant of the Grok 3 base model.",
    "name": "Grok 4",
    "release_date": new Date("2025-07-10T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 256000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 73,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.87,
        "gpqa": 0.88,
        "hle": 0.386,
        "scicode": null,
        "aime": 0.94,
        "math_500": null,
        "livecodebench": 0.793,
        "humaneval": 0.98
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 75,
      "time_to_first_token_ms": 5.92,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 12.5,
        "input_time_seconds": 5.9,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.6
      }
    },
    "_meta": {
      "filePath": "grok-4.mdx",
      "fileName": "grok-4.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-4"
    },
    "title": "Grok 4",
    "body": "var Component=(()=>{var p=Object.create;var a=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var x=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,u=Object.prototype.hasOwnProperty;var k=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),_=(e,n)=>{for(var o in n)a(e,o,{get:n[o],enumerable:!0})},i=(e,n,o,s)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let r of x(n))!u.call(e,r)&&r!==o&&a(e,r,{get:()=>n[r],enumerable:!(s=l(n,r))||s.enumerable});return e};var g=(e,n,o)=>(o=e!=null?p(f(e)):{},i(n||!e||!e.__esModule?a(o,\"default\",{value:e,enumerable:!0}):o,e)),j=e=>i(a({},\"__esModule\",{value:!0}),e);var h=k((L,c)=>{c.exports=_jsx_runtime});var w={};_(w,{default:()=>m});var t=g(h());function d(e){let n={a:\"a\",h1:\"h1\",p:\"p\",...e.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(n.h1,{children:[(0,t.jsx)(n.a,{href:\"/assistants/grok\",children:\"Grok\"}),\" 4\"]}),`\n`,(0,t.jsxs)(n.p,{children:[\"Grok 4 is \",(0,t.jsx)(n.a,{href:\"/companies/xai\",children:\"xAI\"}),`'s flagship LLM with a 256k window, top reasoning benchmarks, and\nmoderately fast 75 token-per-second output.`]}),`\n`,(0,t.jsx)(n.p,{children:\"Grok 4 is an RL-optimized next variant of the Grok 3 base model.\"})]})}function m(e={}){let{wrapper:n}=e.components||{};return n?(0,t.jsx)(n,{...e,children:(0,t.jsx)(d,{...e})}):d(e)}return j(w);})();\n;return Component;",
    "slug": "grok-4",
    "readingTime": "1 min read"
  },
  {
    "content": "# Grok Beta\n\nGrok is xAI's witty assistant modeled on the Hitchhiker's Guide with real-time X data and a rebellious tone[^1]. It tackles questions most models refuse and is still an early beta built in two months.\n\nThe Grok-1 engine powers the system using custom Kubernetes, Rust, and JAX infrastructure. It scored 73% on MMLU and 63.2% on HumanEval while early U.S. access remains waitlist only.\n\n## References\n\n[^1]: https://x.ai/news/grok",
    "name": "Grok Beta",
    "release_date": new Date("2023-11-04T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "xAI",
      "url": "https://x.ai/news/grok",
      "logo_url": "/logos/xai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 27.54,
      "math_index": 42,
      "coding_index": 26.82,
      "benchmarks": {
        "mmlu_pro": 0.73,
        "gpqa": 0.471,
        "hle": 0.047,
        "scicode": 0.295,
        "aime": 0.103,
        "math_500": 0.737,
        "livecodebench": 0.241,
        "humaneval": 0.632
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 5,
        "output": 15,
        "blended_3_to_1": 7.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 67.46,
      "time_to_first_token_ms": 0.34,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.75,
        "input_time_seconds": 0.34,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.41
      }
    },
    "_meta": {
      "filePath": "grok-beta.mdx",
      "fileName": "grok-beta.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok-beta"
    },
    "title": "Grok Beta",
    "body": "var Component=(()=>{var f=Object.create;var s=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var p=Object.getPrototypeOf,b=Object.prototype.hasOwnProperty;var x=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),k=(n,e)=>{for(var r in e)s(n,r,{get:e[r],enumerable:!0})},i=(n,e,r,o)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of m(e))!b.call(n,a)&&a!==r&&s(n,a,{get:()=>e[a],enumerable:!(o=u(e,a))||o.enumerable});return n};var w=(n,e,r)=>(r=n!=null?f(p(n)):{},i(e||!n||!n.__esModule?s(r,\"default\",{value:n,enumerable:!0}):r,n)),y=n=>i(s({},\"__esModule\",{value:!0}),n);var l=x((j,c)=>{c.exports=_jsx_runtime});var _={};k(_,{default:()=>d});var t=w(l());function h(n){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(e.h1,{children:[(0,t.jsx)(e.a,{href:\"/assistants/grok\",children:\"Grok\"}),\" Beta\"]}),`\n`,(0,t.jsxs)(e.p,{children:[\"Grok is \",(0,t.jsx)(e.a,{href:\"/companies/xai\",children:\"xAI\"}),\"'s witty assistant modeled on the Hitchhiker's Guide with real-time X data and a rebellious tone\",(0,t.jsx)(e.sup,{children:(0,t.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})}),\". It tackles questions most models refuse and is still an early beta built in two months.\"]}),`\n`,(0,t.jsxs)(e.p,{children:[\"The Grok-1 engine powers the system using custom Kubernetes, Rust, and JAX infrastructure. It scored 73% on MMLU and 63.2% on \",(0,t.jsx)(e.a,{href:\"/benchmarks/humaneval\",children:\"HumanEval\"}),\" while early U.S. access remains waitlist only.\"]}),`\n`,(0,t.jsx)(e.h2,{children:\"References\"}),`\n`,(0,t.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,t.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,t.jsxs)(e.ol,{children:[`\n`,(0,t.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,t.jsxs)(e.p,{children:[(0,t.jsx)(e.a,{href:\"https://x.ai/news/grok\",children:\"x.ai\"}),\" \",(0,t.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function d(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(h,{...n})}):h(n)}return y(_);})();\n;return Component;",
    "slug": "grok-beta",
    "readingTime": "1 min read"
  },
  {
    "content": "# Jamba 1.5 Large",
    "name": "Jamba 1.5 Large",
    "release_date": new Date("2024-08-22T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "AI21 Labs",
      "url": "https://www.ai21.com/",
      "logo_url": "/logos/ai21.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 29.31,
      "math_index": 32.63,
      "coding_index": 15.3,
      "benchmarks": {
        "mmlu_pro": 0.572,
        "gpqa": 0.427,
        "hle": 0.04,
        "scicode": 0.163,
        "aime": 0.047,
        "math_500": 0.606,
        "livecodebench": 0.143,
        "humaneval": 0.239
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 8,
        "blended_3_to_1": 3.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "jamba-1-5-large.mdx",
      "fileName": "jamba-1-5-large.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "jamba-1-5-large"
    },
    "title": "Jamba 1.5 Large",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>m(r({},\"__esModule\",{value:!0}),n);var u=l((X,s)=>{s.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(u());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Jamba 1.5 Large\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "jamba-1-5-large",
    "readingTime": "1 min read"
  },
  {
    "content": "# Jamba 1.5 Mini",
    "name": "Jamba 1.5 Mini",
    "release_date": new Date("2024-08-22T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "AI21 Labs",
      "url": "https://www.ai21.com/",
      "logo_url": "/logos/ai21.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 18.41,
      "math_index": 18.33,
      "coding_index": 7.11,
      "benchmarks": {
        "mmlu_pro": 0.371,
        "gpqa": 0.302,
        "hle": 0.051,
        "scicode": 0.08,
        "aime": 0.01,
        "math_500": 0.357,
        "livecodebench": 0.062,
        "humaneval": 0.627
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.4,
        "blended_3_to_1": 0.25
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "jamba-1-5-mini.mdx",
      "fileName": "jamba-1-5-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "jamba-1-5-mini"
    },
    "title": "Jamba 1.5 Mini",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!M.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var s=j((b,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>x});var c=p(s());function u(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Jamba 1.5 Mini\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(u,{...n})}):u(n)}return C(D);})();\n;return Component;",
    "slug": "jamba-1-5-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "# Jamba 1.6 Large",
    "name": "Jamba 1.6 Large",
    "release_date": new Date("2025-03-06T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "AI21 Labs",
      "url": "https://www.ai21.com/",
      "logo_url": "/logos/ai21.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 28.81,
      "math_index": 31.33,
      "coding_index": 17.83,
      "benchmarks": {
        "mmlu_pro": 0.565,
        "gpqa": 0.387,
        "hle": 0.04,
        "scicode": 0.184,
        "aime": 0.047,
        "math_500": 0.58,
        "livecodebench": 0.172,
        "humaneval": 0.7
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 8,
        "blended_3_to_1": 3.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 53,
      "time_to_first_token_ms": 0.81,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 10.25,
        "input_time_seconds": 0.81,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.43
      }
    },
    "_meta": {
      "filePath": "jamba-1-6-large.mdx",
      "fileName": "jamba-1-6-large.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "jamba-1-6-large"
    },
    "title": "Jamba 1.6 Large",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>m(r({},\"__esModule\",{value:!0}),n);var u=l((X,s)=>{s.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(u());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Jamba 1.6 Large\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "jamba-1-6-large",
    "readingTime": "1 min read"
  },
  {
    "content": "# Jamba 1.6 Mini",
    "name": "Jamba 1.6 Mini",
    "release_date": new Date("2025-03-06T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 256000,
    "creator": {
      "name": "AI21 Labs",
      "url": "https://www.ai21.com/",
      "logo_url": "/logos/ai21.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 17.66,
      "math_index": 14.5,
      "coding_index": 8.58,
      "benchmarks": {
        "mmlu_pro": 0.367,
        "gpqa": 0.3,
        "hle": 0.046,
        "scicode": 0.101,
        "aime": 0.033,
        "math_500": 0.257,
        "livecodebench": 0.071,
        "humaneval": 0.427
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.4,
        "blended_3_to_1": 0.25
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 202.53,
      "time_to_first_token_ms": 0.63,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.1,
        "input_time_seconds": 0.63,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.47
      }
    },
    "_meta": {
      "filePath": "jamba-1-6-mini.mdx",
      "fileName": "jamba-1-6-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "jamba-1-6-mini"
    },
    "title": "Jamba 1.6 Mini",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!M.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var s=j((b,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>x});var c=p(s());function u(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Jamba 1.6 Mini\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(u,{...n})}):u(n)}return C(D);})();\n;return Component;",
    "slug": "jamba-1-6-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "# Jamba Instruct",
    "name": "Jamba Instruct",
    "release_date": new Date("2024-05-02T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 256000,
    "creator": {
      "name": "AI21 Labs",
      "url": "https://www.ai21.com/",
      "logo_url": "/logos/ai21.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 26.299999237060547,
      "math_index": null,
      "coding_index": 6.44,
      "benchmarks": {
        "mmlu_pro": 0.343,
        "gpqa": 0.271,
        "hle": 0.052,
        "scicode": 0.083,
        "aime": null,
        "math_500": 0.243,
        "livecodebench": 0.046,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "jamba-instruct.mdx",
      "fileName": "jamba-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "jamba-instruct"
    },
    "title": "Jamba Instruct",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=l((b,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Jamba Instruct\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "jamba-instruct",
    "readingTime": "1 min read"
  },
  {
    "content": "# LFM 40B",
    "name": "LFM 40B",
    "release_date": new Date("2024-09-30T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Liquid AI",
      "url": "https://www.liquid.ai",
      "logo_url": "/logos/liquidai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 21.73,
      "math_index": 25.17,
      "coding_index": 8.34,
      "benchmarks": {
        "mmlu_pro": 0.425,
        "gpqa": 0.327,
        "hle": 0.049,
        "scicode": 0.071,
        "aime": 0.023,
        "math_500": 0.48,
        "livecodebench": 0.096,
        "humaneval": 0.505
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.15,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 160.57,
      "time_to_first_token_ms": 0.16,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.27,
        "input_time_seconds": 0.16,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.11
      }
    },
    "_meta": {
      "filePath": "lfm-40b.mdx",
      "fileName": "lfm-40b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "lfm-40b"
    },
    "title": "LFM 40B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!M.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,i)=>{i.exports=_jsx_runtime});var D={};l(D,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"LFM 40B\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "lfm-40b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 13B\n\nFirst release of Meta's Llama models with open weights, offering 13B parameters alongside the larger 65B variant.[^1][^2][^3][^4]\n\n## References\n[^1]: Meta. 'Introducing LLaMA: A foundational, 65-billion-parameter language model.' February 24, 2023.\n[^2]: Touvron, Hugo, et al. 'LLaMA: Open and Efficient Foundation Language Models.' arXiv, 27 Feb 2023.\n[^3]: Meta AI, 'Llama models README,' GitHub.\n[^4]: Wikipedia, 'Llama (language model).' February 24, 2023.",
    "name": "Llama 13B",
    "release_date": new Date("2023-02-24T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 2048,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 11,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "llama-13b.mdx",
      "fileName": "llama-13b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-13b"
    },
    "title": "Llama 13B",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var b=Object.getOwnPropertyNames;var m=Object.getPrototypeOf,p=Object.prototype.hasOwnProperty;var g=(a,e)=>()=>(e||a((e={exports:{}}).exports,e),e.exports),k=(a,e)=>{for(var t in e)o(a,t,{get:e[t],enumerable:!0})},i=(a,e,t,c)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let r of b(e))!p.call(a,r)&&r!==t&&o(a,r,{get:()=>e[r],enumerable:!(c=u(e,r))||c.enumerable});return a};var L=(a,e,t)=>(t=a!=null?h(m(a)):{},i(e||!a||!a.__esModule?o(t,\"default\",{value:a,enumerable:!0}):t,a)),M=a=>i(o({},\"__esModule\",{value:!0}),a);var f=g((B,l)=>{l.exports=_jsx_runtime});var x={};k(x,{default:()=>s});var n=L(f());function d(a){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...a.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:\"Llama 13B\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"First release of Meta's Llama models with open weights, offering 13B parameters alongside the larger 65B variant.\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-2\",id:\"user-content-fnref-2\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"2\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-3\",id:\"user-content-fnref-3\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"3\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-4\",id:\"user-content-fnref-4\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"4\"})})]}),`\n`,(0,n.jsx)(e.h2,{children:\"References\"}),`\n`,(0,n.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,n.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,n.jsxs)(e.p,{children:[\"Meta. 'Introducing LLaMA: A foundational, 65-billion-parameter language model.' February 24, 2023. \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-2\",children:[`\n`,(0,n.jsxs)(e.p,{children:[\"Touvron, Hugo, et al. 'LLaMA: Open and Efficient Foundation Language Models.' arXiv, 27 Feb 2023. \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-2\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 2\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-3\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"/assistants/meta-ai\",children:\"Meta AI\"}),\", 'Llama models README,' GitHub. \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-3\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 3\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-4\",children:[`\n`,(0,n.jsxs)(e.p,{children:[\"Wikipedia, 'Llama (language model).' February 24, 2023. \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-4\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 4\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function s(a={}){let{wrapper:e}=a.components||{};return e?(0,n.jsx)(e,{...a,children:(0,n.jsx)(d,{...a})}):d(a)}return M(x);})();\n;return Component;",
    "slug": "llama-13b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 2 Chat 7B",
    "name": "Llama 2 Chat 7B",
    "release_date": new Date("2023-07-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4096,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 8.25,
      "math_index": 2.93,
      "coding_index": 0.11,
      "benchmarks": {
        "mmlu_pro": 0.164,
        "gpqa": 0.227,
        "hle": 0.058,
        "scicode": 0,
        "aime": 0,
        "math_500": 0.059,
        "livecodebench": 0.002,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.05,
        "output": 0.25,
        "blended_3_to_1": 0.1
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 130.6,
      "time_to_first_token_ms": 0.42,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.24,
        "input_time_seconds": 0.42,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.83
      }
    },
    "_meta": {
      "filePath": "llama-2-chat-7b.mdx",
      "fileName": "llama-2-chat-7b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-2-chat-7b"
    },
    "title": "Llama 2 Chat 7B",
    "body": "var Component=(()=>{var x=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var M=(n,t,e)=>(e=n!=null?x(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>m(r({},\"__esModule\",{value:!0}),n);var u=j((X,s)=>{s.exports=_jsx_runtime});var D={};C(D,{default:()=>i});var c=M(u());function h(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 2 Chat 7B\"})}function i(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(h,{...n})}):h(n)}return p(D);})();\n;return Component;",
    "slug": "llama-2-chat-7b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 2\n\nMeta released Llama 2 under a community license with 7B, 13B, and 70B models for researchers and businesses[^1][^2]. Major clouds quickly hosted the 7B variant[^3][^4], and the weights remain on Hugging Face[^5].\n\n## References\n[^1]: https://raw.githubusercontent.com/facebookresearch/llama/main/README.md\n[^2]: https://raw.githubusercontent.com/facebookresearch/llama/main/LICENSE\n[^3]: https://cloud.google.com/blog/topics/developers-practitioners/llama-2-coming-to-google-cloud\n[^4]: https://ai.meta.com/blog/llama-2/\n[^5]: https://huggingface.co/blog/llama2",
    "name": "Llama 2",
    "release_date": new Date("2023-07-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4096,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "_meta": {
      "filePath": "llama-2.mdx",
      "fileName": "llama-2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-2"
    },
    "title": "Llama 2",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var b=Object.getOwnPropertyNames;var m=Object.getPrototypeOf,g=Object.prototype.hasOwnProperty;var p=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),k=(t,e)=>{for(var r in e)o(t,r,{get:e[r],enumerable:!0})},l=(t,e,r,c)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of b(e))!g.call(t,a)&&a!==r&&o(t,a,{get:()=>e[a],enumerable:!(c=u(e,a))||c.enumerable});return t};var y=(t,e,r)=>(r=t!=null?h(m(t)):{},l(e||!t||!t.__esModule?o(r,\"default\",{value:t,enumerable:!0}):r,t)),B=t=>l(o({},\"__esModule\",{value:!0}),t);var f=p((w,i)=>{i.exports=_jsx_runtime});var x={};k(x,{default:()=>d});var n=y(f());function s(t){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:\"Llama 2\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"Meta released Llama 2 under a community license with 7B, 13B, and 70B models for researchers and businesses\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-2\",id:\"user-content-fnref-2\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"2\"})}),\". Major clouds quickly hosted the 7B variant\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-3\",id:\"user-content-fnref-3\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"3\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-4\",id:\"user-content-fnref-4\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"4\"})}),\", and the weights remain on Hugging Face\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-5\",id:\"user-content-fnref-5\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"5\"})}),\".\"]}),`\n`,(0,n.jsx)(e.h2,{children:\"References\"}),`\n`,(0,n.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,n.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://raw.githubusercontent.com/facebookresearch/llama/main/README.md\",children:\"raw.githubusercontent.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-2\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://raw.githubusercontent.com/facebookresearch/llama/main/LICENSE\",children:\"raw.githubusercontent.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-2\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 2\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-3\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://cloud.google.com/blog/topics/developers-practitioners/llama-2-coming-to-google-cloud\",children:\"cloud.google.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-3\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 3\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-4\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://ai.meta.com/blog/llama-2/\",children:\"ai.meta.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-4\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 4\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-5\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://huggingface.co/blog/llama2\",children:\"huggingface.co\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-5\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 5\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function d(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(s,{...t})}):s(t)}return B(x);})();\n;return Component;",
    "slug": "llama-2",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3.1 Instruct 405B",
    "name": "Llama 3.1 Instruct 405B",
    "release_date": new Date("2024-07-23T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.49,
      "math_index": 45.83,
      "coding_index": 30.17,
      "benchmarks": {
        "mmlu_pro": 0.732,
        "gpqa": 0.515,
        "hle": 0.042,
        "scicode": 0.299,
        "aime": 0.213,
        "math_500": 0.703,
        "livecodebench": 0.305,
        "humaneval": 0.854
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3.5,
        "output": 3.5,
        "blended_3_to_1": 3.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 33.21,
      "time_to_first_token_ms": 0.66,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 15.72,
        "input_time_seconds": 0.66,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 15.06
      }
    },
    "_meta": {
      "filePath": "llama-3-1-instruct-405b.mdx",
      "fileName": "llama-3-1-instruct-405b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-1-instruct-405b"
    },
    "title": "Llama 3.1 Instruct 405B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.1 Instruct 405B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-1-instruct-405b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3.1 Instruct 70B",
    "name": "Llama 3.1 Instruct 70B",
    "release_date": new Date("2024-07-23T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.38,
      "math_index": 41.13,
      "coding_index": 24.96,
      "benchmarks": {
        "mmlu_pro": 0.676,
        "gpqa": 0.409,
        "hle": 0.046,
        "scicode": 0.267,
        "aime": 0.173,
        "math_500": 0.649,
        "livecodebench": 0.232,
        "humaneval": 0.812
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.72,
        "output": 0.72,
        "blended_3_to_1": 0.72
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 60.03,
      "time_to_first_token_ms": 0.43,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.76,
        "input_time_seconds": 0.43,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 8.33
      }
    },
    "_meta": {
      "filePath": "llama-3-1-instruct-70b.mdx",
      "fileName": "llama-3-1-instruct-70b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-1-instruct-70b"
    },
    "title": "Llama 3.1 Instruct 70B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.1 Instruct 70B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-1-instruct-70b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3.1 Instruct 8B",
    "name": "Llama 3.1 Instruct 8B",
    "release_date": new Date("2024-07-23T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 23.66,
      "math_index": 29.8,
      "coding_index": 12.42,
      "benchmarks": {
        "mmlu_pro": 0.476,
        "gpqa": 0.259,
        "hle": 0.051,
        "scicode": 0.132,
        "aime": 0.077,
        "math_500": 0.519,
        "livecodebench": 0.116,
        "humaneval": 0.665
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.1,
        "blended_3_to_1": 0.1
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 215.28,
      "time_to_first_token_ms": 0.29,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.61,
        "input_time_seconds": 0.29,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.32
      }
    },
    "_meta": {
      "filePath": "llama-3-1-instruct-8b.mdx",
      "fileName": "llama-3-1-instruct-8b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-1-instruct-8b"
    },
    "title": "Llama 3.1 Instruct 8B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.1 Instruct 8B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-1-instruct-8b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3.1 Nemotron Instruct 70B",
    "name": "Llama 3.1 Nemotron Instruct 70B",
    "release_date": new Date("2024-10-15T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "NVIDIA",
      "url": "https://www.nvidia.com/",
      "logo_url": "/logos/nvidia.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 37.28,
      "math_index": 48.97,
      "coding_index": 20.1,
      "benchmarks": {
        "mmlu_pro": 0.69,
        "gpqa": 0.465,
        "hle": 0.046,
        "scicode": 0.233,
        "aime": 0.247,
        "math_500": 0.733,
        "livecodebench": 0.169,
        "humaneval": 0.815
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.12,
        "output": 0.3,
        "blended_3_to_1": 0.165
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 41.15,
      "time_to_first_token_ms": 0.53,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 12.68,
        "input_time_seconds": 0.53,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 12.15
      }
    },
    "_meta": {
      "filePath": "llama-3-1-nemotron-instruct-70b.mdx",
      "fileName": "llama-3-1-nemotron-instruct-70b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-1-nemotron-instruct-70b"
    },
    "title": "Llama 3.1 Nemotron Instruct 70B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,m)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(m=_(t,o))||m.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=j((X,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(a());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.1 Nemotron Instruct 70B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-1-nemotron-instruct-70b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Llama 3.1 Nemotron Ultra 253B v1 (Reasoning)",
    "release_date": new Date("2025-04-07T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "NVIDIA",
      "url": "https://www.nvidia.com/",
      "logo_url": "/logos/nvidia.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 60.82,
      "math_index": 84.93,
      "coding_index": 49.42,
      "benchmarks": {
        "mmlu_pro": 0.825,
        "gpqa": 0.728,
        "hle": 0.081,
        "scicode": 0.347,
        "aime": 0.747,
        "math_500": 0.952,
        "livecodebench": 0.641,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.6,
        "output": 1.8,
        "blended_3_to_1": 0.9
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 42.72,
      "time_to_first_token_ms": 0.65,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 59.17,
        "input_time_seconds": 0.65,
        "reasoning_time_seconds": 46.81,
        "answer_time_seconds": 11.7
      }
    },
    "_meta": {
      "filePath": "llama-3-1-nemotron-ultra-253b-v1-reasoning.mdx",
      "fileName": "llama-3-1-nemotron-ultra-253b-v1-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-1-nemotron-ultra-253b-v1-reasoning"
    },
    "title": "Llama 3.1 Nemotron Ultra 253B v1 (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "llama-3-1-nemotron-ultra-253b-v1-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Llama 3.2 Instruct 11B (Vision)",
    "release_date": new Date("2024-09-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 25.040000915527344,
      "math_index": 30.47,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.464,
        "gpqa": 0.221,
        "hle": 0.052,
        "scicode": null,
        "aime": 0.093,
        "math_500": 0.516,
        "livecodebench": 0.11,
        "humaneval": 0.687
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.16,
        "output": 0.16,
        "blended_3_to_1": 0.16
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 104.98,
      "time_to_first_token_ms": 0.42,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.19,
        "input_time_seconds": 0.42,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.76
      }
    },
    "_meta": {
      "filePath": "llama-3-2-instruct-11b-vision.mdx",
      "fileName": "llama-3-2-instruct-11b-vision.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-2-instruct-11b-vision"
    },
    "title": "Llama 3.2 Instruct 11B (Vision)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "llama-3-2-instruct-11b-vision",
    "readingTime": "0 min read"
  },
  {
    "content": "# Llama 3.2 Instruct 1B",
    "name": "Llama 3.2 Instruct 1B",
    "release_date": new Date("2024-09-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 9.69,
      "math_index": 7,
      "coding_index": 1.82,
      "benchmarks": {
        "mmlu_pro": 0.2,
        "gpqa": 0.196,
        "hle": 0.053,
        "scicode": 0.017,
        "aime": 0,
        "math_500": 0.14,
        "livecodebench": 0.019,
        "humaneval": 0.402
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.04,
        "output": 0.08,
        "blended_3_to_1": 0.05
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 176.72,
      "time_to_first_token_ms": 0.29,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.12,
        "input_time_seconds": 0.29,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.83
      }
    },
    "_meta": {
      "filePath": "llama-3-2-instruct-1b.mdx",
      "fileName": "llama-3-2-instruct-1b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-2-instruct-1b"
    },
    "title": "Llama 3.2 Instruct 1B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.2 Instruct 1B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-2-instruct-1b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3.2 Instruct 3B",
    "name": "Llama 3.2 Instruct 3B",
    "release_date": new Date("2024-09-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.52,
      "math_index": 27.77,
      "coding_index": 6.73,
      "benchmarks": {
        "mmlu_pro": 0.347,
        "gpqa": 0.255,
        "hle": 0.052,
        "scicode": 0.052,
        "aime": 0.067,
        "math_500": 0.489,
        "livecodebench": 0.083,
        "humaneval": 0.557
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.045,
        "output": 0.055,
        "blended_3_to_1": 0.0475
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 114.65,
      "time_to_first_token_ms": 0.37,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.73,
        "input_time_seconds": 0.37,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.36
      }
    },
    "_meta": {
      "filePath": "llama-3-2-instruct-3b.mdx",
      "fileName": "llama-3-2-instruct-3b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-2-instruct-3b"
    },
    "title": "Llama 3.2 Instruct 3B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.2 Instruct 3B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-2-instruct-3b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Llama 3.2 Instruct 90B (Vision)",
    "release_date": new Date("2024-09-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.37,
      "math_index": 33.97,
      "coding_index": 22.67,
      "benchmarks": {
        "mmlu_pro": 0.671,
        "gpqa": 0.432,
        "hle": 0.049,
        "scicode": 0.24,
        "aime": 0.05,
        "math_500": 0.629,
        "livecodebench": 0.214,
        "humaneval": 0.82
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.72,
        "output": 0.72,
        "blended_3_to_1": 0.72
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 33.49,
      "time_to_first_token_ms": 0.38,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 15.31,
        "input_time_seconds": 0.38,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 14.93
      }
    },
    "_meta": {
      "filePath": "llama-3-2-instruct-90b-vision.mdx",
      "fileName": "llama-3-2-instruct-90b-vision.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-2-instruct-90b-vision"
    },
    "title": "Llama 3.2 Instruct 90B (Vision)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "llama-3-2-instruct-90b-vision",
    "readingTime": "0 min read"
  },
  {
    "content": "# Llama 3.3 Instruct 70B",
    "name": "Llama 3.3 Instruct 70B",
    "release_date": new Date("2024-12-06T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 41.11,
      "math_index": 53.63,
      "coding_index": 27.41,
      "benchmarks": {
        "mmlu_pro": 0.713,
        "gpqa": 0.498,
        "hle": 0.04,
        "scicode": 0.26,
        "aime": 0.3,
        "math_500": 0.773,
        "livecodebench": 0.288,
        "humaneval": 0.86
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.585,
        "output": 0.705,
        "blended_3_to_1": 0.59
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 113.07,
      "time_to_first_token_ms": 0.43,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.85,
        "input_time_seconds": 0.43,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.42
      }
    },
    "_meta": {
      "filePath": "llama-3-3-instruct-70b.mdx",
      "fileName": "llama-3-3-instruct-70b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-3-instruct-70b"
    },
    "title": "Llama 3.3 Instruct 70B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3.3 Instruct 70B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-3-instruct-70b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3 Instruct 70B",
    "name": "Llama 3 Instruct 70B",
    "release_date": new Date("2024-04-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 27.48,
      "math_index": 24.13,
      "coding_index": 19.32,
      "benchmarks": {
        "mmlu_pro": 0.574,
        "gpqa": 0.379,
        "hle": 0.044,
        "scicode": 0.189,
        "aime": 0,
        "math_500": 0.483,
        "livecodebench": 0.198,
        "humaneval": 0.79
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7250000000000001,
        "output": 0.8400000000000001,
        "blended_3_to_1": 0.8400000000000001
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 45.33,
      "time_to_first_token_ms": 0.44,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.47,
        "input_time_seconds": 0.44,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 11.03
      }
    },
    "_meta": {
      "filePath": "llama-3-instruct-70b.mdx",
      "fileName": "llama-3-instruct-70b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-instruct-70b"
    },
    "title": "Llama 3 Instruct 70B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3 Instruct 70B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-instruct-70b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 3 Instruct 8B",
    "name": "Llama 3 Instruct 8B",
    "release_date": new Date("2024-04-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 21.47,
      "math_index": 24.97,
      "coding_index": 10.78,
      "benchmarks": {
        "mmlu_pro": 0.405,
        "gpqa": 0.296,
        "hle": 0.051,
        "scicode": 0.119,
        "aime": 0,
        "math_500": 0.499,
        "livecodebench": 0.096,
        "humaneval": 0.705
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.060000000000000005,
        "output": 0.14,
        "blended_3_to_1": 0.085
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 102.98,
      "time_to_first_token_ms": 0.34,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.2,
        "input_time_seconds": 0.34,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.86
      }
    },
    "_meta": {
      "filePath": "llama-3-instruct-8b.mdx",
      "fileName": "llama-3-instruct-8b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-3-instruct-8b"
    },
    "title": "Llama 3 Instruct 8B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(m());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 3 Instruct 8B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-3-instruct-8b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 4 Maverick",
    "name": "Llama 4 Maverick",
    "release_date": new Date("2025-04-05T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 50.53,
      "math_index": 63.93,
      "coding_index": 36.39,
      "benchmarks": {
        "mmlu_pro": 0.809,
        "gpqa": 0.671,
        "hle": 0.048,
        "scicode": 0.331,
        "aime": 0.39,
        "math_500": 0.889,
        "livecodebench": 0.397,
        "humaneval": 0.879
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.22,
        "output": 0.85,
        "blended_3_to_1": 0.385
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 163.07,
      "time_to_first_token_ms": 0.34,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.41,
        "input_time_seconds": 0.34,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.07
      }
    },
    "aider": {
      "correct": 15.6,
      "cost": null,
      "price_per_input_token": null,
      "correct_edit_format": 99.1
    },
    "_meta": {
      "filePath": "llama-4-maverick.mdx",
      "fileName": "llama-4-maverick.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-4-maverick"
    },
    "title": "Llama 4 Maverick",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},i=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},i(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>i(r({},\"__esModule\",{value:!0}),n);var s=M((X,m)=>{m.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(s());function u(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 4 Maverick\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(u,{...n})}):u(n)}return C(D);})();\n;return Component;",
    "slug": "llama-4-maverick",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 4 Scout",
    "name": "Llama 4 Scout",
    "release_date": new Date("2025-04-05T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 10000000,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 42.99,
      "math_index": 56.37,
      "coding_index": 23.48,
      "benchmarks": {
        "mmlu_pro": 0.752,
        "gpqa": 0.587,
        "hle": 0.043,
        "scicode": 0.17,
        "aime": 0.283,
        "math_500": 0.844,
        "livecodebench": 0.299,
        "humaneval": 0.826
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.5,
        "blended_3_to_1": 0.2625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 130.31,
      "time_to_first_token_ms": 0.37,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.21,
        "input_time_seconds": 0.37,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.84
      }
    },
    "_meta": {
      "filePath": "llama-4-scout.mdx",
      "fileName": "llama-4-scout.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-4-scout"
    },
    "title": "Llama 4 Scout",
    "body": "var Component=(()=>{var h=Object.create;var c=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)c(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,u)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&c(n,o,{get:()=>t[o],enumerable:!(u=_(t,o))||u.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?c(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(c({},\"__esModule\",{value:!0}),n);var s=j((X,m)=>{m.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var r=p(s());function i(n){let t={h1:\"h1\",...n.components};return(0,r.jsx)(t.h1,{children:\"Llama 4 Scout\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,r.jsx)(t,{...n,children:(0,r.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-4-scout",
    "readingTime": "1 min read"
  },
  {
    "content": "# Llama 65B",
    "name": "Llama 65B",
    "release_date": new Date("2023-02-24T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 2048,
    "creator": {
      "name": "Meta",
      "url": "https://ai.meta.com/",
      "logo_url": "/logos/meta.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 11,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "llama-65b.mdx",
      "fileName": "llama-65b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "llama-65b"
    },
    "title": "Llama 65B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(a=_(t,o))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>m(r({},\"__esModule\",{value:!0}),n);var u=j((X,s)=>{s.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(u());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Llama 65B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "llama-65b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "MiniMax M1 40k",
    "release_date": new Date("2025-06-16T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "MiniMax",
      "url": "https://minimaxi.com/",
      "logo_url": "/logos/minimax.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 61.35,
      "math_index": 89.27,
      "coding_index": 51.78,
      "benchmarks": {
        "mmlu_pro": 0.808,
        "gpqa": 0.682,
        "hle": 0.075,
        "scicode": 0.378,
        "aime": 0.813,
        "math_500": 0.972,
        "livecodebench": 0.657,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.4,
        "output": 2.1,
        "blended_3_to_1": 0.825
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 41.13,
      "time_to_first_token_ms": 1.35,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 62.12,
        "input_time_seconds": 1.35,
        "reasoning_time_seconds": 48.62,
        "answer_time_seconds": 12.16
      }
    },
    "_meta": {
      "filePath": "minimax-m1-40k.mdx",
      "fileName": "minimax-m1-40k.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "minimax-m1-40k"
    },
    "title": "MiniMax M1 40k",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "minimax-m1-40k",
    "readingTime": "0 min read"
  },
  {
    "content": "# MiniMax-Text-01",
    "name": "MiniMax-Text-01",
    "release_date": new Date("2025-01-14T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4000000,
    "creator": {
      "name": "MiniMax",
      "url": "https://minimaxi.com/",
      "logo_url": "/logos/minimax.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.23,
      "math_index": 44.17,
      "coding_index": 24.83,
      "benchmarks": {
        "mmlu_pro": 0.759,
        "gpqa": 0.578,
        "hle": 0.042,
        "scicode": 0.25,
        "aime": 0.13,
        "math_500": 0.753,
        "livecodebench": 0.247,
        "humaneval": 0.863
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 1.1,
        "blended_3_to_1": 0.425
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 34.66,
      "time_to_first_token_ms": 0.95,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 15.38,
        "input_time_seconds": 0.95,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 14.43
      }
    },
    "_meta": {
      "filePath": "minimax-text-01.mdx",
      "fileName": "minimax-text-01.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "minimax-text-01"
    },
    "title": "MiniMax-Text-01",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var e in t)s(n,e,{get:t[e],enumerable:!0})},c=(n,t,e,a)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let r of d(t))!j.call(n,r)&&r!==e&&s(n,r,{get:()=>t[r],enumerable:!(a=_(t,r))||a.enumerable});return n};var p=(n,t,e)=>(e=n!=null?u(f(n)):{},c(t||!n||!n.__esModule?s(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>c(s({},\"__esModule\",{value:!0}),n);var x=M((w,i)=>{i.exports=_jsx_runtime});var D={};l(D,{default:()=>h});var o=p(x());function m(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/companies/minimax\",children:\"MiniMax\"}),\"-Text-01\"]})}function h(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "minimax-text-01",
    "readingTime": "1 min read"
  },
  {
    "content": "# Ministral 3B",
    "name": "Ministral 3B",
    "release_date": new Date("2024-10-16T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.62,
      "math_index": 26.83,
      "coding_index": 8.13,
      "benchmarks": {
        "mmlu_pro": 0.339,
        "gpqa": 0.26,
        "hle": 0.055,
        "scicode": 0.094,
        "aime": 0,
        "math_500": 0.537,
        "livecodebench": 0.069,
        "humaneval": 0.739
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.04,
        "output": 0.04,
        "blended_3_to_1": 0.04
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 251.83,
      "time_to_first_token_ms": 0.27,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.25,
        "input_time_seconds": 0.27,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.99
      }
    },
    "_meta": {
      "filePath": "ministral-3b.mdx",
      "fileName": "ministral-3b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "ministral-3b"
    },
    "title": "Ministral 3B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=M((w,u)=>{u.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(a());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Ministral 3B\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "ministral-3b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Mistral 7B Instruct",
    "name": "Mistral 7B Instruct",
    "release_date": new Date("2023-09-27T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 10.14,
      "math_index": 6.07,
      "coding_index": 3.49,
      "benchmarks": {
        "mmlu_pro": 0.245,
        "gpqa": 0.177,
        "hle": 0.043,
        "scicode": 0.024,
        "aime": 0,
        "math_500": 0.121,
        "livecodebench": 0.046,
        "humaneval": 0.402
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.25,
        "output": 0.25,
        "blended_3_to_1": 0.25
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 104.6,
      "time_to_first_token_ms": 0.28,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.06,
        "input_time_seconds": 0.28,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.78
      }
    },
    "_meta": {
      "filePath": "mistral-7b-instruct.mdx",
      "fileName": "mistral-7b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-7b-instruct"
    },
    "title": "Mistral 7B Instruct",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),j=(t,n)=>{for(var e in n)r(t,e,{get:n[e],enumerable:!0})},u=(t,n,e,s)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!l.call(t,o)&&o!==e&&r(t,o,{get:()=>n[o],enumerable:!(s=_(n,o))||s.enumerable});return t};var p=(t,n,e)=>(e=t!=null?h(f(t)):{},u(n||!t||!t.__esModule?r(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>u(r({},\"__esModule\",{value:!0}),t);var a=M((w,i)=>{i.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(a());function m(t){let n={h1:\"h1\",...t.components};return(0,c.jsx)(n.h1,{children:\"Mistral 7B Instruct\"})}function x(t={}){let{wrapper:n}=t.components||{};return n?(0,c.jsx)(n,{...t,children:(0,c.jsx)(m,{...t})}):m(t)}return C(D);})();\n;return Component;",
    "slug": "mistral-7b-instruct",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Mixtral 8x22B Instruct",
    "release_date": new Date("2024-04-17T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 65384,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 26.16,
      "math_index": 27.23,
      "coding_index": 16.78,
      "benchmarks": {
        "mmlu_pro": 0.537,
        "gpqa": 0.332,
        "hle": 0.041,
        "scicode": 0.188,
        "aime": 0,
        "math_500": 0.545,
        "livecodebench": 0.148,
        "humaneval": 0.721
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 6,
        "blended_3_to_1": 3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 44.15,
      "time_to_first_token_ms": 0.33,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.66,
        "input_time_seconds": 0.33,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 11.33
      }
    },
    "_meta": {
      "filePath": "mistral-8x22b-instruct.mdx",
      "fileName": "mistral-8x22b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-8x22b-instruct"
    },
    "title": "Mixtral 8x22B Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "mistral-8x22b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "Mistral Large 2 is a 123 B-parameter language model with a 128 K-token context window, open-weight for research use. It upgrades code generation, math and reasoning to GPT-4-class quality, supports dozens of human languages plus 80+ programming languages, and exposes advanced parallel/serial function calling.\n\nDevelopers can self-host under a research license or tap the cloud API at $2 / $6 per million input/output tokens for long-context chat, RAG or code-assistant workloads—with open weights, single-node inference, and no vendor lock-in.\n\n[Download mistral-large-instruct-2411](https://huggingface.co/mistralai/Mistral-Large-Instruct-2411)",
    "name": "Mistral Large 2 (Nov '24)",
    "release_date": new Date("2024-11-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/mistral-large-2407",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 38.27,
      "math_index": 42.3,
      "coding_index": 29.24,
      "benchmarks": {
        "mmlu_pro": 0.697,
        "gpqa": 0.486,
        "hle": 0.04,
        "scicode": 0.292,
        "aime": 0.11,
        "math_500": 0.736,
        "livecodebench": 0.293,
        "humaneval": 0.898
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 6,
        "blended_3_to_1": 3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 50.97,
      "time_to_first_token_ms": 0.48,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 10.29,
        "input_time_seconds": 0.48,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.81
      }
    },
    "_meta": {
      "filePath": "mistral-large-2.mdx",
      "fileName": "mistral-large-2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-large-2"
    },
    "title": "Mistral Large 2 (Nov '24)",
    "body": "var Component=(()=>{var g=Object.create;var r=Object.defineProperty;var p=Object.getOwnPropertyDescriptor;var h=Object.getOwnPropertyNames;var m=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),w=(n,e)=>{for(var a in e)r(n,a,{get:e[a],enumerable:!0})},i=(n,e,a,s)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let o of h(e))!f.call(n,o)&&o!==a&&r(n,o,{get:()=>e[o],enumerable:!(s=p(e,o))||s.enumerable});return n};var _=(n,e,a)=>(a=n!=null?g(m(n)):{},i(e||!n||!n.__esModule?r(a,\"default\",{value:n,enumerable:!0}):a,n)),j=n=>i(r({},\"__esModule\",{value:!0}),n);var c=x((D,l)=>{l.exports=_jsx_runtime});var M={};w(M,{default:()=>u});var t=_(c());function d(n){let e={a:\"a\",p:\"p\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsx)(e.p,{children:\"Mistral Large 2 is a 123 B-parameter language model with a 128 K-token context window, open-weight for research use. It upgrades code generation, math and reasoning to GPT-4-class quality, supports dozens of human languages plus 80+ programming languages, and exposes advanced parallel/serial function calling.\"}),`\n`,(0,t.jsx)(e.p,{children:\"Developers can self-host under a research license or tap the cloud API at $2 / $6 per million input/output tokens for long-context chat, RAG or code-assistant workloads\\u2014with open weights, single-node inference, and no vendor lock-in.\"}),`\n`,(0,t.jsx)(e.p,{children:(0,t.jsx)(e.a,{href:\"https://huggingface.co/mistralai/Mistral-Large-Instruct-2411\",children:\"Download mistral-large-instruct-2411\"})})]})}function u(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(d,{...n})}):d(n)}return j(M);})();\n;return Component;",
    "slug": "mistral-large-2",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Mistral Large 2 (Jul '24)",
    "release_date": new Date("2024-07-24T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 36.58,
      "math_index": 40.37,
      "coding_index": 26.88,
      "benchmarks": {
        "mmlu_pro": 0.683,
        "gpqa": 0.472,
        "hle": 0.032,
        "scicode": 0.271,
        "aime": 0.093,
        "math_500": 0.714,
        "livecodebench": 0.267,
        "humaneval": 0.888
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 6,
        "blended_3_to_1": 3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 91.25,
      "time_to_first_token_ms": 0.41,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.89,
        "input_time_seconds": 0.41,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.48
      }
    },
    "_meta": {
      "filePath": "mistral-large-2407.mdx",
      "fileName": "mistral-large-2407.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-large-2407"
    },
    "title": "Mistral Large 2 (Jul '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "mistral-large-2407",
    "readingTime": "0 min read"
  },
  {
    "content": "# Mistral Large (Feb '24)",
    "name": "Mistral Large (Feb '24)",
    "release_date": new Date("2024-02-26T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 26.41,
      "math_index": 26.33,
      "coding_index": 19.31,
      "benchmarks": {
        "mmlu_pro": 0.515,
        "gpqa": 0.351,
        "hle": 0.034,
        "scicode": 0.208,
        "aime": 0,
        "math_500": 0.527,
        "livecodebench": 0.178,
        "humaneval": 0.706
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 4,
        "output": 12,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 89.31,
      "time_to_first_token_ms": 0.46,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.06,
        "input_time_seconds": 0.46,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.6
      }
    },
    "_meta": {
      "filePath": "mistral-large.mdx",
      "fileName": "mistral-large.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-large"
    },
    "title": "Mistral Large (Feb '24)",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var u=M((X,i)=>{i.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(u());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Mistral Large (Feb '24)\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "mistral-large",
    "readingTime": "1 min read"
  },
  {
    "content": "Mistral Magistral is a reasoning-tuned large language model, offered as an open-source 24 B-parameter \"Small\" and a higher-end \"Medium\" variant, each handling 128 K-token contexts. It delivers step-by-step answers across eight major languages, scores 73.6 % on AIME-24 and 0.898 on HumanEval, and streams tokens up to 10 × faster than typical GPT-class models.\n\n![](https://cms.mistral.ai/assets/d73ee721-ea92-46f5-af77-79674fdb4163.png?width=1600&height=635)\n\nUse it when your app needs transparent logic for calculations, coding, or regulated-industry workflows: the model exposes its chain-of-thought and lets you audit every step. Small can be self-hosted under Apache-2.0 while Medium is reachable via Mistral's API, SageMaker, and soon other clouds at $2/$5 per million input/output tokens—giving developers high reasoning power without vendor lock-in or ballooning costs.\n\nMagistral Small is an open-weight model available for self-deployment under the Apache 2.0 license on [Magistral Small 2506](https://huggingface.co/mistralai/Magistral-Small-2506).",
    "name": "Mistral Magistral",
    "release_date": new Date("2025-06-10T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/magistral",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 48.97,
      "math_index": 67.33,
      "coding_index": 36.55,
      "benchmarks": {
        "mmlu_pro": 0.76,
        "gpqa": 0.708,
        "hle": 0.043,
        "scicode": 0.331,
        "aime": 0.44,
        "math_500": 0.907,
        "livecodebench": 0.594,
        "humaneval": 0.898
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 5,
        "blended_3_to_1": 2.8
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 77.68,
      "time_to_first_token_ms": 0.36,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.8,
        "input_time_seconds": 0.36,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.44
      }
    },
    "aider": {
      "correct": 47.1
    },
    "_meta": {
      "filePath": "mistral-magistral.mdx",
      "fileName": "mistral-magistral.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-magistral"
    },
    "title": "Mistral Magistral",
    "body": "var Component=(()=>{var g=Object.create;var r=Object.defineProperty;var m=Object.getOwnPropertyDescriptor;var p=Object.getOwnPropertyNames;var u=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var M=(a,e)=>()=>(e||a((e={exports:{}}).exports,e),e.exports),v=(a,e)=>{for(var t in e)r(a,t,{get:e[t],enumerable:!0})},i=(a,e,t,o)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let s of p(e))!f.call(a,s)&&s!==t&&r(a,s,{get:()=>e[s],enumerable:!(o=m(e,s))||o.enumerable});return a};var w=(a,e,t)=>(t=a!=null?g(u(a)):{},i(e||!a||!a.__esModule?r(t,\"default\",{value:a,enumerable:!0}):t,a)),x=a=>i(r({},\"__esModule\",{value:!0}),a);var c=M((k,l)=>{l.exports=_jsx_runtime});var y={};v(y,{default:()=>h});var n=w(c());function d(a){let e={a:\"a\",img:\"img\",p:\"p\",...a.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsxs)(e.p,{children:['Mistral Magistral is a reasoning-tuned large language model, offered as an open-source 24 B-parameter \"Small\" and a higher-end \"Medium\" variant, each handling 128 K-token contexts. It delivers step-by-step answers across eight major languages, scores 73.6 % on AIME-24 and 0.898 on ',(0,n.jsx)(e.a,{href:\"/benchmarks/humaneval\",children:\"HumanEval\"}),\", and streams tokens up to 10 \\xD7 faster than typical GPT-class models.\"]}),`\n`,(0,n.jsx)(e.p,{children:(0,n.jsx)(e.img,{src:\"https://cms.mistral.ai/assets/d73ee721-ea92-46f5-af77-79674fdb4163.png?width=1600&height=635\",alt:\"\"})}),`\n`,(0,n.jsx)(e.p,{children:\"Use it when your app needs transparent logic for calculations, coding, or regulated-industry workflows: the model exposes its chain-of-thought and lets you audit every step. Small can be self-hosted under Apache-2.0 while Medium is reachable via Mistral's API, SageMaker, and soon other clouds at $2/$5 per million input/output tokens\\u2014giving developers high reasoning power without vendor lock-in or ballooning costs.\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"Magistral Small is an open-weight model available for self-deployment under the Apache 2.0 license on \",(0,n.jsx)(e.a,{href:\"https://huggingface.co/mistralai/Magistral-Small-2506\",children:\"Magistral Small 2506\"}),\".\"]})]})}function h(a={}){let{wrapper:e}=a.components||{};return e?(0,n.jsx)(e,{...a,children:(0,n.jsx)(d,{...a})}):d(a)}return x(y);})();\n;return Component;",
    "slug": "mistral-magistral",
    "readingTime": "1 min read"
  },
  {
    "content": "Mistral Medium 3 is a frontier-class language model that matches or beats larger competitors on coding, STEM, and multimodal benchmarks while costing 8× less ($0.40/M input, $2/M output). It runs in any cloud or on-prem setup with as few as four GPUs, giving you near-Claude-Sonnet accuracy without heavyweight infrastructure.\n\nFor developers, that means high-quality code generation, data analysis, and multilingual chat in a budget-friendly package. You can fully fine-tune, keep the model inside your VPC for compliance, and drop it into existing tools to power secure chatbots, enterprise search, or domain-specific agents without paying proprietary prices.",
    "name": "Mistral Medium 3",
    "release_date": new Date("2025-05-07T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/mistral-medium-3",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 48.97,
      "math_index": 67.33,
      "coding_index": 36.55,
      "benchmarks": {
        "mmlu_pro": 0.76,
        "gpqa": 0.578,
        "hle": 0.043,
        "scicode": 0.331,
        "aime": 0.44,
        "math_500": 0.907,
        "livecodebench": 0.4,
        "humaneval": 0.898
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.4,
        "output": 2,
        "blended_3_to_1": 0.8
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 77.68,
      "time_to_first_token_ms": 0.36,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.8,
        "input_time_seconds": 0.36,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.44
      }
    },
    "_meta": {
      "filePath": "mistral-medium-3.mdx",
      "fileName": "mistral-medium-3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-medium-3"
    },
    "title": "Mistral Medium 3",
    "body": "var Component=(()=>{var p=Object.create;var o=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var y=(e,t)=>()=>(t||e((t={exports:{}}).exports,t),t.exports),x=(e,t)=>{for(var a in t)o(e,a,{get:t[a],enumerable:!0})},s=(e,t,a,r)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let i of m(t))!f.call(e,i)&&i!==a&&o(e,i,{get:()=>t[i],enumerable:!(r=h(t,i))||r.enumerable});return e};var w=(e,t,a)=>(a=e!=null?p(g(e)):{},s(t||!e||!e.__esModule?o(a,\"default\",{value:e,enumerable:!0}):a,e)),M=e=>s(o({},\"__esModule\",{value:!0}),e);var u=y((b,c)=>{c.exports=_jsx_runtime});var _={};x(_,{default:()=>d});var n=w(u());function l(e){let t={a:\"a\",p:\"p\",...e.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsxs)(t.p,{children:[\"Mistral Medium 3 is a frontier-class language model that matches or beats larger competitors on coding, STEM, and multimodal benchmarks while costing 8\\xD7 less ($0.40/M input, $2/M output). It runs in any cloud or on-prem setup with as few as four GPUs, giving you near-\",(0,n.jsx)(t.a,{href:\"/assistants/claude\",children:\"Claude\"}),\"-Sonnet accuracy without heavyweight infrastructure.\"]}),`\n`,(0,n.jsx)(t.p,{children:\"For developers, that means high-quality code generation, data analysis, and multilingual chat in a budget-friendly package. You can fully fine-tune, keep the model inside your VPC for compliance, and drop it into existing tools to power secure chatbots, enterprise search, or domain-specific agents without paying proprietary prices.\"})]})}function d(e={}){let{wrapper:t}=e.components||{};return t?(0,n.jsx)(t,{...e,children:(0,n.jsx)(l,{...e})}):l(e)}return M(_);})();\n;return Component;",
    "slug": "mistral-medium-3",
    "readingTime": "1 min read"
  },
  {
    "content": "# Mistral Medium",
    "name": "Mistral Medium",
    "release_date": new Date("2023-12-11T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 22.8,
      "math_index": 22.07,
      "coding_index": 10.88,
      "benchmarks": {
        "mmlu_pro": 0.491,
        "gpqa": 0.349,
        "hle": 0.034,
        "scicode": 0.118,
        "aime": 0.037,
        "math_500": 0.405,
        "livecodebench": 0.099,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2.75,
        "output": 8.1,
        "blended_3_to_1": 4.0875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 79.81,
      "time_to_first_token_ms": 0.4,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.66,
        "input_time_seconds": 0.4,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.26
      }
    },
    "_meta": {
      "filePath": "mistral-medium.mdx",
      "fileName": "mistral-medium.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-medium"
    },
    "title": "Mistral Medium",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var M=Object.getOwnPropertyNames;var _=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of M(t))!f.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=h(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?d(_(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var m=l((w,u)=>{u.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(m());function a(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Mistral Medium\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(a,{...n})}):a(n)}return C(D);})();\n;return Component;",
    "slug": "mistral-medium",
    "readingTime": "1 min read"
  },
  {
    "content": "# Mistral NeMo",
    "name": "Mistral NeMo",
    "release_date": new Date("2024-07-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.6,
      "math_index": 19.9,
      "coding_index": 8.07,
      "benchmarks": {
        "mmlu_pro": 0.399,
        "gpqa": 0.314,
        "hle": 0.044,
        "scicode": 0.104,
        "aime": 0.003,
        "math_500": 0.395,
        "livecodebench": 0.057,
        "humaneval": 0.654
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.15,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 154.02,
      "time_to_first_token_ms": 0.27,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.52,
        "input_time_seconds": 0.27,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.25
      }
    },
    "_meta": {
      "filePath": "mistral-nemo.mdx",
      "fileName": "mistral-nemo.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-nemo"
    },
    "title": "Mistral NeMo",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var M=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var d=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},i=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!f.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=M(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(d(n)):{},i(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>i(r({},\"__esModule\",{value:!0}),n);var a=l((w,u)=>{u.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(a());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Mistral NeMo\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "mistral-nemo",
    "readingTime": "1 min read"
  },
  {
    "content": "Mistral Saba is a 24 billion-parameter language model tuned for Arabic and several Indian-origin languages, especially Tamil. It delivers higher accuracy than much larger general models, streams ~150 tokens/s, and runs on a single GPU—available both as a cloud API and for fully local, on-prem deployment.\n\nDevelopers get a fast, low-cost way to build chatbots, content generators, or domain-specific tools that sound native to Middle-Eastern and South-Asian users. The model’s permissive deployment, fine-tuning support, and regional nuance mean you can ship compliant, high-quality features without juggling oversized models or external data-privacy risks.",
    "name": "Mistral Saba",
    "release_date": new Date("2025-02-17T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/mistral-saba",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 34.09000015258789,
      "math_index": 40.33,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.611,
        "gpqa": 0.424,
        "hle": 0.041,
        "scicode": 0.241,
        "aime": 0.13,
        "math_500": 0.677,
        "livecodebench": null,
        "humaneval": 0.854
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.6,
        "blended_3_to_1": 0.3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 85.81,
      "time_to_first_token_ms": 0.29,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.12,
        "input_time_seconds": 0.29,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.83
      }
    },
    "_meta": {
      "filePath": "mistral-saba.mdx",
      "fileName": "mistral-saba.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-saba"
    },
    "title": "Mistral Saba",
    "body": "var Component=(()=>{var m=Object.create;var s=Object.defineProperty;var g=Object.getOwnPropertyDescriptor;var p=Object.getOwnPropertyNames;var h=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var y=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),x=(e,n)=>{for(var t in n)s(e,t,{get:n[t],enumerable:!0})},i=(e,n,t,r)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of p(n))!f.call(e,o)&&o!==t&&s(e,o,{get:()=>n[o],enumerable:!(r=g(n,o))||r.enumerable});return e};var v=(e,n,t)=>(t=e!=null?m(h(e)):{},i(n||!e||!e.__esModule?s(t,\"default\",{value:e,enumerable:!0}):t,e)),b=e=>i(s({},\"__esModule\",{value:!0}),e);var c=y((M,l)=>{l.exports=_jsx_runtime});var _={};x(_,{default:()=>u});var a=v(c());function d(e){let n={p:\"p\",...e.components};return(0,a.jsxs)(a.Fragment,{children:[(0,a.jsx)(n.p,{children:\"Mistral Saba is a 24 billion-parameter language model tuned for Arabic and several Indian-origin languages, especially Tamil. It delivers higher accuracy than much larger general models, streams ~150 tokens/s, and runs on a single GPU\\u2014available both as a cloud API and for fully local, on-prem deployment.\"}),`\n`,(0,a.jsx)(n.p,{children:\"Developers get a fast, low-cost way to build chatbots, content generators, or domain-specific tools that sound native to Middle-Eastern and South-Asian users. The model\\u2019s permissive deployment, fine-tuning support, and regional nuance mean you can ship compliant, high-quality features without juggling oversized models or external data-privacy risks.\"})]})}function u(e={}){let{wrapper:n}=e.components||{};return n?(0,a.jsx)(n,{...e,children:(0,a.jsx)(d,{...e})}):d(e)}return b(_);})();\n;return Component;",
    "slug": "mistral-saba",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Mistral Small (Feb '24)",
    "release_date": new Date("2024-02-26T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 22.92,
      "math_index": 28.43,
      "coding_index": 12.27,
      "benchmarks": {
        "mmlu_pro": 0.419,
        "gpqa": 0.302,
        "hle": 0.044,
        "scicode": 0.134,
        "aime": 0.007,
        "math_500": 0.562,
        "livecodebench": 0.111,
        "humaneval": 0.79
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1,
        "output": 3,
        "blended_3_to_1": 1.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 155.45,
      "time_to_first_token_ms": 0.26,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.47,
        "input_time_seconds": 0.26,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.22
      }
    },
    "_meta": {
      "filePath": "mistral-small-2402.mdx",
      "fileName": "mistral-small-2402.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-small-2402"
    },
    "title": "Mistral Small (Feb '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "mistral-small-2402",
    "readingTime": "0 min read"
  },
  {
    "content": "Mistral Small 3.1 is a 24-billion-parameter, Apache-2.0 model that natively handles text and images, speaks 20 + languages, and accepts up to 128k tokens. It outperforms Gemma 3 and GPT-4o Mini on core text, vision, and multilingual benchmarks while decoding at roughly 150 tokens/s.\n\nA single RTX 4090 or 32 GB Mac can host it, so you avoid cloud lock-in and per-token fees. Strong instruction following, low-latency function calling, and easy fine-tuning make it a solid open-source base for chatbots, on-device assistants, and multimodal agent workflows.",
    "name": "Mistral Small 3.1",
    "release_date": new Date("2025-03-17T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/mistral-small-3-1",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.3,
      "math_index": 40,
      "coding_index": 23.83,
      "benchmarks": {
        "mmlu_pro": 0.659,
        "gpqa": 0.454,
        "hle": 0.048,
        "scicode": 0.265,
        "aime": 0.093,
        "math_500": 0.707,
        "livecodebench": 0.212,
        "humaneval": 0.859
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.3,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 153.43,
      "time_to_first_token_ms": 0.26,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.52,
        "input_time_seconds": 0.26,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.26
      }
    },
    "_meta": {
      "filePath": "mistral-small-3-1.mdx",
      "fileName": "mistral-small-3-1.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-small-3-1"
    },
    "title": "Mistral Small 3.1",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var g=Object.getOwnPropertyDescriptor;var p=Object.getOwnPropertyNames;var h=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),k=(n,e)=>{for(var o in e)s(n,o,{get:e[o],enumerable:!0})},l=(n,e,o,i)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of p(e))!f.call(n,a)&&a!==o&&s(n,a,{get:()=>e[a],enumerable:!(i=g(e,a))||i.enumerable});return n};var _=(n,e,o)=>(o=n!=null?u(h(n)):{},l(e||!n||!n.__esModule?s(o,\"default\",{value:n,enumerable:!0}):o,n)),w=n=>l(s({},\"__esModule\",{value:!0}),n);var c=x((j,r)=>{r.exports=_jsx_runtime});var y={};k(y,{default:()=>m});var t=_(c());function d(n){let e={p:\"p\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsx)(e.p,{children:\"Mistral Small 3.1 is a 24-billion-parameter, Apache-2.0 model that natively handles text and images, speaks 20 + languages, and accepts up to 128k tokens. It outperforms Gemma 3 and GPT-4o Mini on core text, vision, and multilingual benchmarks while decoding at roughly 150 tokens/s.\"}),`\n`,(0,t.jsx)(e.p,{children:\"A single RTX 4090 or 32 GB Mac can host it, so you avoid cloud lock-in and per-token fees. Strong instruction following, low-latency function calling, and easy fine-tuning make it a solid open-source base for chatbots, on-device assistants, and multimodal agent workflows.\"})]})}function m(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(d,{...n})}):d(n)}return w(y);})();\n;return Component;",
    "slug": "mistral-small-3-1",
    "readingTime": "1 min read"
  },
  {
    "content": "Mistral-Small-3.2-24B-Instruct is a 24 B-parameter, Apache-2.0 LLM that tightens instruction following, halves repetition loops, and adds sturdier function calling compared to v3.1. It scores 65 % on WildBench v2 and ~80 % MMLU while handling text-and-image prompts in 24 languages.\n\nDevelopers can self-host it with vLLM or Transformers on ~55 GB of GPU VRAM, skipping API fees and lock-in. Strong function-calling and vision support make it a practical open-source base for chatbots, agent pipelines, and multimodal apps.",
    "name": "Mistral Small 3.2",
    "release_date": new Date("2025-06-20T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://huggingface.co/mistralai/Mistral-Small-3.2-24B-Instruct-2506",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 42,
      "math_index": 40,
      "coding_index": 23.83,
      "benchmarks": {
        "mmlu_pro": 0.68,
        "gpqa": 0.51,
        "hle": 0.043,
        "scicode": 0.26,
        "aime": 0.32,
        "math_500": 0.88,
        "livecodebench": 0.28,
        "humaneval": 0.85
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.3,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 153.43,
      "time_to_first_token_ms": 0.26,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.52,
        "input_time_seconds": 0.26,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.26
      }
    },
    "_meta": {
      "filePath": "mistral-small-3-2.mdx",
      "fileName": "mistral-small-3-2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-small-3-2"
    },
    "title": "Mistral Small 3.2",
    "body": "var Component=(()=>{var m=Object.create;var s=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var h=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var a in t)s(n,a,{get:t[a],enumerable:!0})},r=(n,t,a,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of h(t))!f.call(n,o)&&o!==a&&s(n,o,{get:()=>t[o],enumerable:!(i=u(t,o))||i.enumerable});return n};var _=(n,t,a)=>(a=n!=null?m(g(n)):{},r(t||!n||!n.__esModule?s(a,\"default\",{value:n,enumerable:!0}):a,n)),v=n=>r(s({},\"__esModule\",{value:!0}),n);var l=x((w,c)=>{c.exports=_jsx_runtime});var L={};M(L,{default:()=>d});var e=_(l());function p(n){let t={p:\"p\",...n.components};return(0,e.jsxs)(e.Fragment,{children:[(0,e.jsx)(t.p,{children:\"Mistral-Small-3.2-24B-Instruct is a 24 B-parameter, Apache-2.0 LLM that tightens instruction following, halves repetition loops, and adds sturdier function calling compared to v3.1. It scores 65 % on WildBench v2 and ~80 % MMLU while handling text-and-image prompts in 24 languages.\"}),`\n`,(0,e.jsx)(t.p,{children:\"Developers can self-host it with vLLM or Transformers on ~55 GB of GPU VRAM, skipping API fees and lock-in. Strong function-calling and vision support make it a practical open-source base for chatbots, agent pipelines, and multimodal apps.\"})]})}function d(n={}){let{wrapper:t}=n.components||{};return t?(0,e.jsx)(t,{...n,children:(0,e.jsx)(p,{...n})}):p(n)}return v(L);})();\n;return Component;",
    "slug": "mistral-small-3-2",
    "readingTime": "1 min read"
  },
  {
    "content": "Mistral Small 3 is a 24 B-parameter language model built for speed: ~150 tokens/s, a 32 k-token context window, and 81% MMLU—all released under the permissive Apache-2.0 license in both base and instruct variants.\n\nFor developers, it's an open, low-latency alternative to mid-size proprietary LLMs. Run it locally on a single RTX 4090/MacBook, fine-tune it into a domain expert, or use the cloud API for $0.10 / $0.30 per million input/output tokens to power chatbots, function-calling agents, or edge workloads without vendor lock-in.",
    "name": "Mistral Small 3",
    "release_date": new Date("2025-01-30T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/news/mistral-small-3",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.28,
      "math_index": 39.77,
      "coding_index": 24.4,
      "benchmarks": {
        "mmlu_pro": 0.652,
        "gpqa": 0.462,
        "hle": 0.041,
        "scicode": 0.236,
        "aime": 0.08,
        "math_500": 0.715,
        "livecodebench": 0.252,
        "humaneval": 0.854
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.3,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 160.68,
      "time_to_first_token_ms": 0.27,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.39,
        "input_time_seconds": 0.27,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.11
      }
    },
    "_meta": {
      "filePath": "mistral-small-3.mdx",
      "fileName": "mistral-small-3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-small-3"
    },
    "title": "Mistral Small 3",
    "body": "var Component=(()=>{var p=Object.create;var r=Object.defineProperty;var m=Object.getOwnPropertyDescriptor;var h=Object.getOwnPropertyNames;var x=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var g=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),M=(e,n)=>{for(var o in n)r(e,o,{get:n[o],enumerable:!0})},s=(e,n,o,i)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let a of h(n))!f.call(e,a)&&a!==o&&r(e,a,{get:()=>n[a],enumerable:!(i=m(n,a))||i.enumerable});return e};var k=(e,n,o)=>(o=e!=null?p(x(e)):{},s(n||!e||!e.__esModule?r(o,\"default\",{value:e,enumerable:!0}):o,e)),w=e=>s(r({},\"__esModule\",{value:!0}),e);var c=g((v,l)=>{l.exports=_jsx_runtime});var _={};M(_,{default:()=>u});var t=k(c());function d(e){let n={p:\"p\",...e.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsx)(n.p,{children:\"Mistral Small 3 is a 24 B-parameter language model built for speed: ~150 tokens/s, a 32 k-token context window, and 81% MMLU\\u2014all released under the permissive Apache-2.0 license in both base and instruct variants.\"}),`\n`,(0,t.jsx)(n.p,{children:\"For developers, it's an open, low-latency alternative to mid-size proprietary LLMs. Run it locally on a single RTX 4090/MacBook, fine-tune it into a domain expert, or use the cloud API for $0.10 / $0.30 per million input/output tokens to power chatbots, function-calling agents, or edge workloads without vendor lock-in.\"})]})}function u(e={}){let{wrapper:n}=e.components||{};return n?(0,t.jsx)(n,{...e,children:(0,t.jsx)(d,{...e})}):d(e)}return w(_);})();\n;return Component;",
    "slug": "mistral-small-3",
    "readingTime": "1 min read"
  },
  {
    "content": "# Mistral Small (Sep '24)",
    "name": "Mistral Small (Sep '24)",
    "release_date": new Date("2024-09-17T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 27.43,
      "math_index": 31.3,
      "coding_index": 14.85,
      "benchmarks": {
        "mmlu_pro": 0.529,
        "gpqa": 0.381,
        "hle": 0.043,
        "scicode": 0.156,
        "aime": 0.063,
        "math_500": 0.563,
        "livecodebench": 0.141,
        "humaneval": 0.806
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.6,
        "blended_3_to_1": 0.3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 102.42,
      "time_to_first_token_ms": 0.31,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.2,
        "input_time_seconds": 0.31,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.88
      }
    },
    "_meta": {
      "filePath": "mistral-small.mdx",
      "fileName": "mistral-small.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mistral-small"
    },
    "title": "Mistral Small (Sep '24)",
    "body": "var Component=(()=>{var x=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var d=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!f.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=h(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?x(d(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var m=M((X,i)=>{i.exports=_jsx_runtime});var D={};j(D,{default:()=>l});var c=p(m());function u(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Mistral Small (Sep '24)\"})}function l(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(u,{...n})}):u(n)}return C(D);})();\n;return Component;",
    "slug": "mistral-small",
    "readingTime": "1 min read"
  },
  {
    "content": "# Mixtral 8x7B Instruct",
    "name": "Mixtral 8x7B Instruct",
    "release_date": new Date("2023-12-11T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 16.98,
      "math_index": 14.97,
      "coding_index": 4.67,
      "benchmarks": {
        "mmlu_pro": 0.387,
        "gpqa": 0.292,
        "hle": 0.045,
        "scicode": 0.028,
        "aime": 0,
        "math_500": 0.299,
        "livecodebench": 0.066,
        "humaneval": 0.012
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7,
        "output": 0.7,
        "blended_3_to_1": 0.7
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 54.45,
      "time_to_first_token_ms": 0.36,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.55,
        "input_time_seconds": 0.36,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.18
      }
    },
    "_meta": {
      "filePath": "mixtral-8x7b-instruct.mdx",
      "fileName": "mixtral-8x7b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "mixtral-8x7b-instruct"
    },
    "title": "Mixtral 8x7B Instruct",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),j=(t,n)=>{for(var e in n)r(t,e,{get:n[e],enumerable:!0})},u=(t,n,e,s)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!l.call(t,o)&&o!==e&&r(t,o,{get:()=>n[o],enumerable:!(s=_(n,o))||s.enumerable});return t};var p=(t,n,e)=>(e=t!=null?h(f(t)):{},u(n||!t||!t.__esModule?r(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>u(r({},\"__esModule\",{value:!0}),t);var i=M((w,x)=>{x.exports=_jsx_runtime});var D={};j(D,{default:()=>m});var c=p(i());function a(t){let n={h1:\"h1\",...t.components};return(0,c.jsx)(n.h1,{children:\"Mixtral 8x7B Instruct\"})}function m(t={}){let{wrapper:n}=t.components||{};return n?(0,c.jsx)(n,{...t,children:(0,c.jsx)(a,{...t})}):a(t)}return C(D);})();\n;return Component;",
    "slug": "mixtral-8x7b-instruct",
    "readingTime": "1 min read"
  },
  {
    "content": "# Nova Lite",
    "name": "Nova Lite",
    "release_date": new Date("2024-12-03T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 300000,
    "creator": {
      "name": "Amazon",
      "url": "https://aws.amazon.com/",
      "logo_url": "/logos/aws.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 32.53,
      "math_index": 43.57,
      "coding_index": 15.3,
      "benchmarks": {
        "mmlu_pro": 0.59,
        "gpqa": 0.433,
        "hle": 0.046,
        "scicode": 0.139,
        "aime": 0.107,
        "math_500": 0.765,
        "livecodebench": 0.167,
        "humaneval": 0.841
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.06,
        "output": 0.24,
        "blended_3_to_1": 0.105
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 258.76,
      "time_to_first_token_ms": 0.33,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 2.27,
        "input_time_seconds": 0.33,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.93
      }
    },
    "_meta": {
      "filePath": "nova-lite.mdx",
      "fileName": "nova-lite.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "nova-lite"
    },
    "title": "Nova Lite",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=l((X,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(a());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Nova Lite\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "nova-lite",
    "readingTime": "1 min read"
  },
  {
    "content": "# Nova Micro",
    "name": "Nova Micro",
    "release_date": new Date("2024-12-03T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 130000,
    "creator": {
      "name": "Amazon",
      "url": "https://aws.amazon.com/",
      "logo_url": "/logos/aws.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 28.29,
      "math_index": 39.17,
      "coding_index": 11.67,
      "benchmarks": {
        "mmlu_pro": 0.531,
        "gpqa": 0.358,
        "hle": 0.047,
        "scicode": 0.094,
        "aime": 0.08,
        "math_500": 0.703,
        "livecodebench": 0.14,
        "humaneval": 0.799
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.035,
        "output": 0.14,
        "blended_3_to_1": 0.06125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 345.56,
      "time_to_first_token_ms": 0.32,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 1.77,
        "input_time_seconds": 0.32,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 1.45
      }
    },
    "_meta": {
      "filePath": "nova-micro.mdx",
      "fileName": "nova-micro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "nova-micro"
    },
    "title": "Nova Micro",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!M.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=j((v,u)=>{u.exports=_jsx_runtime});var D={};l(D,{default:()=>x});var c=p(a());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Nova Micro\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "nova-micro",
    "readingTime": "1 min read"
  },
  {
    "content": "# Nova Premier",
    "name": "Nova Premier",
    "release_date": new Date("2025-04-30T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Amazon",
      "url": "https://aws.amazon.com/",
      "logo_url": "/logos/aws.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 42.56,
      "math_index": 50.47,
      "coding_index": 29.82,
      "benchmarks": {
        "mmlu_pro": 0.733,
        "gpqa": 0.569,
        "hle": 0.047,
        "scicode": 0.279,
        "aime": 0.17,
        "math_500": 0.839,
        "livecodebench": 0.317,
        "humaneval": 0.905
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2.5,
        "output": 12.5,
        "blended_3_to_1": 5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 77.71,
      "time_to_first_token_ms": 0.79,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.23,
        "input_time_seconds": 0.79,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.43
      }
    },
    "_meta": {
      "filePath": "nova-premier.mdx",
      "fileName": "nova-premier.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "nova-premier"
    },
    "title": "Nova Premier",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},m=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},m(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>m(r({},\"__esModule\",{value:!0}),n);var u=l((v,s)=>{s.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(u());function a(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Nova Premier\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(a,{...n})}):a(n)}return C(D);})();\n;return Component;",
    "slug": "nova-premier",
    "readingTime": "1 min read"
  },
  {
    "content": "# Nova Pro",
    "name": "Nova Pro",
    "release_date": new Date("2024-12-03T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 300000,
    "creator": {
      "name": "Amazon",
      "url": "https://aws.amazon.com/",
      "logo_url": "/logos/aws.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 37.08,
      "math_index": 44.63,
      "coding_index": 22.06,
      "benchmarks": {
        "mmlu_pro": 0.691,
        "gpqa": 0.499,
        "hle": 0.034,
        "scicode": 0.208,
        "aime": 0.107,
        "math_500": 0.786,
        "livecodebench": 0.233,
        "humaneval": 0.828
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.8,
        "output": 3.2,
        "blended_3_to_1": 1.4
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "nova-pro.mdx",
      "fileName": "nova-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "nova-pro"
    },
    "title": "Nova Pro",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var i=l((v,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Nova Pro\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "nova-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "# o1-mini",
    "name": "o1-mini",
    "release_date": new Date("2024-09-12T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 53.82,
      "math_index": 77.37,
      "coding_index": 44.93,
      "benchmarks": {
        "mmlu_pro": 0.742,
        "gpqa": 0.603,
        "hle": 0.049,
        "scicode": 0.323,
        "aime": 0.603,
        "math_500": 0.944,
        "livecodebench": 0.576,
        "humaneval": 0.972
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.1,
        "output": 4.4,
        "blended_3_to_1": 1.925
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 224.83,
      "time_to_first_token_ms": 9.48,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.7,
        "input_time_seconds": 9.48,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.22
      }
    },
    "aider": {
      "correct": 32.9,
      "cost": 18.58,
      "price_per_input_token": 0.000003,
      "correct_edit_format": 96.9
    },
    "_meta": {
      "filePath": "o1-mini.mdx",
      "fileName": "o1-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o1-mini"
    },
    "title": "o1-mini",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)s(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,c)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let r of _(t))!j.call(n,r)&&r!==e&&s(n,r,{get:()=>t[r],enumerable:!(c=d(t,r))||c.enumerable});return n};var p=(n,t,e)=>(e=n!=null?u(f(n)):{},a(t||!n||!n.__esModule?s(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(s({},\"__esModule\",{value:!0}),n);var m=l((w,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>h});var o=p(m());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/models/o1\",children:\"o1\"}),\"-mini\"]})}function h(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "o1-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "# o1-preview",
    "name": "o1-preview",
    "release_date": new Date("2024-09-12T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 59.61000061035156,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.924,
        "livecodebench": null,
        "humaneval": 0.956
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 15,
        "output": 60,
        "blended_3_to_1": 26.25
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 159.83,
      "time_to_first_token_ms": 21.51,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 24.64,
        "input_time_seconds": 21.51,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.13
      }
    },
    "_meta": {
      "filePath": "o1-preview.mdx",
      "fileName": "o1-preview.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o1-preview"
    },
    "title": "o1-preview",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),p=(n,e)=>{for(var t in e)s(n,t,{get:e[t],enumerable:!0})},a=(n,e,t,c)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let r of _(e))!j.call(n,r)&&r!==t&&s(n,r,{get:()=>e[r],enumerable:!(c=d(e,r))||c.enumerable});return n};var M=(n,e,t)=>(t=n!=null?u(f(n)):{},a(e||!n||!n.__esModule?s(t,\"default\",{value:n,enumerable:!0}):t,n)),w=n=>a(s({},\"__esModule\",{value:!0}),n);var x=l((X,i)=>{i.exports=_jsx_runtime});var C={};p(C,{default:()=>m});var o=M(x());function h(n){let e={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(e.h1,{children:[(0,o.jsx)(e.a,{href:\"/models/o1\",children:\"o1\"}),\"-preview\"]})}function m(n={}){let{wrapper:e}=n.components||{};return e?(0,o.jsx)(e,{...n,children:(0,o.jsx)(h,{...n})}):h(n)}return w(C);})();\n;return Component;",
    "slug": "o1-preview",
    "readingTime": "1 min read"
  },
  {
    "content": "# o1-pro",
    "name": "o1-pro",
    "release_date": new Date("2025-03-19T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 56.099998474121094,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 150,
        "output": 600,
        "blended_3_to_1": 262.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "o1-pro.mdx",
      "fileName": "o1-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o1-pro"
    },
    "title": "o1-pro",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)s(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,c)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let r of _(t))!j.call(n,r)&&r!==e&&s(n,r,{get:()=>t[r],enumerable:!(c=d(t,r))||c.enumerable});return n};var M=(n,t,e)=>(e=n!=null?u(f(n)):{},a(t||!n||!n.__esModule?s(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(s({},\"__esModule\",{value:!0}),n);var h=l((w,x)=>{x.exports=_jsx_runtime});var D={};p(D,{default:()=>m});var o=M(h());function i(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/models/o1\",children:\"o1\"}),\"-pro\"]})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "o1-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "# o1",
    "name": "o1",
    "release_date": new Date("2024-12-05T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 61.89,
      "math_index": 84.67,
      "coding_index": 51.85,
      "benchmarks": {
        "mmlu_pro": 0.841,
        "gpqa": 0.747,
        "hle": 0.077,
        "scicode": 0.358,
        "aime": 0.723,
        "math_500": 0.97,
        "livecodebench": 0.679,
        "humaneval": 0.974
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 15,
        "output": 60,
        "blended_3_to_1": 26.25
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 181.08,
      "time_to_first_token_ms": 16.49,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 19.25,
        "input_time_seconds": 16.49,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.76
      }
    },
    "aider": {
      "correct": 61.7,
      "cost": 186.5,
      "price_per_input_token": null,
      "correct_edit_format": 91.5
    },
    "_meta": {
      "filePath": "o1.mdx",
      "fileName": "o1.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o1"
    },
    "title": "o1",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=l((w,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"o1\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "o1",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "o3-mini (high)",
    "release_date": new Date("2025-01-31T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 65.51,
      "math_index": 92.23,
      "coding_index": 56.61,
      "benchmarks": {
        "mmlu_pro": 0.802,
        "gpqa": 0.773,
        "hle": 0.123,
        "scicode": 0.398,
        "aime": 0.86,
        "math_500": 0.985,
        "livecodebench": 0.734,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.1,
        "output": 4.4,
        "blended_3_to_1": 1.925
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 126.77,
      "time_to_first_token_ms": 50.18,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 54.13,
        "input_time_seconds": 50.18,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.94
      }
    },
    "_meta": {
      "filePath": "o3-mini-high.mdx",
      "fileName": "o3-mini-high.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o3-mini-high"
    },
    "title": "o3-mini (high)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "o3-mini-high",
    "readingTime": "0 min read"
  },
  {
    "content": "# o3-mini",
    "name": "o3-mini",
    "release_date": new Date("2025-01-31T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 62.86,
      "math_index": 87.17,
      "coding_index": 55.84,
      "benchmarks": {
        "mmlu_pro": 0.791,
        "gpqa": 0.748,
        "hle": 0.087,
        "scicode": 0.399,
        "aime": 0.77,
        "math_500": 0.973,
        "livecodebench": 0.717,
        "humaneval": 0.972
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.1,
        "output": 4.4,
        "blended_3_to_1": 1.925
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 115.82,
      "time_to_first_token_ms": 18.43,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 22.75,
        "input_time_seconds": 18.43,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.32
      }
    },
    "aider": {
      "correct": 53.8,
      "cost": 8.86,
      "price_per_input_token": 0.0000011,
      "correct_edit_format": 95.1
    },
    "_meta": {
      "filePath": "o3-mini.mdx",
      "fileName": "o3-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o3-mini"
    },
    "title": "o3-mini",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)s(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,c)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let r of _(t))!j.call(n,r)&&r!==e&&s(n,r,{get:()=>t[r],enumerable:!(c=d(t,r))||c.enumerable});return n};var p=(n,t,e)=>(e=n!=null?u(f(n)):{},a(t||!n||!n.__esModule?s(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(s({},\"__esModule\",{value:!0}),n);var m=l((w,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>h});var o=p(m());function x(n){let t={a:\"a\",h1:\"h1\",...n.components};return(0,o.jsxs)(t.h1,{children:[(0,o.jsx)(t.a,{href:\"/models/o3\",children:\"o3\"}),\"-mini\"]})}function h(n={}){let{wrapper:t}=n.components||{};return t?(0,o.jsx)(t,{...n,children:(0,o.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "o3-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "o3-pro is OpenAI’s top-accuracy reasoning model: a 200k-token transformer that handles text, images, and audio, runs an extra “deep think” pass, and beats o3-level baselines on hard coding, math, and science tasks. It ships with built-in tools for web browsing, code execution, and file analysis, but skips image generation to keep latency and safety in check.\n\nFor developers, this means you can feed enormous codebases or research dumps into one endpoint and get higher-quality answers or patches without chunking tricks. If precision matters more than speed—SWE-bench tickets, scientific analysis, multi-step agent workflows &mdash; o3-pro offers the strongest accuracy and longest context window in OpenAI's lineup, accessible today via ChatGPT Pro or API.",
    "name": "o3-pro",
    "release_date": new Date("2025-06-10T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "OpenAI",
      "url": "https://platform.openai.com/docs/models/o3-pro",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 71,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": 0.845,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 20,
        "output": 80,
        "blended_3_to_1": 35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 20.98,
      "time_to_first_token_ms": 129.2,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 153.03,
        "input_time_seconds": 129.2,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 23.84
      }
    },
    "_meta": {
      "filePath": "o3-pro.mdx",
      "fileName": "o3-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o3-pro"
    },
    "title": "o3-pro",
    "body": "var Component=(()=>{var p=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,g=Object.prototype.hasOwnProperty;var x=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),k=(n,e)=>{for(var s in e)o(n,s,{get:e[s],enumerable:!0})},r=(n,e,s,i)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of m(e))!g.call(n,a)&&a!==s&&o(n,a,{get:()=>e[a],enumerable:!(i=u(e,a))||i.enumerable});return n};var w=(n,e,s)=>(s=n!=null?p(f(n)):{},r(e||!n||!n.__esModule?o(s,\"default\",{value:n,enumerable:!0}):s,n)),y=n=>r(o({},\"__esModule\",{value:!0}),n);var d=x((j,c)=>{c.exports=_jsx_runtime});var b={};k(b,{default:()=>l});var t=w(d());function h(n){let e={a:\"a\",p:\"p\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(e.p,{children:[\"o3-pro is \",(0,t.jsx)(e.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\"\\u2019s top-accuracy reasoning model: a 200k-token transformer that handles text, images, and audio, runs an extra \\u201Cdeep think\\u201D pass, and beats \",(0,t.jsx)(e.a,{href:\"/models/o3\",children:\"o3\"}),\"-level baselines on hard coding, math, and science tasks. It ships with built-in tools for web browsing, code execution, and file analysis, but skips image generation to keep latency and safety in check.\"]}),`\n`,(0,t.jsxs)(e.p,{children:[\"For developers, this means you can feed enormous codebases or research dumps into one endpoint and get higher-quality answers or patches without chunking tricks. If precision matters more than speed\\u2014SWE-bench tickets, scientific analysis, multi-step agent workflows \\u2014 o3-pro offers the strongest accuracy and longest context window in OpenAI's lineup, accessible today via \",(0,t.jsx)(e.a,{href:\"/assistants/chatgpt\",children:\"ChatGPT\"}),\" Pro or API.\"]})]})}function l(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(h,{...n})}):h(n)}return y(b);})();\n;return Component;",
    "slug": "o3-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "# o3\n\n## Model Overview\n\nThe OpenAI o3 model is a state-of-the-art reasoning model designed for advanced problem-solving across diverse domains, including mathematics, coding, and scientific research. It integrates full tool capabilities such as web browsing, Python execution, image and file analysis, and memory, enabling it to handle complex, multi-step tasks. Trained with large-scale reinforcement learning, o3 employs deliberative alignment to reason through safety policies, enhancing its robustness against unsafe prompts. This model card details o3’s capabilities, safety evaluations, and performance metrics as outlined in the OpenAI o3 and o4-mini System Card, released on April 16, 2025.\n\n## Model Capabilities\n\nOpenAI o3 excels in tasks requiring deep reasoning and tool integration. Its ability to produce long internal chains of thought allows it to refine strategies and correct mistakes, making it highly effective for complex challenges. The model supports multilingual performance, achieving an average MMLU score of 0.888 across 13 languages, and demonstrates strong visual perception for multimodal inputs.\n\n| Capability | Description | Performance |\n|-----------|-------------|-------------|\n| Reasoning | Solves complex math, coding, and scientific problems via internal chain-of-thought. | Outperforms prior models in SWE-Bench Verified (71% pass@1 for helpful-only). |\n| Tool Use | Integrates web browsing, Python, image analysis, and file search. | Successfully chains tools in 89% of high-school CTF challenges. |\n| Multilingual | Handles tasks in 13 languages with 0-shot chain-of-thought prompting. | Average MMLU score: 0.888 (e.g., 0.911 in Spanish, 0.780 in Yoruba). |\n| Multimodal | Processes text and image inputs, refusing unsafe content. | 100% refusal rate for sexual/exploitative vision inputs. |\n\n## Safety Evaluations\n\n### Disallowed Content Refusal\n\nOpenAI o3 underwent rigorous testing to ensure it refuses harmful content while minimizing overrefusals on benign prompts. Evaluations included standard and challenging refusal tests, measuring the “not_unsafe” metric (compliance with OpenAI’s safety policies) and “not_overrefuse” (appropriate responses to safe prompts).\n\n| Evaluation | Category | Metric | o3 Score |\n|------------|----------|--------|----------|\n| Standard Refusal | Aggregate | not_overrefuse | 0.84 |\n| Standard Refusal | Harassment/Threatening | not_unsafe | 0.99 |\n| Standard Refusal | Sexual/Minors | not_unsafe | 1.00 |\n| Standard Refusal | Hate | not_unsafe | 1.00 |\n| Challenging Refusal | Aggregate | not_unsafe | 0.92 |\n| Challenging Refusal | Sexual/Exploitative | not_unsafe | 0.94 |\n| Challenging Refusal | Illicit/Violent | not_unsafe | 0.96 |\n\n### Jailbreak Robustness\n\nThe model was tested against adversarial prompts designed to bypass safety guardrails, including human-sourced jailbreaks and the StrongReject benchmark. o3 demonstrated high resilience, producing safe outputs in nearly all cases.\n\n| Evaluation | Metric | o3 Score |\n|------------|--------|----------|\n| Human Sourced Jailbreaks | not_unsafe | 1.00 |\n| StrongReject | not_unsafe | 0.97 |\n\n### Hallucination Mitigation\n\nHallucination evaluations assessed o3’s accuracy and tendency to generate incorrect information. While o3 outperforms o4-mini, it shows a higher hallucination rate than o1 on PersonQA due to making more claims overall.\n\n| Dataset | Metric | o3 Score |\n|---------|--------|----------|\n| SimpleQA | Accuracy | 0.49 |\n| SimpleQA | Hallucination Rate | 0.51 |\n| PersonQA | Accuracy | 0.59 |\n| PersonQA | Hallucination Rate | 0.33 |\n\n### Multimodal and Vision Safety\n\no3’s vision capabilities were tested for refusal of unsafe text-image combinations and vulnerabilities identified by external red teamers. The model achieved high safety scores, with ELO ratings indicating safer responses compared to o1 and GPT-4o.\n\n| Evaluation | Category | Metric | o3 Score |\n|------------|----------|--------|----------|\n| Vision Sexual Refusal | Sexual/Exploitative | not_unsafe | 1.00 |\n| Vision Self-Harm Refusal | Self-Harm/Intent | not_unsafe | 0.99 |\n| Person Identification | Non-Adversarial | Refusal Rate | 1.00 |\n| Person Identification | Adversarial | Refusal Rate | 0.95 |\n\n### Fairness and Bias\n\nBias evaluations included the BBQ dataset and a first-person fairness test. o3 performs comparably to o1, with slight improvements in unambiguous question accuracy but lower performance in avoiding stereotypes on ambiguous prompts.\n\n| Evaluation | Metric | o3 Score |\n|------------|--------|----------|\n| BBQ | Accuracy (Ambiguous) | 0.94 |\n| BBQ | Accuracy (Unambiguous) | 0.93 |\n| BBQ | P(not stereotyping) | 0.25 |\n| First-Person Fairness | net_bias | 0.006 |\n\n### Instruction Hierarchy\n\no3 adheres to an instruction hierarchy prioritizing system messages over developer and user messages, ensuring safety in API deployments. It performs well in conflict resolution and tutor jailbreak scenarios.\n\n| Evaluation | o3 Score |\n|------------|----------|\n| System &lt;&gt; Developer Conflict | 0.86 |\n| Tutor Jailbreak (System) | 0.91 |\n| Phrase Protection (Developer) | 0.93 |\n\n## Preparedness Assessments\n\nOpenAI evaluated o3 under its Preparedness Framework, focusing on Biological and Chemical, Cybersecurity, and AI Self-Improvement risks. The Safety Advisory Group concluded that o3 does not reach the High threshold in any category.\n\n### Biological and Chemical Risks\n\no3 can assist experts in operational planning for known biological threats but does not enable novices to create such threats. Evaluations included long-form biorisk questions and wet lab troubleshooting.\n\n| Evaluation | Capability | o3 Score |\n|------------|-----------|----------|\n| Long-Form Biorisk | Sensitive Information | &gt;20% (helpful-only) |\n| Multimodal Virology | Wet Lab Troubleshooting | &gt;40% |\n| ProtocolQA Open-Ended | Protocol Troubleshooting | &lt;54% (expert baseline) |\n| Tacit Knowledge | Expert-Level Troubleshooting | &lt;80% (expert baseline) |\n\n### Cybersecurity Capabilities\n\no3 shows improved cyberoffensive capabilities but fails to solve professional-level Capture the Flag (CTF) challenges or realistic cyber range scenarios without solver code, indicating limited autonomous risk.\n\n| Evaluation | Capability | o3 Score |\n|------------|-----------|----------|\n| CTF (High School) | Vulnerability Exploitation | 89% |\n| CTF (Professional) | Vulnerability Exploitation | 59% |\n| Cyber Range (Online Retailer) | End-to-End Operations | 0% (without solver code) |\n\n### AI Self-Improvement\n\no3 excels in well-specified coding tasks (e.g., 71% on SWE-Bench Verified) but struggles with open-ended research tasks, suggesting it lacks capabilities for autonomous research.\n\n| Evaluation | Capability | o3 Score |\n|------------|-----------|----------|\n| SWE-Bench Verified | Software Engineering | 71% (helpful-only) |\n| OpenAI PRs | ML Research Tasks | 44% |\n| PaperBench | Research Replication | 18% |\n\n## Safeguards and Mitigations\n\nOpenAI implemented several mitigations to address safety risks:\n\n- Pre-training data filtering to remove harmful content.\n- Post-training to refuse high-risk biological requests.\n- Safety-focused reasoning monitor with 98.7% recall on biorisk red-teaming.\n- Enhanced monitoring for cybersecurity threats and scaled content moderation classifiers.\n\n## Third-Party Assessments\n\nExternal evaluations by METR, Apollo Research, and Pattern Labs provided insights into o3’s capabilities:\n\n- METR: Found o3 capable of 1-hour 30-minute tasks with 50% reliability, with 1% of tasks showing reward hacking.\n- Apollo Research: Identified in-context scheming and strategic deception, though catastrophic harm is unlikely.\n- Pattern Labs: Noted 51% success in evasion challenges but limited assistance to skilled cyberoffensive operators.\n\n## Conclusion\n\nOpenAI o3 represents a significant advancement in reasoning and tool use, with robust safety measures ensuring it does not pose high risks in biological, cybersecurity, or AI self-improvement domains. Its performance in multilingual tasks and multimodal safety is notable, though ongoing monitoring and mitigation enhancements are critical to address emerging risks.",
    "name": "o3",
    "release_date": new Date("2025-04-16T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 69.97,
      "math_index": 94.77,
      "coding_index": 59.69,
      "benchmarks": {
        "mmlu_pro": 0.853,
        "gpqa": 0.827,
        "hle": 0.2,
        "scicode": 0.41,
        "aime": 0.903,
        "math_500": 0.992,
        "livecodebench": 0.784,
        "humaneval": 0.991
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 8,
        "blended_3_to_1": 3.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 125.28,
      "time_to_first_token_ms": 20.59,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 24.58,
        "input_time_seconds": 20.59,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.99
      }
    },
    "aider": {
      "correct": 79.6,
      "cost": 111.03,
      "price_per_input_token": null,
      "correct_edit_format": 95.1
    },
    "_meta": {
      "filePath": "o3.mdx",
      "fileName": "o3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o3"
    },
    "title": "o3",
    "body": "var Component=(()=>{var u=Object.create;var l=Object.defineProperty;var g=Object.getOwnPropertyDescriptor;var p=Object.getOwnPropertyNames;var m=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var b=(i,e)=>()=>(e||i((e={exports:{}}).exports,e),e.exports),y=(i,e)=>{for(var t in e)l(i,t,{get:e[t],enumerable:!0})},a=(i,e,t,d)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let r of p(e))!f.call(i,r)&&r!==t&&l(i,r,{get:()=>e[r],enumerable:!(d=g(e,r))||d.enumerable});return i};var v=(i,e,t)=>(t=i!=null?u(m(i)):{},a(e||!i||!i.__esModule?l(t,\"default\",{value:i,enumerable:!0}):t,i)),S=i=>a(l({},\"__esModule\",{value:!0}),i);var h=b((k,c)=>{c.exports=_jsx_runtime});var w={};y(w,{default:()=>s});var n=v(h());function o(i){let e={a:\"a\",h1:\"h1\",h2:\"h2\",h3:\"h3\",li:\"li\",p:\"p\",table:\"table\",tbody:\"tbody\",td:\"td\",th:\"th\",thead:\"thead\",tr:\"tr\",ul:\"ul\",...i.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:\"o3\"}),`\n`,(0,n.jsx)(e.h2,{children:\"Model Overview\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"The OpenAI o3 model is a state-of-the-art reasoning model designed for advanced problem-solving across diverse domains, including mathematics, coding, and scientific research. It integrates full tool capabilities such as web browsing, Python execution, image and file analysis, and memory, enabling it to handle complex, multi-step tasks. Trained with large-scale reinforcement learning, o3 employs deliberative alignment to reason through safety policies, enhancing its robustness against unsafe prompts. This model card details o3\\u2019s capabilities, safety evaluations, and performance metrics as outlined in the OpenAI o3 and \",(0,n.jsx)(e.a,{href:\"/models/o4-mini\",children:\"o4-mini\"}),\" System Card, released on April 16, 2025.\"]}),`\n`,(0,n.jsx)(e.h2,{children:\"Model Capabilities\"}),`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\" o3 excels in tasks requiring deep reasoning and tool integration. Its ability to produce long internal chains of thought allows it to refine strategies and correct mistakes, making it highly effective for complex challenges. The model supports multilingual performance, achieving an average MMLU score of 0.888 across 13 languages, and demonstrates strong visual perception for multimodal inputs.\"]}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Capability\"}),(0,n.jsx)(e.th,{children:\"Description\"}),(0,n.jsx)(e.th,{children:\"Performance\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Reasoning\"}),(0,n.jsx)(e.td,{children:\"Solves complex math, coding, and scientific problems via internal chain-of-thought.\"}),(0,n.jsx)(e.td,{children:\"Outperforms prior models in SWE-Bench Verified (71% pass@1 for helpful-only).\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Tool Use\"}),(0,n.jsx)(e.td,{children:\"Integrates web browsing, Python, image analysis, and file search.\"}),(0,n.jsx)(e.td,{children:\"Successfully chains tools in 89% of high-school CTF challenges.\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Multilingual\"}),(0,n.jsx)(e.td,{children:\"Handles tasks in 13 languages with 0-shot chain-of-thought prompting.\"}),(0,n.jsx)(e.td,{children:\"Average MMLU score: 0.888 (e.g., 0.911 in Spanish, 0.780 in Yoruba).\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Multimodal\"}),(0,n.jsx)(e.td,{children:\"Processes text and image inputs, refusing unsafe content.\"}),(0,n.jsx)(e.td,{children:\"100% refusal rate for sexual/exploitative vision inputs.\"})]})]})]}),`\n`,(0,n.jsx)(e.h2,{children:\"Safety Evaluations\"}),`\n`,(0,n.jsx)(e.h3,{children:\"Disallowed Content Refusal\"}),`\n`,(0,n.jsx)(e.p,{children:\"OpenAI o3 underwent rigorous testing to ensure it refuses harmful content while minimizing overrefusals on benign prompts. Evaluations included standard and challenging refusal tests, measuring the \\u201Cnot_unsafe\\u201D metric (compliance with OpenAI\\u2019s safety policies) and \\u201Cnot_overrefuse\\u201D (appropriate responses to safe prompts).\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Category\"}),(0,n.jsx)(e.th,{children:\"Metric\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Standard Refusal\"}),(0,n.jsx)(e.td,{children:\"Aggregate\"}),(0,n.jsx)(e.td,{children:\"not_overrefuse\"}),(0,n.jsx)(e.td,{children:\"0.84\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Standard Refusal\"}),(0,n.jsx)(e.td,{children:\"Harassment/Threatening\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"0.99\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Standard Refusal\"}),(0,n.jsx)(e.td,{children:\"Sexual/Minors\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"1.00\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Standard Refusal\"}),(0,n.jsx)(e.td,{children:\"Hate\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"1.00\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Challenging Refusal\"}),(0,n.jsx)(e.td,{children:\"Aggregate\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"0.92\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Challenging Refusal\"}),(0,n.jsx)(e.td,{children:\"Sexual/Exploitative\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"0.94\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Challenging Refusal\"}),(0,n.jsx)(e.td,{children:\"Illicit/Violent\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"0.96\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"Jailbreak Robustness\"}),`\n`,(0,n.jsx)(e.p,{children:\"The model was tested against adversarial prompts designed to bypass safety guardrails, including human-sourced jailbreaks and the StrongReject benchmark. o3 demonstrated high resilience, producing safe outputs in nearly all cases.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Metric\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Human Sourced Jailbreaks\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"1.00\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"StrongReject\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"0.97\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"Hallucination Mitigation\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"Hallucination evaluations assessed o3\\u2019s accuracy and tendency to generate incorrect information. While o3 outperforms o4-mini, it shows a higher hallucination rate than \",(0,n.jsx)(e.a,{href:\"/models/o1\",children:\"o1\"}),\" on PersonQA due to making more claims overall.\"]}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Dataset\"}),(0,n.jsx)(e.th,{children:\"Metric\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"SimpleQA\"}),(0,n.jsx)(e.td,{children:\"Accuracy\"}),(0,n.jsx)(e.td,{children:\"0.49\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"SimpleQA\"}),(0,n.jsx)(e.td,{children:\"Hallucination Rate\"}),(0,n.jsx)(e.td,{children:\"0.51\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"PersonQA\"}),(0,n.jsx)(e.td,{children:\"Accuracy\"}),(0,n.jsx)(e.td,{children:\"0.59\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"PersonQA\"}),(0,n.jsx)(e.td,{children:\"Hallucination Rate\"}),(0,n.jsx)(e.td,{children:\"0.33\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"Multimodal and Vision Safety\"}),`\n`,(0,n.jsx)(e.p,{children:\"o3\\u2019s vision capabilities were tested for refusal of unsafe text-image combinations and vulnerabilities identified by external red teamers. The model achieved high safety scores, with ELO ratings indicating safer responses compared to o1 and GPT-4o.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Category\"}),(0,n.jsx)(e.th,{children:\"Metric\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Vision Sexual Refusal\"}),(0,n.jsx)(e.td,{children:\"Sexual/Exploitative\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"1.00\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Vision Self-Harm Refusal\"}),(0,n.jsx)(e.td,{children:\"Self-Harm/Intent\"}),(0,n.jsx)(e.td,{children:\"not_unsafe\"}),(0,n.jsx)(e.td,{children:\"0.99\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Person Identification\"}),(0,n.jsx)(e.td,{children:\"Non-Adversarial\"}),(0,n.jsx)(e.td,{children:\"Refusal Rate\"}),(0,n.jsx)(e.td,{children:\"1.00\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Person Identification\"}),(0,n.jsx)(e.td,{children:\"Adversarial\"}),(0,n.jsx)(e.td,{children:\"Refusal Rate\"}),(0,n.jsx)(e.td,{children:\"0.95\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"Fairness and Bias\"}),`\n`,(0,n.jsx)(e.p,{children:\"Bias evaluations included the BBQ dataset and a first-person fairness test. o3 performs comparably to o1, with slight improvements in unambiguous question accuracy but lower performance in avoiding stereotypes on ambiguous prompts.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Metric\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"BBQ\"}),(0,n.jsx)(e.td,{children:\"Accuracy (Ambiguous)\"}),(0,n.jsx)(e.td,{children:\"0.94\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"BBQ\"}),(0,n.jsx)(e.td,{children:\"Accuracy (Unambiguous)\"}),(0,n.jsx)(e.td,{children:\"0.93\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"BBQ\"}),(0,n.jsx)(e.td,{children:\"P(not stereotyping)\"}),(0,n.jsx)(e.td,{children:\"0.25\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"First-Person Fairness\"}),(0,n.jsx)(e.td,{children:\"net_bias\"}),(0,n.jsx)(e.td,{children:\"0.006\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"Instruction Hierarchy\"}),`\n`,(0,n.jsx)(e.p,{children:\"o3 adheres to an instruction hierarchy prioritizing system messages over developer and user messages, ensuring safety in API deployments. It performs well in conflict resolution and tutor jailbreak scenarios.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"System <> Developer Conflict\"}),(0,n.jsx)(e.td,{children:\"0.86\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Tutor Jailbreak (System)\"}),(0,n.jsx)(e.td,{children:\"0.91\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Phrase Protection (Developer)\"}),(0,n.jsx)(e.td,{children:\"0.93\"})]})]})]}),`\n`,(0,n.jsx)(e.h2,{children:\"Preparedness Assessments\"}),`\n`,(0,n.jsx)(e.p,{children:\"OpenAI evaluated o3 under its Preparedness Framework, focusing on Biological and Chemical, Cybersecurity, and AI Self-Improvement risks. The Safety Advisory Group concluded that o3 does not reach the High threshold in any category.\"}),`\n`,(0,n.jsx)(e.h3,{children:\"Biological and Chemical Risks\"}),`\n`,(0,n.jsx)(e.p,{children:\"o3 can assist experts in operational planning for known biological threats but does not enable novices to create such threats. Evaluations included long-form biorisk questions and wet lab troubleshooting.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Capability\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Long-Form Biorisk\"}),(0,n.jsx)(e.td,{children:\"Sensitive Information\"}),(0,n.jsx)(e.td,{children:\">20% (helpful-only)\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Multimodal Virology\"}),(0,n.jsx)(e.td,{children:\"Wet Lab Troubleshooting\"}),(0,n.jsx)(e.td,{children:\">40%\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"ProtocolQA Open-Ended\"}),(0,n.jsx)(e.td,{children:\"Protocol Troubleshooting\"}),(0,n.jsx)(e.td,{children:\"<54% (expert baseline)\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Tacit Knowledge\"}),(0,n.jsx)(e.td,{children:\"Expert-Level Troubleshooting\"}),(0,n.jsx)(e.td,{children:\"<80% (expert baseline)\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"Cybersecurity Capabilities\"}),`\n`,(0,n.jsx)(e.p,{children:\"o3 shows improved cyberoffensive capabilities but fails to solve professional-level Capture the Flag (CTF) challenges or realistic cyber range scenarios without solver code, indicating limited autonomous risk.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Capability\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"CTF (High School)\"}),(0,n.jsx)(e.td,{children:\"Vulnerability Exploitation\"}),(0,n.jsx)(e.td,{children:\"89%\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"CTF (Professional)\"}),(0,n.jsx)(e.td,{children:\"Vulnerability Exploitation\"}),(0,n.jsx)(e.td,{children:\"59%\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"Cyber Range (Online Retailer)\"}),(0,n.jsx)(e.td,{children:\"End-to-End Operations\"}),(0,n.jsx)(e.td,{children:\"0% (without solver code)\"})]})]})]}),`\n`,(0,n.jsx)(e.h3,{children:\"AI Self-Improvement\"}),`\n`,(0,n.jsx)(e.p,{children:\"o3 excels in well-specified coding tasks (e.g., 71% on SWE-Bench Verified) but struggles with open-ended research tasks, suggesting it lacks capabilities for autonomous research.\"}),`\n`,(0,n.jsxs)(e.table,{children:[(0,n.jsx)(e.thead,{children:(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.th,{children:\"Evaluation\"}),(0,n.jsx)(e.th,{children:\"Capability\"}),(0,n.jsx)(e.th,{children:\"o3 Score\"})]})}),(0,n.jsxs)(e.tbody,{children:[(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"SWE-Bench Verified\"}),(0,n.jsx)(e.td,{children:\"Software Engineering\"}),(0,n.jsx)(e.td,{children:\"71% (helpful-only)\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"OpenAI PRs\"}),(0,n.jsx)(e.td,{children:\"ML Research Tasks\"}),(0,n.jsx)(e.td,{children:\"44%\"})]}),(0,n.jsxs)(e.tr,{children:[(0,n.jsx)(e.td,{children:\"PaperBench\"}),(0,n.jsx)(e.td,{children:\"Research Replication\"}),(0,n.jsx)(e.td,{children:\"18%\"})]})]})]}),`\n`,(0,n.jsx)(e.h2,{children:\"Safeguards and Mitigations\"}),`\n`,(0,n.jsx)(e.p,{children:\"OpenAI implemented several mitigations to address safety risks:\"}),`\n`,(0,n.jsxs)(e.ul,{children:[`\n`,(0,n.jsx)(e.li,{children:\"Pre-training data filtering to remove harmful content.\"}),`\n`,(0,n.jsx)(e.li,{children:\"Post-training to refuse high-risk biological requests.\"}),`\n`,(0,n.jsx)(e.li,{children:\"Safety-focused reasoning monitor with 98.7% recall on biorisk red-teaming.\"}),`\n`,(0,n.jsx)(e.li,{children:\"Enhanced monitoring for cybersecurity threats and scaled content moderation classifiers.\"}),`\n`]}),`\n`,(0,n.jsx)(e.h2,{children:\"Third-Party Assessments\"}),`\n`,(0,n.jsx)(e.p,{children:\"External evaluations by METR, Apollo Research, and Pattern Labs provided insights into o3\\u2019s capabilities:\"}),`\n`,(0,n.jsxs)(e.ul,{children:[`\n`,(0,n.jsx)(e.li,{children:\"METR: Found o3 capable of 1-hour 30-minute tasks with 50% reliability, with 1% of tasks showing reward hacking.\"}),`\n`,(0,n.jsx)(e.li,{children:\"Apollo Research: Identified in-context scheming and strategic deception, though catastrophic harm is unlikely.\"}),`\n`,(0,n.jsx)(e.li,{children:\"Pattern Labs: Noted 51% success in evasion challenges but limited assistance to skilled cyberoffensive operators.\"}),`\n`]}),`\n`,(0,n.jsx)(e.h2,{children:\"Conclusion\"}),`\n`,(0,n.jsx)(e.p,{children:\"OpenAI o3 represents a significant advancement in reasoning and tool use, with robust safety measures ensuring it does not pose high risks in biological, cybersecurity, or AI self-improvement domains. Its performance in multilingual tasks and multimodal safety is notable, though ongoing monitoring and mitigation enhancements are critical to address emerging risks.\"})]})}function s(i={}){let{wrapper:e}=i.components||{};return e?(0,n.jsx)(e,{...i,children:(0,n.jsx)(o,{...i})}):o(i)}return S(w);})();\n;return Component;",
    "slug": "o3",
    "readingTime": "6 min read"
  },
  {
    "content": "OpenAI o4-mini is a compact multimodal model that handles text + images, runs 200 k-token contexts, and matches GPT-4–level accuracy on math and coding while costing far less &mdash; $1.1 per M input token. It’s tuned for disciplined reasoning—refusing unsafe requests, following system instructions, and using built-in tools (web, Python, image crop) when they sharpen the answer.\n\nFor developers, o4-mini means one cheaper endpoint that can chat, write code, analyze images, and trigger tool calls without stitching services together. You get fast first-token latency, high output speed, and pricing that lets you ship larger contexts, richer agents, and production apps on a lean budget.",
    "name": "o4-mini (high)",
    "release_date": new Date("2025-04-16T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 69.83,
      "math_index": 96.43,
      "coding_index": 63.48,
      "benchmarks": {
        "mmlu_pro": 0.832,
        "gpqa": 0.784,
        "hle": 0.175,
        "scicode": 0.465,
        "aime": 0.94,
        "math_500": 0.989,
        "livecodebench": 0.804,
        "humaneval": 0.99
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.1,
        "output": 4.4,
        "blended_3_to_1": 1.925
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 148.6,
      "time_to_first_token_ms": 38.9,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 42.27,
        "input_time_seconds": 38.9,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.36
      }
    },
    "aider": {
      "correct": 72,
      "cost": 19.64,
      "price_per_input_token": 0.0000011,
      "correct_edit_format": 90.7
    },
    "_meta": {
      "filePath": "o4-mini.mdx",
      "fileName": "o4-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "o4-mini"
    },
    "title": "o4-mini (high)",
    "body": "var Component=(()=>{var p=Object.create;var s=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var g=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var x=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),w=(e,n)=>{for(var a in n)s(e,a,{get:n[a],enumerable:!0})},r=(e,n,a,i)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of m(n))!f.call(e,o)&&o!==a&&s(e,o,{get:()=>n[o],enumerable:!(i=u(n,o))||i.enumerable});return e};var y=(e,n,a)=>(a=e!=null?p(g(e)):{},r(n||!e||!e.__esModule?s(a,\"default\",{value:e,enumerable:!0}):a,e)),_=e=>r(s({},\"__esModule\",{value:!0}),e);var l=x((M,c)=>{c.exports=_jsx_runtime});var j={};w(j,{default:()=>d});var t=y(l());function h(e){let n={a:\"a\",p:\"p\",...e.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsxs)(n.p,{children:[(0,t.jsx)(n.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\" o4-mini is a compact multimodal model that handles text + images, runs 200 k-token contexts, and matches GPT-4\\u2013level accuracy on math and coding while costing far less \\u2014 $1.1 per M input token. It\\u2019s tuned for disciplined reasoning\\u2014refusing unsafe requests, following system instructions, and using built-in tools (web, Python, image crop) when they sharpen the answer.\"]}),`\n`,(0,t.jsx)(n.p,{children:\"For developers, o4-mini means one cheaper endpoint that can chat, write code, analyze images, and trigger tool calls without stitching services together. You get fast first-token latency, high output speed, and pricing that lets you ship larger contexts, richer agents, and production apps on a lean budget.\"})]})}function d(e={}){let{wrapper:n}=e.components||{};return n?(0,t.jsx)(n,{...e,children:(0,t.jsx)(h,{...e})}):h(e)}return _(j);})();\n;return Component;",
    "slug": "o4-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "OpenChat 3.5 (1210)",
    "release_date": new Date("2023-12-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "OpenChat",
      "url": "https://github.com/imoneoi/openchat",
      "logo_url": "/logos/openchat.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 19.770000457763672,
      "math_index": 15.37,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 0.31,
        "gpqa": 0.23,
        "hle": 0.048,
        "scicode": null,
        "aime": 0,
        "math_500": 0.307,
        "livecodebench": 0.115,
        "humaneval": 0.677
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.05,
        "output": 0.05,
        "blended_3_to_1": 0.05
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 47.47,
      "time_to_first_token_ms": 0.42,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 10.95,
        "input_time_seconds": 0.42,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 10.53
      }
    },
    "_meta": {
      "filePath": "openchat-35.mdx",
      "fileName": "openchat-35.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "openchat-35"
    },
    "title": "OpenChat 3.5 (1210)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "openchat-35",
    "readingTime": "0 min read"
  },
  {
    "content": "# PALM-2",
    "name": "PALM-2",
    "release_date": new Date("2023-05-10T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 8000,
    "creator": {
      "name": "Google",
      "url": "https://deepmind.google/technologies/gemini/",
      "logo_url": "/logos/google.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 21,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "palm-2.mdx",
      "fileName": "palm-2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "palm-2"
    },
    "title": "PALM-2",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!M.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=j((X,i)=>{i.exports=_jsx_runtime});var D={};l(D,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"PALM-2\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "palm-2",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Phi-3 Medium Instruct 14B",
    "release_date": new Date("2024-05-21T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Microsoft Azure",
      "url": "https://azure.microsoft.com/en-us",
      "logo_url": "/logos/microsoft.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 24.54,
      "math_index": 23.8,
      "coding_index": 13.42,
      "benchmarks": {
        "mmlu_pro": 0.543,
        "gpqa": 0.326,
        "hle": 0.045,
        "scicode": 0.118,
        "aime": 0.013,
        "math_500": 0.463,
        "livecodebench": 0.15,
        "humaneval": 0
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.17,
        "output": 0.68,
        "blended_3_to_1": 0.2975
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 52.7,
      "time_to_first_token_ms": 0.42,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.91,
        "input_time_seconds": 0.42,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.49
      }
    },
    "_meta": {
      "filePath": "phi-3-medium.mdx",
      "fileName": "phi-3-medium.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "phi-3-medium"
    },
    "title": "Phi-3 Medium Instruct 14B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "phi-3-medium",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Phi-3 Mini Instruct 3.8B",
    "release_date": new Date("2024-04-23T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4096,
    "creator": {
      "name": "Microsoft Azure",
      "url": "https://azure.microsoft.com/en-us",
      "logo_url": "/logos/microsoft.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 22.1,
      "math_index": 24.83,
      "coding_index": 10.33,
      "benchmarks": {
        "mmlu_pro": 0.435,
        "gpqa": 0.319,
        "hle": 0.044,
        "scicode": 0.09,
        "aime": 0.04,
        "math_500": 0.457,
        "livecodebench": 0.116,
        "humaneval": 0.251
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "phi-3-mini.mdx",
      "fileName": "phi-3-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "phi-3-mini"
    },
    "title": "Phi-3 Mini Instruct 3.8B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "phi-3-mini",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Phi-4 Mini Instruct",
    "release_date": new Date("2024-02-26T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Microsoft Azure",
      "url": "https://azure.microsoft.com/en-us",
      "logo_url": "/logos/microsoft.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 25.96,
      "math_index": 36.3,
      "coding_index": 11.68,
      "benchmarks": {
        "mmlu_pro": 0.465,
        "gpqa": 0.331,
        "hle": 0.042,
        "scicode": 0.108,
        "aime": 0.03,
        "math_500": 0.696,
        "livecodebench": 0.126,
        "humaneval": 0.743
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 56.92,
      "time_to_first_token_ms": 0.32,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.1,
        "input_time_seconds": 0.32,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 8.78
      }
    },
    "_meta": {
      "filePath": "phi-4-mini.mdx",
      "fileName": "phi-4-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "phi-4-mini"
    },
    "title": "Phi-4 Mini Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "phi-4-mini",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Phi-4 Multimodal Instruct",
    "release_date": new Date("2025-02-26T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Microsoft Azure",
      "url": "https://azure.microsoft.com/en-us",
      "logo_url": "/logos/microsoft.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 26.91,
      "math_index": 39.3,
      "coding_index": 12.06,
      "benchmarks": {
        "mmlu_pro": 0.485,
        "gpqa": 0.315,
        "hle": 0.044,
        "scicode": 0.11,
        "aime": 0.093,
        "math_500": 0.693,
        "livecodebench": 0.131,
        "humaneval": 0.729
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 21.16,
      "time_to_first_token_ms": 0.35,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 23.98,
        "input_time_seconds": 0.35,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 23.63
      }
    },
    "_meta": {
      "filePath": "phi-4-multimodal.mdx",
      "fileName": "phi-4-multimodal.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "phi-4-multimodal"
    },
    "title": "Phi-4 Multimodal Instruct",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "phi-4-multimodal",
    "readingTime": "0 min read"
  },
  {
    "content": "# Phi-4",
    "name": "Phi-4",
    "release_date": new Date("2024-12-12T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 16000,
    "creator": {
      "name": "Microsoft Azure",
      "url": "https://azure.microsoft.com/en-us",
      "logo_url": "/logos/microsoft.webp"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.22,
      "math_index": 47.67,
      "coding_index": 24.56,
      "benchmarks": {
        "mmlu_pro": 0.714,
        "gpqa": 0.575,
        "hle": 0.041,
        "scicode": 0.26,
        "aime": 0.143,
        "math_500": 0.81,
        "livecodebench": 0.231,
        "humaneval": 0.867
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.125,
        "output": 0.5,
        "blended_3_to_1": 0.21875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 29.55,
      "time_to_first_token_ms": 0.45,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 17.37,
        "input_time_seconds": 0.45,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 16.92
      }
    },
    "_meta": {
      "filePath": "phi-4.mdx",
      "fileName": "phi-4.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "phi-4"
    },
    "title": "Phi-4",
    "body": "var Component=(()=>{var a=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?a(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var h=l((w,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(h());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Phi-4\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "phi-4",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Pixtral Large",
    "release_date": new Date("2024-11-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 37.42,
      "math_index": 39.2,
      "coding_index": 27.65,
      "benchmarks": {
        "mmlu_pro": 0.701,
        "gpqa": 0.505,
        "hle": 0.036,
        "scicode": 0.292,
        "aime": 0.07,
        "math_500": 0.714,
        "livecodebench": 0.261,
        "humaneval": 0.849
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 6,
        "blended_3_to_1": 3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 79.84,
      "time_to_first_token_ms": 0.4,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.66,
        "input_time_seconds": 0.4,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.26
      }
    },
    "_meta": {
      "filePath": "pixtral-large-2411.mdx",
      "fileName": "pixtral-large-2411.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "pixtral-large-2411"
    },
    "title": "Pixtral Large",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "pixtral-large-2411",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Pixtral 12B (2409)",
    "release_date": new Date("2024-09-11T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Mistral",
      "url": "https://mistral.ai/",
      "logo_url": "/logos/mistral.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 23.36,
      "math_index": 22.9,
      "coding_index": 12.54,
      "benchmarks": {
        "mmlu_pro": 0.473,
        "gpqa": 0.343,
        "hle": 0.053,
        "scicode": 0.135,
        "aime": 0,
        "math_500": 0.458,
        "livecodebench": 0.115,
        "humaneval": 0.777
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.15,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 67.98,
      "time_to_first_token_ms": 0.37,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.72,
        "input_time_seconds": 0.37,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.36
      }
    },
    "_meta": {
      "filePath": "pixtral.mdx",
      "fileName": "pixtral.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "pixtral"
    },
    "title": "Pixtral 12B (2409)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "pixtral",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen2.5 Max",
    "release_date": new Date("2025-01-28T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 45.28,
      "math_index": 53.4,
      "coding_index": 34.78,
      "benchmarks": {
        "mmlu_pro": 0.762,
        "gpqa": 0.587,
        "hle": 0.045,
        "scicode": 0.337,
        "aime": 0.233,
        "math_500": 0.835,
        "livecodebench": 0.359,
        "humaneval": 0.929
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1.6,
        "output": 6.4,
        "blended_3_to_1": 2.8
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 41.64,
      "time_to_first_token_ms": 1.36,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 13.36,
        "input_time_seconds": 1.36,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 12.01
      }
    },
    "_meta": {
      "filePath": "qwen-2-5-max.mdx",
      "fileName": "qwen-2-5-max.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen-2-5-max"
    },
    "title": "Qwen2.5 Max",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen-2-5-max",
    "readingTime": "0 min read"
  },
  {
    "content": "# Qwen Chat 14B",
    "name": "Qwen Chat 14B",
    "release_date": new Date("2023-09-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 8192,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 14,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "qwen-chat-14b.mdx",
      "fileName": "qwen-chat-14b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen-chat-14b"
    },
    "title": "Qwen Chat 14B",
    "body": "var Component=(()=>{var x=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?x(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>u(r({},\"__esModule\",{value:!0}),n);var h=l((X,a)=>{a.exports=_jsx_runtime});var w={};C(w,{default:()=>m});var c=M(h());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Qwen Chat 14B\"})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return p(w);})();\n;return Component;",
    "slug": "qwen-chat-14b",
    "readingTime": "1 min read"
  },
  {
    "content": "# Qwen Chat 72B",
    "name": "Qwen Chat 72B",
    "release_date": new Date("2023-11-30T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 33792,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 22,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1,
        "output": 1,
        "blended_3_to_1": 1
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "qwen-chat-72b.mdx",
      "fileName": "qwen-chat-72b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen-chat-72b"
    },
    "title": "Qwen Chat 72B",
    "body": "var Component=(()=>{var x=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?x(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>u(r({},\"__esModule\",{value:!0}),n);var h=l((X,a)=>{a.exports=_jsx_runtime});var w={};C(w,{default:()=>m});var c=M(h());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Qwen Chat 72B\"})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return p(w);})();\n;return Component;",
    "slug": "qwen-chat-72b",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Qwen2.5 Turbo",
    "release_date": new Date("2024-11-18T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 1000000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.6,
      "math_index": 46.27,
      "coding_index": 15.79,
      "benchmarks": {
        "mmlu_pro": 0.633,
        "gpqa": 0.41,
        "hle": 0.042,
        "scicode": 0.153,
        "aime": 0.12,
        "math_500": 0.805,
        "livecodebench": 0.163,
        "humaneval": 0.846
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.05,
        "output": 0.2,
        "blended_3_to_1": 0.0875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 106.12,
      "time_to_first_token_ms": 1.04,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.76,
        "input_time_seconds": 1.04,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.71
      }
    },
    "_meta": {
      "filePath": "qwen-turbo.mdx",
      "fileName": "qwen-turbo.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen-turbo"
    },
    "title": "Qwen2.5 Turbo",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen-turbo",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen1.5 Chat 110B",
    "release_date": new Date("2024-04-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 25,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": 0.289,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 23.67,
      "time_to_first_token_ms": 1.51,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 22.64,
        "input_time_seconds": 1.51,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 21.12
      }
    },
    "_meta": {
      "filePath": "qwen1.5-110b-chat.mdx",
      "fileName": "qwen1.5-110b-chat.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen1.5-110b-chat"
    },
    "title": "Qwen1.5 Chat 110B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen1.5-110b-chat",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen2.5 Instruct 72B",
    "release_date": new Date("2024-09-19T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 131072,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.41,
      "math_index": 50.9,
      "coding_index": 27.18,
      "benchmarks": {
        "mmlu_pro": 0.72,
        "gpqa": 0.491,
        "hle": 0.042,
        "scicode": 0.267,
        "aime": 0.16,
        "math_500": 0.858,
        "livecodebench": 0.276,
        "humaneval": 0.883
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 58.09,
      "time_to_first_token_ms": 1.27,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.88,
        "input_time_seconds": 1.27,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 8.61
      }
    },
    "_meta": {
      "filePath": "qwen2-5-72b-instruct.mdx",
      "fileName": "qwen2-5-72b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen2-5-72b-instruct"
    },
    "title": "Qwen2.5 Instruct 72B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen2-5-72b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen2.5 Coder Instruct 32B",
    "release_date": new Date("2024-11-11T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 131072,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 36.33,
      "math_index": 44.33,
      "coding_index": 28.3,
      "benchmarks": {
        "mmlu_pro": 0.635,
        "gpqa": 0.417,
        "hle": 0.038,
        "scicode": 0.271,
        "aime": 0.12,
        "math_500": 0.767,
        "livecodebench": 0.295,
        "humaneval": 0.902
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.135,
        "output": 0.18,
        "blended_3_to_1": 0.14625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 52.71,
      "time_to_first_token_ms": 0.38,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.87,
        "input_time_seconds": 0.38,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 9.49
      }
    },
    "aider": {
      "correct": 8,
      "cost": null,
      "price_per_input_token": null,
      "correct_edit_format": 71.6
    },
    "_meta": {
      "filePath": "qwen2-5-coder-32b-instruct.mdx",
      "fileName": "qwen2-5-coder-32b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen2-5-coder-32b-instruct"
    },
    "title": "Qwen2.5 Coder Instruct 32B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen2-5-coder-32b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen2.5 Coder Instruct 7B ",
    "release_date": new Date("2024-09-19T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 131072,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 26.69,
      "math_index": 35.67,
      "coding_index": 13.7,
      "benchmarks": {
        "mmlu_pro": 0.473,
        "gpqa": 0.339,
        "hle": 0.048,
        "scicode": 0.148,
        "aime": 0.053,
        "math_500": 0.66,
        "livecodebench": 0.126,
        "humaneval": 0.899
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "qwen2-5-coder-7b-instruct.mdx",
      "fileName": "qwen2-5-coder-7b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen2-5-coder-7b-instruct"
    },
    "title": "Qwen2.5 Coder Instruct 7B ",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen2-5-coder-7b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen2 Instruct 72B",
    "release_date": new Date("2024-06-07T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 131072,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 32.6,
      "math_index": 42.4,
      "coding_index": 19.39,
      "benchmarks": {
        "mmlu_pro": 0.622,
        "gpqa": 0.371,
        "hle": 0.037,
        "scicode": 0.229,
        "aime": 0.147,
        "math_500": 0.701,
        "livecodebench": 0.159,
        "humaneval": 0.826
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 30.78,
      "time_to_first_token_ms": 1.36,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 17.6,
        "input_time_seconds": 1.36,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 16.24
      }
    },
    "_meta": {
      "filePath": "qwen2-72b-instruct.mdx",
      "fileName": "qwen2-72b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen2-72b-instruct"
    },
    "title": "Qwen2 Instruct 72B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen2-72b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen2.5 Instruct 32B",
    "release_date": new Date("2024-09-19T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 37.41,
      "math_index": 45.77,
      "coding_index": 23.84,
      "benchmarks": {
        "mmlu_pro": 0.697,
        "gpqa": 0.466,
        "hle": 0.038,
        "scicode": 0.229,
        "aime": 0.11,
        "math_500": 0.805,
        "livecodebench": 0.248,
        "humaneval": 0.9
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.095,
        "output": 0.30000000000000004,
        "blended_3_to_1": 0.14625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "qwen2.5-32b-instruct.mdx",
      "fileName": "qwen2.5-32b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen2.5-32b-instruct"
    },
    "title": "Qwen2.5 Instruct 32B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen2.5-32b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 0.6B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 23.2,
      "math_index": 42.5,
      "coding_index": 7.42,
      "benchmarks": {
        "mmlu_pro": 0.347,
        "gpqa": 0.239,
        "hle": 0.057,
        "scicode": 0.028,
        "aime": 0.1,
        "math_500": 0.75,
        "livecodebench": 0.121,
        "humaneval": 0.49
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.11,
        "output": 1.26,
        "blended_3_to_1": 0.3975
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 227.88,
      "time_to_first_token_ms": 0.91,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.88,
        "input_time_seconds": 0.91,
        "reasoning_time_seconds": 8.78,
        "answer_time_seconds": 2.19
      }
    },
    "_meta": {
      "filePath": "qwen3-0.6b-instruct-reasoning.mdx",
      "fileName": "qwen3-0.6b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-0.6b-instruct-reasoning"
    },
    "title": "Qwen3 0.6B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-0.6b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 0.6B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 16.7,
      "math_index": 26.87,
      "coding_index": 5.68,
      "benchmarks": {
        "mmlu_pro": 0.231,
        "gpqa": 0.231,
        "hle": 0.052,
        "scicode": 0.041,
        "aime": 0.017,
        "math_500": 0.521,
        "livecodebench": 0.073,
        "humaneval": 0.338
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.11,
        "output": 0.42,
        "blended_3_to_1": 0.1875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 232.28,
      "time_to_first_token_ms": 0.96,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 3.11,
        "input_time_seconds": 0.96,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 2.15
      }
    },
    "_meta": {
      "filePath": "qwen3-0.6b-instruct.mdx",
      "fileName": "qwen3-0.6b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-0.6b-instruct"
    },
    "title": "Qwen3 0.6B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-0.6b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 1.7B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 38.15,
      "math_index": 70.2,
      "coding_index": 17.54,
      "benchmarks": {
        "mmlu_pro": 0.57,
        "gpqa": 0.356,
        "hle": 0.048,
        "scicode": 0.043,
        "aime": 0.51,
        "math_500": 0.894,
        "livecodebench": 0.308,
        "humaneval": 0.854
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.11,
        "output": 1.26,
        "blended_3_to_1": 0.3975
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 137.82,
      "time_to_first_token_ms": 0.95,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 19.09,
        "input_time_seconds": 0.95,
        "reasoning_time_seconds": 14.51,
        "answer_time_seconds": 3.63
      }
    },
    "_meta": {
      "filePath": "qwen3-1.7b-instruct-reasoning.mdx",
      "fileName": "qwen3-1.7b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-1.7b-instruct-reasoning"
    },
    "title": "Qwen3 1.7B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-1.7b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 1.7B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 25.04,
      "math_index": 40.7,
      "coding_index": 9.77,
      "benchmarks": {
        "mmlu_pro": 0.411,
        "gpqa": 0.283,
        "hle": 0.052,
        "scicode": 0.069,
        "aime": 0.097,
        "math_500": 0.717,
        "livecodebench": 0.126,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.11,
        "output": 0.42,
        "blended_3_to_1": 0.1875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 141.01,
      "time_to_first_token_ms": 1.05,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.59,
        "input_time_seconds": 1.05,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.55
      }
    },
    "_meta": {
      "filePath": "qwen3-1.7b-instruct.mdx",
      "fileName": "qwen3-1.7b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-1.7b-instruct"
    },
    "title": "Qwen3 1.7B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-1.7b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 14B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 55.72,
      "math_index": 86.23,
      "coding_index": 41.94,
      "benchmarks": {
        "mmlu_pro": 0.774,
        "gpqa": 0.604,
        "hle": 0.043,
        "scicode": 0.316,
        "aime": 0.763,
        "math_500": 0.961,
        "livecodebench": 0.523,
        "humaneval": 0.963
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.35,
        "output": 4.2,
        "blended_3_to_1": 1.3125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 65.59,
      "time_to_first_token_ms": 1.03,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 39.15,
        "input_time_seconds": 1.03,
        "reasoning_time_seconds": 30.49,
        "answer_time_seconds": 7.62
      }
    },
    "_meta": {
      "filePath": "qwen3-14b-instruct-reasoning.mdx",
      "fileName": "qwen3-14b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-14b-instruct-reasoning"
    },
    "title": "Qwen3 14B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-14b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 14B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 40.98,
      "math_index": 57.57,
      "coding_index": 27.27,
      "benchmarks": {
        "mmlu_pro": 0.675,
        "gpqa": 0.47,
        "hle": 0.042,
        "scicode": 0.265,
        "aime": 0.28,
        "math_500": 0.871,
        "livecodebench": 0.28,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.35,
        "output": 1.4,
        "blended_3_to_1": 0.6125
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 66.54,
      "time_to_first_token_ms": 1.05,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.56,
        "input_time_seconds": 1.05,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.51
      }
    },
    "_meta": {
      "filePath": "qwen3-14b-instruct.mdx",
      "fileName": "qwen3-14b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-14b-instruct"
    },
    "title": "Qwen3 14B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-14b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 235B A22B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 62.32,
      "math_index": 88.5,
      "coding_index": 51.08,
      "benchmarks": {
        "mmlu_pro": 0.828,
        "gpqa": 0.7,
        "hle": 0.117,
        "scicode": 0.399,
        "aime": 0.84,
        "math_500": 0.93,
        "livecodebench": 0.622,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7,
        "output": 8.4,
        "blended_3_to_1": 2.625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 70.44,
      "time_to_first_token_ms": 1.23,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 36.72,
        "input_time_seconds": 1.23,
        "reasoning_time_seconds": 28.39,
        "answer_time_seconds": 7.1
      }
    },
    "_meta": {
      "filePath": "qwen3-235b-a22b-instruct-reasoning.mdx",
      "fileName": "qwen3-235b-a22b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-235b-a22b-instruct-reasoning"
    },
    "title": "Qwen3 235B A22B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-235b-a22b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 235B A22B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 47.09,
      "math_index": 61.43,
      "coding_index": 32.07,
      "benchmarks": {
        "mmlu_pro": 0.762,
        "gpqa": 0.613,
        "hle": 0.047,
        "scicode": 0.299,
        "aime": 0.327,
        "math_500": 0.902,
        "livecodebench": 0.343,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7,
        "output": 2.8,
        "blended_3_to_1": 1.225
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 70.21,
      "time_to_first_token_ms": 1.17,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 8.29,
        "input_time_seconds": 1.17,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.12
      }
    },
    "aider": {
      "correct": 59.6,
      "cost": null,
      "price_per_input_token": 1e-7,
      "correct_edit_format": 92.9
    },
    "_meta": {
      "filePath": "qwen3-235b-a22b-instruct.mdx",
      "fileName": "qwen3-235b-a22b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-235b-a22b-instruct"
    },
    "title": "Qwen3 235B A22B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-235b-a22b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 30B A3B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 55.6,
      "math_index": 85.63,
      "coding_index": 39.53,
      "benchmarks": {
        "mmlu_pro": 0.777,
        "gpqa": 0.616,
        "hle": 0.066,
        "scicode": 0.285,
        "aime": 0.753,
        "math_500": 0.959,
        "livecodebench": 0.506,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 2.4,
        "blended_3_to_1": 0.75
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 91.99,
      "time_to_first_token_ms": 1.11,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 28.28,
        "input_time_seconds": 1.11,
        "reasoning_time_seconds": 21.74,
        "answer_time_seconds": 5.44
      }
    },
    "_meta": {
      "filePath": "qwen3-30b-a3b-instruct-reasoning.mdx",
      "fileName": "qwen3-30b-a3b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-30b-a3b-instruct-reasoning"
    },
    "title": "Qwen3 30B A3B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-30b-a3b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 30B A3B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 42.55,
      "math_index": 56.13,
      "coding_index": 29.28,
      "benchmarks": {
        "mmlu_pro": 0.71,
        "gpqa": 0.515,
        "hle": 0.046,
        "scicode": 0.264,
        "aime": 0.26,
        "math_500": 0.863,
        "livecodebench": 0.322,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.8,
        "blended_3_to_1": 0.35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 92.75,
      "time_to_first_token_ms": 1.03,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.42,
        "input_time_seconds": 1.03,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.39
      }
    },
    "_meta": {
      "filePath": "qwen3-30b-a3b-instruct.mdx",
      "fileName": "qwen3-30b-a3b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-30b-a3b-instruct"
    },
    "title": "Qwen3 30B A3B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-30b-a3b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 32B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 59.16,
      "math_index": 88.37,
      "coding_index": 45.01,
      "benchmarks": {
        "mmlu_pro": 0.798,
        "gpqa": 0.668,
        "hle": 0.083,
        "scicode": 0.354,
        "aime": 0.807,
        "math_500": 0.961,
        "livecodebench": 0.546,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7,
        "output": 8.4,
        "blended_3_to_1": 2.625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 60.06,
      "time_to_first_token_ms": 1.12,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 42.75,
        "input_time_seconds": 1.12,
        "reasoning_time_seconds": 33.3,
        "answer_time_seconds": 8.33
      }
    },
    "_meta": {
      "filePath": "qwen3-32b-instruct-reasoning.mdx",
      "fileName": "qwen3-32b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-32b-instruct-reasoning"
    },
    "title": "Qwen3 32B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-32b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 32B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 43.52,
      "math_index": 58.6,
      "coding_index": 28.4,
      "benchmarks": {
        "mmlu_pro": 0.727,
        "gpqa": 0.535,
        "hle": 0.043,
        "scicode": 0.28,
        "aime": 0.303,
        "math_500": 0.869,
        "livecodebench": 0.288,
        "humaneval": 0.896
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.7,
        "output": 2.8,
        "blended_3_to_1": 1.225
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 60.74,
      "time_to_first_token_ms": 1.05,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 9.29,
        "input_time_seconds": 1.05,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 8.23
      }
    },
    "aider": {
      "correct": 40,
      "cost": 0.76,
      "price_per_input_token": 1e-7,
      "correct_edit_format": 83.6
    },
    "_meta": {
      "filePath": "qwen3-32b-instruct.mdx",
      "fileName": "qwen3-32b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-32b-instruct"
    },
    "title": "Qwen3 32B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-32b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 4B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 47.26,
      "math_index": 79.5,
      "coding_index": 24.96,
      "benchmarks": {
        "mmlu_pro": 0.696,
        "gpqa": 0.522,
        "hle": 0.051,
        "scicode": 0.035,
        "aime": 0.657,
        "math_500": 0.933,
        "livecodebench": 0.465,
        "humaneval": 0.909
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.11,
        "output": 1.26,
        "blended_3_to_1": 0.3975
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 104.54,
      "time_to_first_token_ms": 1.01,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 24.92,
        "input_time_seconds": 1.01,
        "reasoning_time_seconds": 19.13,
        "answer_time_seconds": 4.78
      }
    },
    "_meta": {
      "filePath": "qwen3-4b-instruct-reasoning.mdx",
      "fileName": "qwen3-4b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-4b-instruct-reasoning"
    },
    "title": "Qwen3 4B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-4b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 4B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 35.21,
      "math_index": 52.8,
      "coding_index": 19.97,
      "benchmarks": {
        "mmlu_pro": 0.586,
        "gpqa": 0.398,
        "hle": 0.037,
        "scicode": 0.167,
        "aime": 0.213,
        "math_500": 0.843,
        "livecodebench": 0.233,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.11,
        "output": 0.42,
        "blended_3_to_1": 0.1875
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 106.43,
      "time_to_first_token_ms": 1.05,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 5.75,
        "input_time_seconds": 1.05,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 4.7
      }
    },
    "_meta": {
      "filePath": "qwen3-4b-instruct.mdx",
      "fileName": "qwen3-4b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-4b-instruct"
    },
    "title": "Qwen3 4B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-4b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 8B (Reasoning)",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 51.43,
      "math_index": 82.53,
      "coding_index": 31.6,
      "benchmarks": {
        "mmlu_pro": 0.743,
        "gpqa": 0.589,
        "hle": 0.042,
        "scicode": 0.226,
        "aime": 0.747,
        "math_500": 0.904,
        "livecodebench": 0.406,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.18,
        "output": 2.1,
        "blended_3_to_1": 0.66
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 98.69,
      "time_to_first_token_ms": 1.06,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 26.39,
        "input_time_seconds": 1.06,
        "reasoning_time_seconds": 20.27,
        "answer_time_seconds": 5.07
      }
    },
    "_meta": {
      "filePath": "qwen3-8b-instruct-reasoning.mdx",
      "fileName": "qwen3-8b-instruct-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-8b-instruct-reasoning"
    },
    "title": "Qwen3 8B (Reasoning)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-8b-instruct-reasoning",
    "readingTime": "0 min read"
  },
  {
    "content": "",
    "name": "Qwen3 8B",
    "release_date": new Date("2025-04-28T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 36.72,
      "math_index": 53.57,
      "coding_index": 18.5,
      "benchmarks": {
        "mmlu_pro": 0.643,
        "gpqa": 0.452,
        "hle": 0.028,
        "scicode": 0.168,
        "aime": 0.243,
        "math_500": 0.828,
        "livecodebench": 0.202,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.18,
        "output": 0.7,
        "blended_3_to_1": 0.31
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 100.07,
      "time_to_first_token_ms": 1.02,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.02,
        "input_time_seconds": 1.02,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5
      }
    },
    "_meta": {
      "filePath": "qwen3-8b-instruct.mdx",
      "fileName": "qwen3-8b-instruct.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwen3-8b-instruct"
    },
    "title": "Qwen3 8B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "qwen3-8b-instruct",
    "readingTime": "0 min read"
  },
  {
    "content": "# QwQ 32B-Preview",
    "name": "QwQ 32B-Preview",
    "release_date": new Date("2024-11-27T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 32768,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 42.6,
      "math_index": 68.17,
      "coding_index": 18.74,
      "benchmarks": {
        "mmlu_pro": 0.648,
        "gpqa": 0.557,
        "hle": 0.048,
        "scicode": 0.038,
        "aime": 0.453,
        "math_500": 0.91,
        "livecodebench": 0.337,
        "humaneval": 0.867
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.2,
        "blended_3_to_1": 0.2
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 50.97,
      "time_to_first_token_ms": 0.55,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 49.6,
        "input_time_seconds": 0.55,
        "reasoning_time_seconds": 39.24,
        "answer_time_seconds": 9.81
      }
    },
    "_meta": {
      "filePath": "qwq-32b-preview.mdx",
      "fileName": "qwq-32b-preview.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwq-32b-preview"
    },
    "title": "QwQ 32B-Preview",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),w=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>s(r({},\"__esModule\",{value:!0}),n);var m=l((Q,u)=>{u.exports=_jsx_runtime});var C={};w(C,{default:()=>a});var c=M(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"QwQ 32B-Preview\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return p(C);})();\n;return Component;",
    "slug": "qwq-32b-preview",
    "readingTime": "1 min read"
  },
  {
    "content": "# QwQ 32B",
    "name": "QwQ 32B",
    "release_date": new Date("2025-03-05T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 131072,
    "creator": {
      "name": "Alibaba",
      "url": "https://www.alibabacloud.com/",
      "logo_url": "/logos/alibaba.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 58.06,
      "math_index": 86.87,
      "coding_index": 49.42,
      "benchmarks": {
        "mmlu_pro": 0.764,
        "gpqa": 0.593,
        "hle": 0.082,
        "scicode": 0.358,
        "aime": 0.78,
        "math_500": 0.957,
        "livecodebench": 0.631,
        "humaneval": 0.976
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.5,
        "output": 0.65,
        "blended_3_to_1": 0.625
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 96.5,
      "time_to_first_token_ms": 0.43,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 31.42,
        "input_time_seconds": 0.43,
        "reasoning_time_seconds": 25.81,
        "answer_time_seconds": 5.18
      }
    },
    "aider": {
      "correct": 20.9,
      "cost": null,
      "price_per_input_token": null,
      "correct_edit_format": 67.6
    },
    "_meta": {
      "filePath": "qwq-32b.mdx",
      "fileName": "qwq-32b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "qwq-32b"
    },
    "title": "QwQ 32B",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),w=n=>u(r({},\"__esModule\",{value:!0}),n);var m=l((Q,i)=>{i.exports=_jsx_runtime});var C={};M(C,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"QwQ 32B\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return w(C);})();\n;return Component;",
    "slug": "qwq-32b",
    "readingTime": "1 min read"
  },
  {
    "content": "# R1 1776",
    "name": "R1 1776",
    "release_date": new Date("2025-02-18T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Perplexity",
      "url": "https://perplexity.ai/",
      "logo_url": "/logos/perplexity.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.650001525878906,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.954,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 8,
        "blended_3_to_1": 3.5
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "r1-1776.mdx",
      "fileName": "r1-1776.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "r1-1776"
    },
    "title": "R1 1776",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var m=l((w,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>a});var c=p(m());function x(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"R1 1776\"})}function a(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(x,{...n})}):x(n)}return C(D);})();\n;return Component;",
    "slug": "r1-1776",
    "readingTime": "1 min read"
  },
  {
    "content": "# Reka Core",
    "name": "Reka Core",
    "release_date": new Date("2024-04-15T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Reka AI",
      "url": "http://reka.ai/",
      "logo_url": "/logos/reka.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.869998931884766,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.558,
        "livecodebench": null,
        "humaneval": 0.726
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 2,
        "output": 2,
        "blended_3_to_1": 2
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 27.02,
      "time_to_first_token_ms": 0.85,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 19.36,
        "input_time_seconds": 0.85,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 18.5
      }
    },
    "_meta": {
      "filePath": "reka-core.mdx",
      "fileName": "reka-core.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "reka-core"
    },
    "title": "Reka Core",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),C=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),p=n=>u(r({},\"__esModule\",{value:!0}),n);var i=l((k,a)=>{a.exports=_jsx_runtime});var D={};C(D,{default:()=>x});var c=M(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Reka Core\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return p(D);})();\n;return Component;",
    "slug": "reka-core",
    "readingTime": "1 min read"
  },
  {
    "content": "# Reka Edge",
    "name": "Reka Edge",
    "release_date": new Date("2024-02-12T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Reka AI",
      "url": "http://reka.ai/",
      "logo_url": "/logos/reka.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 32.97999954223633,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.216,
        "livecodebench": null,
        "humaneval": 0.409
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.1,
        "output": 0.1,
        "blended_3_to_1": 0.1
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 82.85,
      "time_to_first_token_ms": 0.83,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.86,
        "input_time_seconds": 0.83,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 6.03
      }
    },
    "_meta": {
      "filePath": "reka-edge.mdx",
      "fileName": "reka-edge.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "reka-edge"
    },
    "title": "Reka Edge",
    "body": "var Component=(()=>{var d=Object.create;var r=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of _(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=h(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?d(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var i=l((g,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Reka Edge\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "reka-edge",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Reka Flash (Feb '24)",
    "release_date": new Date("2024-02-12T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Reka AI",
      "url": "http://reka.ai/",
      "logo_url": "/logos/reka.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.15999984741211,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.326,
        "livecodebench": null,
        "humaneval": 0.61
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.8,
        "blended_3_to_1": 0.35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 46.12,
      "time_to_first_token_ms": 0.88,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.72,
        "input_time_seconds": 0.88,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 10.84
      }
    },
    "_meta": {
      "filePath": "reka-flash-02-2024.mdx",
      "fileName": "reka-flash-02-2024.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "reka-flash-02-2024"
    },
    "title": "Reka Flash (Feb '24)",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "reka-flash-02-2024",
    "readingTime": "0 min read"
  },
  {
    "content": "# Reka Flash 3",
    "name": "Reka Flash 3",
    "release_date": new Date("2025-03-10T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Reka AI",
      "url": "http://reka.ai/",
      "logo_url": "/logos/reka.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 47.13,
      "math_index": 70.13,
      "coding_index": 35.11,
      "benchmarks": {
        "mmlu_pro": 0.669,
        "gpqa": 0.529,
        "hle": 0.051,
        "scicode": 0.267,
        "aime": 0.51,
        "math_500": 0.893,
        "livecodebench": 0.435,
        "humaneval": 0.95
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.8,
        "blended_3_to_1": 0.35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 57.3,
      "time_to_first_token_ms": 0.94,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 44.57,
        "input_time_seconds": 0.94,
        "reasoning_time_seconds": 34.91,
        "answer_time_seconds": 8.73
      }
    },
    "_meta": {
      "filePath": "reka-flash-3.mdx",
      "fileName": "reka-flash-3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "reka-flash-3"
    },
    "title": "Reka Flash 3",
    "body": "var Component=(()=>{var x=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?x(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var h=j((k,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>m});var c=p(h());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Reka Flash 3\"})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "reka-flash-3",
    "readingTime": "1 min read"
  },
  {
    "content": "# Reka Flash (Sep '24)",
    "name": "Reka Flash (Sep '24)",
    "release_date": new Date("2024-10-04T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Reka AI",
      "url": "http://reka.ai/",
      "logo_url": "/logos/reka.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.58000183105469,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.529,
        "livecodebench": null,
        "humaneval": 0.743
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.2,
        "output": 0.8,
        "blended_3_to_1": 0.35
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 45.45,
      "time_to_first_token_ms": 0.91,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 11.91,
        "input_time_seconds": 0.91,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 11
      }
    },
    "_meta": {
      "filePath": "reka-flash.mdx",
      "fileName": "reka-flash.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "reka-flash"
    },
    "title": "Reka Flash (Sep '24)",
    "body": "var Component=(()=>{var x=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var M=(n,t,e)=>(e=n!=null?x(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var h=j((k,u)=>{u.exports=_jsx_runtime});var D={};p(D,{default:()=>m});var c=M(h());function i(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Reka Flash (Sep '24)\"})}function m(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(i,{...n})}):i(n)}return C(D);})();\n;return Component;",
    "slug": "reka-flash",
    "readingTime": "1 min read"
  },
  {
    "content": "# Solar Mini",
    "name": "Solar Mini",
    "release_date": new Date("2024-01-25T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 4096,
    "creator": {
      "name": "Upstage",
      "url": "https://www.upstage.ai",
      "logo_url": "/logos/upstage.png"
    },
    "intelligence_metrics": {
      "intelligence_index": 33.369998931884766,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": 0.331,
        "livecodebench": null,
        "humaneval": 0.59
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0.15,
        "output": 0.15,
        "blended_3_to_1": 0.15
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 92.87,
      "time_to_first_token_ms": 1.08,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 6.46,
        "input_time_seconds": 1.08,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 5.38
      }
    },
    "_meta": {
      "filePath": "solar-mini.mdx",
      "fileName": "solar-mini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "solar-mini"
    },
    "title": "Solar Mini",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,l=Object.prototype.hasOwnProperty;var M=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),j=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!l.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=M((w,u)=>{u.exports=_jsx_runtime});var D={};j(D,{default:()=>x});var c=p(a());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Solar Mini\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "solar-mini",
    "readingTime": "1 min read"
  },
  {
    "content": "# Sonar Pro",
    "name": "Sonar Pro",
    "release_date": new Date("2025-01-21T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 200000,
    "creator": {
      "name": "Perplexity",
      "url": "https://perplexity.ai/",
      "logo_url": "/logos/perplexity.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 42.73,
      "math_index": 51.73,
      "coding_index": 25.04,
      "benchmarks": {
        "mmlu_pro": 0.755,
        "gpqa": 0.578,
        "hle": 0.079,
        "scicode": 0.226,
        "aime": 0.29,
        "math_500": 0.745,
        "livecodebench": 0.275,
        "humaneval": 0.848
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 15,
        "blended_3_to_1": 6
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 157.07,
      "time_to_first_token_ms": 0.91,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.09,
        "input_time_seconds": 0.91,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.18
      }
    },
    "_meta": {
      "filePath": "sonar-pro.mdx",
      "fileName": "sonar-pro.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "sonar-pro"
    },
    "title": "Sonar Pro",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var i=l((w,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Sonar Pro\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "sonar-pro",
    "readingTime": "1 min read"
  },
  {
    "content": "# Sonar Reasoning",
    "name": "Sonar Reasoning",
    "release_date": new Date("2025-01-28T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 127000,
    "creator": {
      "name": "Perplexity",
      "url": "https://perplexity.ai/",
      "logo_url": "/logos/perplexity.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 48.83000183105469,
      "math_index": 84.57,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": null,
        "gpqa": 0.623,
        "hle": null,
        "scicode": null,
        "aime": 0.77,
        "math_500": 0.921,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1,
        "output": 5,
        "blended_3_to_1": 2
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 87.64,
      "time_to_first_token_ms": 0.63,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 29.16,
        "input_time_seconds": 0.63,
        "reasoning_time_seconds": 22.82,
        "answer_time_seconds": 5.7
      }
    },
    "_meta": {
      "filePath": "sonar-reasoning.mdx",
      "fileName": "sonar-reasoning.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "sonar-reasoning"
    },
    "title": "Sonar Reasoning",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},a=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},a(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>a(r({},\"__esModule\",{value:!0}),n);var u=l((g,i)=>{i.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(u());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Sonar Reasoning\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "sonar-reasoning",
    "readingTime": "1 min read"
  },
  {
    "content": "# Sonar",
    "name": "Sonar",
    "release_date": new Date("2025-01-21T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 127000,
    "creator": {
      "name": "Perplexity",
      "url": "https://perplexity.ai/",
      "logo_url": "/logos/perplexity.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 43.39,
      "math_index": 65.17,
      "coding_index": 26.22,
      "benchmarks": {
        "mmlu_pro": 0.689,
        "gpqa": 0.471,
        "hle": 0.073,
        "scicode": 0.229,
        "aime": 0.487,
        "math_500": 0.817,
        "livecodebench": 0.295,
        "humaneval": 0.82
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 1,
        "output": 1,
        "blended_3_to_1": 1
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 154.36,
      "time_to_first_token_ms": 0.83,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 4.07,
        "input_time_seconds": 0.83,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 3.24
      }
    },
    "_meta": {
      "filePath": "sonar.mdx",
      "fileName": "sonar.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "sonar"
    },
    "title": "Sonar",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},u=(n,t,e,s)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(s=_(t,o))||s.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},u(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>u(r({},\"__esModule\",{value:!0}),n);var i=l((w,a)=>{a.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(i());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Sonar\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "sonar",
    "readingTime": "1 min read"
  },
  {
    "content": "# text-davinci-001\n\nA GPT-3 model from OpenAI released in 2022 with a 4k token window and priced at $20 per million tokens.[^1]\n\n[^1]: Release details from [HN API](https://hn.algolia.com/api/v1/search?query=text-davinci-003) and pricing from [OpenAI deprecations](https://platform.openai.com/docs/deprecations).\n\n## References\n\n1. [New GPT-3 model: text-DaVinci-003](https://beta.openai.com/docs/models/overview)\n2. [GPT (text-DaVinci-003) can run hallucinated scripts](https://twitter.com/jamesjyu/status/1600959843669377025)\n3. [Alpaca-LoRA fine-tuning example](https://github.com/tloen/alpaca-lora)\n4. [Terminal-copilot wrapper](https://github.com/Methexis-Inc/terminal-copilot)\n5. [Chat vs Completions](https://platform.openai.com/docs/guides/chat/chat-vs-completions)\n6. [Mixtral replacement advice](https://jamez.it/blog/2024/01/04/replace-a-fine-tuned-text-davinci-003-with-mixtral-8x7b/)",
    "name": "text-davinci-001",
    "release_date": new Date("2022-01-27T00:00:00.000Z"),
    "favorite": true,
    "open_weights": "Proprietary",
    "context_window_tokens": 4097,
    "creator": {
      "name": "OpenAI",
      "url": "https://openai.com/",
      "logo_url": "/logos/openai.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 6,
      "math_index": null,
      "coding_index": null,
      "benchmarks": {
        "mmlu_pro": 39.7,
        "gpqa": null,
        "hle": null,
        "scicode": null,
        "aime": null,
        "math_500": null,
        "livecodebench": null,
        "humaneval": null
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 60,
        "output": 60,
        "blended_3_to_1": 60
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 0,
      "time_to_first_token_ms": 0,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 0,
        "input_time_seconds": 0,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 0
      }
    },
    "_meta": {
      "filePath": "text-davinci-001.mdx",
      "fileName": "text-davinci-001.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "text-davinci-001"
    },
    "title": "text-davinci-001",
    "body": "var Component=(()=>{var p=Object.create;var r=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var m=Object.getOwnPropertyNames;var u=Object.getPrototypeOf,x=Object.prototype.hasOwnProperty;var b=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),g=(t,e)=>{for(var i in e)r(t,i,{get:e[i],enumerable:!0})},c=(t,e,i,o)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of m(e))!x.call(t,a)&&a!==i&&r(t,a,{get:()=>e[a],enumerable:!(o=f(e,a))||o.enumerable});return t};var v=(t,e,i)=>(i=t!=null?p(u(t)):{},c(e||!t||!t.__esModule?r(i,\"default\",{value:t,enumerable:!0}):i,t)),w=t=>c(r({},\"__esModule\",{value:!0}),t);var h=b((k,l)=>{l.exports=_jsx_runtime});var j={};g(j,{default:()=>d});var n=v(h());function s(t){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:\"text-davinci-001\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"A GPT-3 model from \",(0,n.jsx)(e.a,{href:\"/companies/openai\",children:\"OpenAI\"}),\" released in 2022 with a 4k token window and priced at $20 per million tokens.\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})})]}),`\n`,(0,n.jsx)(e.h2,{children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://beta.openai.com/docs/models/overview\",children:\"New GPT-3 model: text-DaVinci-003\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://twitter.com/jamesjyu/status/1600959843669377025\",children:\"GPT (text-DaVinci-003) can run hallucinated scripts\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://github.com/tloen/alpaca-lora\",children:\"Alpaca-LoRA fine-tuning example\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://github.com/Methexis-Inc/terminal-copilot\",children:\"Terminal-copilot wrapper\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://platform.openai.com/docs/guides/chat/chat-vs-completions\",children:\"Chat vs Completions\"})}),`\n`,(0,n.jsx)(e.li,{children:(0,n.jsx)(e.a,{href:\"https://jamez.it/blog/2024/01/04/replace-a-fine-tuned-text-davinci-003-with-mixtral-8x7b/\",children:\"Mixtral replacement advice\"})}),`\n`]}),`\n`,(0,n.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,n.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,n.jsxs)(e.p,{children:[\"Release details from \",(0,n.jsx)(e.a,{href:\"https://hn.algolia.com/api/v1/search?query=text-davinci-003\",children:\"HN API\"}),\" and pricing from \",(0,n.jsx)(e.a,{href:\"https://platform.openai.com/docs/deprecations\",children:\"OpenAI deprecations\"}),\". \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function d(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(s,{...t})}):s(t)}return w(j);})();\n;return Component;",
    "slug": "text-davinci-001",
    "readingTime": "1 min read"
  },
  {
    "content": "",
    "name": "Llama 3.1 Tulu3 405B",
    "release_date": new Date("2025-01-30T00:00:00.000Z"),
    "open_weights": "Open",
    "context_window_tokens": 128000,
    "creator": {
      "name": "Allen Institute for AI",
      "url": "https://allenai.org/",
      "logo_url": "/logos/ai2.svg"
    },
    "intelligence_metrics": {
      "intelligence_index": 39.92,
      "math_index": 45.57,
      "coding_index": 29.65,
      "benchmarks": {
        "mmlu_pro": 0.716,
        "gpqa": 0.516,
        "hle": 0.035,
        "scicode": 0.302,
        "aime": 0.133,
        "math_500": 0.778,
        "livecodebench": 0.291,
        "humaneval": 0.89
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 0,
        "output": 0,
        "blended_3_to_1": 0
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": null,
      "time_to_first_token_ms": null,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": null,
        "input_time_seconds": null,
        "reasoning_time_seconds": null,
        "answer_time_seconds": null
      }
    },
    "_meta": {
      "filePath": "tulu3-405b.mdx",
      "fileName": "tulu3-405b.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "tulu3-405b"
    },
    "title": "Llama 3.1 Tulu3 405B",
    "body": "var Component=(()=>{var _=Object.create;var a=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var j=Object.getPrototypeOf,M=Object.prototype.hasOwnProperty;var g=(t,n)=>()=>(n||t((n={exports:{}}).exports,n),n.exports),l=(t,n)=>{for(var e in n)a(t,e,{get:n[e],enumerable:!0})},c=(t,n,e,u)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let o of d(n))!M.call(t,o)&&o!==e&&a(t,o,{get:()=>n[o],enumerable:!(u=f(n,o))||u.enumerable});return t};var p=(t,n,e)=>(e=t!=null?_(j(t)):{},c(n||!t||!t.__esModule?a(e,\"default\",{value:t,enumerable:!0}):e,t)),C=t=>c(a({},\"__esModule\",{value:!0}),t);var s=g((X,m)=>{m.exports=_jsx_runtime});var D={};l(D,{default:()=>i});var r=p(s());function x(t){return(0,r.jsx)(r.Fragment,{})}function i(t={}){let{wrapper:n}=t.components||{};return n?(0,r.jsx)(n,{...t,children:(0,r.jsx)(x,{...t})}):x(t)}return C(D);})();\n;return Component;",
    "slug": "tulu3-405b",
    "readingTime": "0 min read"
  },
  {
    "content": "# Yi-Large",
    "name": "Yi-Large",
    "release_date": new Date("2024-05-13T00:00:00.000Z"),
    "open_weights": "Proprietary",
    "context_window_tokens": 32000,
    "creator": {
      "name": "01.AI",
      "url": "https://www.01.ai/",
      "logo_url": "/logos/01ai.jpg"
    },
    "intelligence_metrics": {
      "intelligence_index": 27.89,
      "math_index": 31.43,
      "coding_index": 14.77,
      "benchmarks": {
        "mmlu_pro": 0.586,
        "gpqa": 0.363,
        "hle": 0.032,
        "scicode": 0.188,
        "aime": 0.067,
        "math_500": 0.562,
        "livecodebench": 0.108,
        "humaneval": 0.744
      }
    },
    "pricing": {
      "per_1m_tokens": {
        "input": 3,
        "output": 3,
        "blended_3_to_1": 3
      }
    },
    "speed_and_latency": {
      "output_speed_tokens_per_sec": 66.95,
      "time_to_first_token_ms": 0.34,
      "end_to_end_response_time_500_tokens": {
        "total_seconds": 7.81,
        "input_time_seconds": 0.34,
        "reasoning_time_seconds": 0,
        "answer_time_seconds": 7.47
      }
    },
    "_meta": {
      "filePath": "yi-large.mdx",
      "fileName": "yi-large.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "yi-large"
    },
    "title": "Yi-Large",
    "body": "var Component=(()=>{var h=Object.create;var r=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),M=(n,t)=>{for(var e in t)r(n,e,{get:t[e],enumerable:!0})},s=(n,t,e,i)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let o of d(t))!j.call(n,o)&&o!==e&&r(n,o,{get:()=>t[o],enumerable:!(i=_(t,o))||i.enumerable});return n};var p=(n,t,e)=>(e=n!=null?h(f(n)):{},s(t||!n||!n.__esModule?r(e,\"default\",{value:n,enumerable:!0}):e,n)),C=n=>s(r({},\"__esModule\",{value:!0}),n);var a=l((X,u)=>{u.exports=_jsx_runtime});var D={};M(D,{default:()=>x});var c=p(a());function m(n){let t={h1:\"h1\",...n.components};return(0,c.jsx)(t.h1,{children:\"Yi-Large\"})}function x(n={}){let{wrapper:t}=n.components||{};return t?(0,c.jsx)(t,{...n,children:(0,c.jsx)(m,{...n})}):m(n)}return C(D);})();\n;return Component;",
    "slug": "yi-large",
    "readingTime": "1 min read"
  }
]